var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { orderBy } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { ImpersonateUserConstants } from '../constants/impersonate-user.constants';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { GroupByPipe } from '../../common/pipes/group-by.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from "../../shared/constants/common.constants";
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../shared/services/member-display-price-config.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { Utils } from '../../shared/Utils/utils';
import { Constants, DelivaryOptionType, IsoCodeThree, MemberType, ProductSource, UserTitleType } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PromotionOrderType, PurchaseFlow, RowStatus } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { MemberTypeId } from '../constants/member-type-id.enum';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PhoneCodesConstants } from '../constants/phone-codes.constant';
import { PortalDisplayPage } from '../constants/portal-display-page.enum';
import { ResponseStatus } from '../constants/response-status-constants';
import { StatusConstants } from '../constants/status.constants';
import { Translations } from '../constants/translations.constants';
import { EcheckPhoneNumberValidation } from '../directive/echeck-phone-validation';
import { ValidateDateOfBirth } from '../directive/validate-dob';
import { BonusPaymentOption } from '../enums/bonus-payment-option.enum';
import { CartTypes } from '../enums/cart-type.enum';
import { DisplaySectionId, DocumentLibraryMemberId, Portal } from '../enums/document-library-member-id.enum';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../enums/echeck-portal-types.enum';
import { ImageType } from '../enums/image-type.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import { AddressType, OrderSourceType, OrderStatus, PaymentMethodTypes, PaymentType, PriceType, ProductWeightMetric, PurchaseFlows, PurchaseFlowType, ShippingOrderType, ShippingType, Source } from '../enums/order-source-type';
import { OrderSourceTypes, OrderSourceValue } from '../enums/order-source.enum';
import { SecType } from '../enums/payment-ach-sectypes.enum';
import { PaymentCardTypes } from '../enums/payment-card-types.enum';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { SelectEnum } from '../enums/selection.enum';
import { ShippingMemberTitle } from '../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../enums/shipping-member-type.enum';
import { SponsorSearchOption } from '../enums/sponsor-search-option.enum';
import { SponsorWizardSearchType } from '../enums/sponsor-wizard-type.enum';
import { ValueType } from '../enums/value-type.enum';
import { TaxType } from '../interface/tax-type.interface';
import { DeleteModal } from '../models/delete-modal';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { AchService } from '../services/ach.service';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { ConfigurationService } from '../services/configuration.service';
import { AddressService } from '../services/address.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';
import { EcheckService } from '../services/echeck.service';
import { EnrollmentMessageService } from '../services/enrollment-message.service';
import { EnrollService } from '../services/enrollment.service';
import { OrderService } from '../services/order.service';
import { PayvisionService } from '../services/payvision.service';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
import { PersonalMessageService } from '../services/personal-schema-form.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { SponsorConfigService } from '../services/sponsor-config.service';
import { SponsorService } from '../services/sponsor.service';
import { CustomValidator } from './customvalidation.component';
import { PaymentModeConstants } from '../constants/payment-mode.constants';
import { PriceTier, StorerPiceTier } from '../constants/pricetier.constants';
import { MemberPreferencesType } from '../enums/member-preferences.enum';
import { AccountRestrictionStatus } from "../../common/enums/account-restricted.enum";
import { RetailFreeShippingConstants } from '../constants/retail-free-shipping.constants';
import { MemberMetaDataEnum } from '../enums/member-meta-data.enum';
import { EnrollmentCommonService } from '../../shared/services/enrollment-common.service';
import { PaymentProcessorAlias } from '../enums/payment-processor-alias.enum';
import { BonusConstants } from '../constants/bonus-status.constants';
import { BankWireTransferConstants } from '../constants/bank-wire-transfer-configuration.constants';
import { transactional } from '../enums/sponsor-transactional-source-type.enum';
var OrderPromotionComponent = /** @class */ (function () {
    function OrderPromotionComponent(_orderService, _echeckService, _sanitizer, _formbuilder, _http, _commonService, _translatePipe, _translateKey, _documentService, _currencyPipe, _cacheService, _customerService, messageService, _payvisionService, _titleCase, _maskPipe, _enrollmentMessageService, _enrollmentCommonService, _addressService, _enrollService, _shippingAddressInfoConfigService, _sponsorConfigService, _checkoutConfigService, _memberDisplayPriceConfigService, chRef, _appConfigService, _translateService, _achService, _sponsorService, _configurationService, _personalInfoConfigService, _personalMessageService, _groupByPipe, document) {
        var _this = this;
        this._orderService = _orderService;
        this._echeckService = _echeckService;
        this._sanitizer = _sanitizer;
        this._formbuilder = _formbuilder;
        this._http = _http;
        this._commonService = _commonService;
        this._translatePipe = _translatePipe;
        this._translateKey = _translateKey;
        this._documentService = _documentService;
        this._currencyPipe = _currencyPipe;
        this._cacheService = _cacheService;
        this._customerService = _customerService;
        this.messageService = messageService;
        this._payvisionService = _payvisionService;
        this._titleCase = _titleCase;
        this._maskPipe = _maskPipe;
        this._enrollmentMessageService = _enrollmentMessageService;
        this._enrollmentCommonService = _enrollmentCommonService;
        this._addressService = _addressService;
        this._enrollService = _enrollService;
        this._shippingAddressInfoConfigService = _shippingAddressInfoConfigService;
        this._sponsorConfigService = _sponsorConfigService;
        this._checkoutConfigService = _checkoutConfigService;
        this._memberDisplayPriceConfigService = _memberDisplayPriceConfigService;
        this.chRef = chRef;
        this._appConfigService = _appConfigService;
        this._translateService = _translateService;
        this._achService = _achService;
        this._sponsorService = _sponsorService;
        this._configurationService = _configurationService;
        this._personalInfoConfigService = _personalInfoConfigService;
        this._personalMessageService = _personalMessageService;
        this._groupByPipe = _groupByPipe;
        this.document = document;
        this.momentConstructor = moment.default || moment;
        this.showAddressFormValidations = false;
        this.memberTypeEnum = MemberTypeEnum;
        this.orderType = OrderType;
        this.deliveryPreference = DeliveryPreference;
        this.displayStatementForWavePayment = false;
        this.items = [];
        this.countries = [];
        this.memberCountries = [];
        this.states = [];
        this.memberSearchSubmitted = false;
        this.memberAddressDetails = [];
        this.memberShippingDetails = [];
        this.address = {};
        this.showPudoPickupPersonAddressForm = false;
        this.pudoShippingAddressInfo = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.dropshipPudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.shipMethodValidation = '';
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.defaultCurrency = CommonConstant.Default_Currency;
        this.subTotal = 0.0;
        this.retailSubTotal = 0.0;
        this.totalCommissionableVolume = 0;
        this.selectedIsoCountryCode = '';
        this.selectedCountryCodeTwo = '';
        this.shippingMethods = [];
        this.savedCards = [];
        this.isPaymentWithSavedCard = false;
        this.isSubmitted = false;
        this.products = [];
        this.taxableAmount = 0;
        this.shippingCost = 0;
        this.orginalShippingCost = 0;
        this.shipMethod = {};
        this.showSelectedShipMethod = false;
        this.languageCode = 'en-US';
        this.languageShortCode = 'en';
        this.languageCulture = 'en-US';
        this.payByLinkLanguageShortCode = 'en';
        this.disableDelivery = false;
        this.pollCount = 0;
        this.maxPollCount = 15;
        this.importFeeValue = 0;
        this.importFeeEnabled = false;
        this.selectEnum = SelectEnum;
        this.datePickerStartDateAt = new Date();
        this.optInCheck = true;
        this.isFPCOptInEnabled = false;
        this.isMemberFboUpgraded = false;
        this.upgradeFboLimitExceeded = false;
        this.isFBOValidationPending = false;
        this.isWhosaleCheckNotCalculated = false;
        this.single_debit_show = false;
        this.direct_debit_show = false;
        this.acceptPaymentDocuments = null;
        this.disableBonusAgreement = true;
        this.accountNumber = "";
        this.isPayByLinkValid = true;
        this.storeDefaultLanguageShortCode = 'en';
        this.storeResponeLanguages = [];
        this.memberPreference = [];
        this.overrideMinimumLimitIsEnabled = false;
        this.verifyPudoAddress = true;
        this.translateOptions = {
            translateText: "checkout.Forever Living Products {{countryName}} GmbH",
            translateParams: { countryName: '' }
        };
        this.cityList = [];
        this.operatingCountry = [];
        this.isOverrideMinimumLimit = false;
        this.imageTypes = ImageType;
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.orderSession = {};
        this.deliveryPreferenceType = this.deliveryPreference.DELIVERY;
        this.FBORegularOrderPermissions = [
            Permission.REGULAR_ORDER_CREATE,
            Permission.REGULAR_ORDER_MANAGE
        ];
        this.FBOPOSOrderPermissions = [
            Permission.POS_ORDER_CREATE,
            Permission.POS_ORDER_MANAGE
        ];
        this.serviceOrderTypePermissions = [
            Permission.REPLACEMENT_ORDER_CREATE,
            Permission.REPLACEMENT_ORDER_MANAGE
        ];
        this.overrideMinimumOrderLimitPermissions = [
            Permission.OVERRIDE_MINIMUM_LIMIT
        ];
        this.backDateOrderPermission = false;
        this.enableBackDateOrder = false;
        this.isNewCard = false;
        this.shoppingCartCount = 0;
        this.depositFeeProductCount = 0;
        this.itemCount = 0;
        this.existingItemCount = 0;
        this.guestPersonalInfoFormValid = true;
        this.sponsorPollCount = 0;
        this.sponsorMaxPollCount = environment.longPollCount;
        this.isGuestMemberType = false;
        this.personalInfoFormValid = true;
        this.memberCommunicationPreferences = {
            email: true,
            phone: false
        };
        this.mailAlreadyExist = false;
        this.showMailingAddress = true;
        this.showShippingAddress = true;
        this.isMemberHasAccessToOrder = true;
        this.restrictedDays = 0;
        this.cartLimitExceed = false;
        this.cartLimitNotReach = false;
        this.paymentTypeEnum = PaymentType;
        this.bankDetailsList = [];
        this.memberShippingDiscountOfferEligible = false;
        this.taxType = TaxType;
        this.addressSearchResult = [];
        this.enableServiceOrder = environment.enableServiceOrder;
        this.bonusPaymentOption = BonusPaymentOption;
        this.bonusInfoFormValidated = true;
        this.productPromotions = [];
        this.promotionModels = [];
        this.clickTimeout = [];
        this.promotionIds = [];
        this.beneluxCountry = false;
        this.bonusInfoAgreements = [];
        this.hasFboBonusInfoViewPermission = false;
        this.hasFboBonusInfoDeletePermission = false;
        this.hasFboBonusInfoManagePermission = false;
        this.hasPersistedMemberId = false;
        this.dropShipDeliveryOptionDisabled = false;
        this.hidePudoPickupLocationsButton = true;
        this.accountRestriction = false;
        this.accountRestrictionPermission = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
        this.accountViewPermission = false;
        this.showDropShipPersonAddressForm = false;
        this.dropShipOptionAvailable = false;
        this.dropLoactionSelected = false;
        this.depsoitFeeProductsInfo = [];
        this.productAssociationInfo = [];
        this.purchaseFlowType = null;
        this.enableRetailFreeShipping = environment && environment.enableRetailFreeShipping ? true : false;
        this.retailFreeShippingEnabledCountries = environment.retailFreeShippingEnabledCountries;
        this.RFSConstants = RetailFreeShippingConstants;
        this.orderLevelDiscount = 0;
        this.isBWPEnabledProduct = false;
        this.isBWPEnabled = false;
        this.isSelectedBonusPaymentOptionType = false;
        this.bonusInfoAvailable = false;
        this.retailDeliveryFee = 0;
        this.sponsorSearchTimeDelay = environment.sponsorSearchTimeDelay;
        this.enableNexioPaymentForPickUpCenter = environment.enableNexioPaymentForPickUpCenter;
        this.isShippingTaxAddedToShippingCost = false;
        this.customBankTransferDetailsConfiguration = BankWireTransferConstants.BankTransferCountries;
        this.customWireTransferDetailsConfiguration = BankWireTransferConstants.WireTransferCountries;
        this.showCustomerBankTransferDetails = false;
        this.showCustomerWireTransferDetails = false;
        this.isPickUpOptionExist = false;
        this.isDropShipOptionExist = false;
        this.showDistance = false;
        /**
         * Checks Whether Order Can be BackDated or Not
         * @param timeZoneOffset
         */
        this.isBackDateOrderAvailable = function (timeZoneOffset, operatingCountry) {
            _this.enableBackDateOrder = false;
            var processingMonth;
            var processingYear;
            var date = new Date();
            if (date.getMonth() === 0) {
                processingMonth = 12;
                processingYear = date.getFullYear() - 1;
            }
            else {
                processingMonth = date.getMonth();
                processingYear = date.getFullYear();
            }
            if (operatingCountry && processingMonth && processingYear) {
                _this._customerService.getBonusRunStatusDetails(operatingCountry, processingMonth, processingYear).subscribe(function (response) {
                    if (response && response.success && response.bonusStatus && response.validations.length === 0) {
                        if ((response.bonusStatus.toLowerCase() === BonusConstants.Open.toLowerCase())
                            || (response.bonusStatus.toLowerCase() === BonusConstants.Restricted.toLowerCase())) {
                            _this._orderService.isBackDateOrderAllowed(timeZoneOffset, _this.countryCode).subscribe(function (response) {
                                if (response && response.success) {
                                    _this.enableBackDateOrder = true;
                                }
                                else {
                                    _this.enableBackDateOrder = false;
                                }
                            }, function (error) {
                                _this.enableBackDateOrder = false;
                            });
                        }
                    }
                }, function (error) {
                    _this.enableBackDateOrder = false;
                });
            }
        };
        // endregion
        // region #Start Products Section
        /**
        * @param  {any} data
        * @returns SafeHtml
        */
        this.autocompleListFormatter = function (data) {
            var html = "<span>" + data.itemNumber + " - " + _this._titleCase.transform(data.displayName ? data.displayName : data.name) + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        /**
         * Auto Complete Product Search
         */
        this.observableSource = function (keyword, fullSearch) {
            var fpc5PercentEnabled = false;
            if ((_this.memberInfo || _this.hasNewGuestOrderPermissions || _this.hasNewRetailOrderPermissions) && _this.storeInfo) {
                if (keyword && keyword.length > 1) {
                    if (keyword.indexOf('#') == 0) {
                        keyword = keyword.replace(/#/, '');
                    }
                    if (_this.appConfig && _this.appConfig.fpc5PercentEnabled) {
                        fpc5PercentEnabled = true;
                    }
                    var wholesaleQualified = _this.memberInfo && _this.memberInfo.wholeSaleQualified ? true : false;
                    if (wholesaleQualified == null) {
                        wholesaleQualified = false;
                    }
                    var optin = _this.memberInfo && _this.memberInfo.optin ? _this.memberInfo.optin : false;
                    /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
                        Level, Opt-In, and Wholesale Qualified Status*/
                    var memberTitleId = _this.memberInfo ? _this._orderService.getMemberTitleId(_this.memberInfo) : MemberLevel.RETAIL;
                    var purchaseFlowType = _this._commonService.getPurchaseFlowType(_this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    if (_this.memberInfo) {
                        memberTitleId = _this._orderService.getDowngradeTitleID(_this.memberInfo.memberTypeId, _this.memberInfo.memberTitleId);
                    }
                    var _itemNumberURL = environment.productsUrl + '/stores/' + _this.storeInfo.id + '/customerservice/products' +
                        '?languageCode=' + _this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId +
                        '&countryCode=' + _this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                        + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&source=' + ProductSource.ADMINISTRATION +
                        '&optin=' + optin + '&taxInclusive=' + _this.storeInfo.taxInclusive;
                    if (fullSearch) {
                        _itemNumberURL += '&searchType=FULL';
                    }
                    return _this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(function (res) {
                        var results = res.json();
                        if (results && results.length > 0) {
                            return results;
                        }
                        else {
                            return [];
                        }
                    });
                }
                else {
                    return Observable.of([]);
                }
            }
            else {
                var notification = void 0;
                if (!_this.memberInfo) {
                    notification = _this._translatePipe.get('order.Member Details are Mandatory');
                }
                if (!_this.storeInfo && !_this.countryCode && !_this.pickupDeliveryOptionAvailable && !_this.shippingDeliveryOptionAvailable) {
                    notification = _this._translatePipe.get('Shipping options not available');
                }
                else if (!_this.storeInfo && !_this.countryCode &&
                    (_this.pickupDeliveryOptionAvailable || _this.shippingDeliveryOptionAvailable)) {
                    notification = _this._translatePipe.get('order.Country Details are Mandatory');
                }
                else if (!_this.storeInfo && _this.showPOSOrderValidation) {
                    notification = _this._translatePipe.get('order.Member not eligible for POS orders');
                }
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        };
        this.setPaymentMethod = function (value) {
            if (value && value != _this.orderFormGroup.controls['paymentSelector'].value) {
                _this.orderFormGroup.controls['paymentSelector'].setValue(value.toString());
            }
            _this.onPaymentMethodChnage();
        };
    }
    OrderPromotionComponent.prototype.ngOnInit = function () {
        this.dropShipDeliveryOptionDisabled = false;
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.getDistributorInfoFromStorage();
        this.subscribePersistedMemberId();
        this.getAllPermissions();
        this.buildForm();
        this.getOperatingCountries();
        this.getStates();
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
        if (this.orderSession && (this.orderSession.orderType === OrderType.NEW_FPC || this.orderSession.orderType === OrderType.NEW_FBO || this.orderSession.orderType === OrderType.SERVICE_ORDER)) {
            this.orderTypeChange(this.orderSession.orderType);
            this.pudoAddress = this.orderSession.pudoaddress ? this.orderSession.pudoaddress : this.pudoAddress;
            return;
        }
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (this.orderSession) {
            this.shoppingBagClicked = this.orderSession && this.orderSession.shoppingBagClicked ? true : false;
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
            this.businessEntityId = this.orderSession.businessEntityId;
            this.taxCalculationStatus = this.orderSession.taxCalculationStatus;
            this.languageCulture = this.orderSession.languageCulture;
            this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
            this.shipMethods = this.orderSession.shipMethods;
            this.storeInfo = this.orderSession.storeInfo;
            if (this.storeInfo && this.memberInfo) {
                this.memberInfo = __assign({}, this.memberInfo, { displayMiddleName: this.storeInfo.displayMiddleName });
            }
            this.appConfig = this.orderSession.appConfig;
            this.orderTaxResponse = this.orderSession.orderTaxResponse;
            this.countryTaxInclusive = this.orderSession.countryTaxInclusive;
        }
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.getCountries();
        this.getZipCodePatterns();
        this.deleteModal = new DeleteModal(this.clearData.bind(this), this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;
        this.selectedPaymentMethod = PaymentMethodTypes.Credit_Card.toString();
        this.orderFromLookup || this.isOrderSessionInfo
            ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
            : (document.getElementById('memberInfo') ? document.getElementById('memberInfo').focus() : null);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid) || this._enrollmentCommonService.getSessionGuid();
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.subscribeSaveAddress();
        this.setPUDOSuggestedAddress();
    };
    OrderPromotionComponent.prototype.clearData = function () {
    };
    OrderPromotionComponent.prototype.getFormControls = function () {
        var items = this.orderFormGroup.get('items');
        return items.controls;
    };
    OrderPromotionComponent.prototype.closeDeleteMessage = function () {
    };
    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.getAllPermissions = function () {
        this.backDateOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.ORDER_BACKDATE + ']'), AccessLevel.Customer_Service);
        this.hasRegularOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBORegularOrderPermissions + ']'), AccessLevel.Customer_Service);
        this.hasPOSOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOPOSOrderPermissions + ']'), AccessLevel.Customer_Service);
        this.hasNewGuestOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_RETAIL_AND_GUEST + ']'), AccessLevel.Customer_Service);
        this.hasNewRetailOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_RETAIL + ']'), AccessLevel.Customer_Service);
        this.hasNewFPCOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_FPC + ']'), AccessLevel.Customer_Service);
        this.hasNewFBOOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_FBO + ']'), AccessLevel.Customer_Service);
        this.createShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.CREATE_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.serviceOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.serviceOrderTypePermissions + ']'), AccessLevel.Customer_Service);
        this.hasMinimumOverrideLimit = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.overrideMinimumOrderLimitPermissions + ']'), AccessLevel.Customer_Service);
    };
    /**
     * @description This method used to prevent click event
     * onClickOfOrderType()
     * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.onClickOfOrderType = function (event, orderType) {
        this.showDropShipPersonAddressForm = false;
        this.displayDropAddress = false;
        this.orderFormGroup.controls['orderType'].setValue(this.orderTypePrevValue);
        if (orderType === this.orderTypePrevValue) {
            return;
        }
        this.orderTypeSelectedValue = orderType;
        if (this.countries.length < 1) {
            this.getCountries();
        }
        if (this.memberInfo || this.mailingAddress || this.shippingAddressInfo || this.address || this.personalInformation
            || this.sponsorInformation || (this.products && this.products.length) || (this.updateCartProduct > 0) || (this.updateMemberDetail != null)) {
            this.orderTypeChangeConfirmation.open();
            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
        }
        else {
            this.orderTypeChange(orderType);
        }
    };
    OrderPromotionComponent.prototype.onSelectOrderTypeChange = function (orderType) {
        this.removeSessionGuid();
        this.orderTypeChange(orderType);
    };
    OrderPromotionComponent.prototype.removeSessionGuid = function () {
        this._cacheService.removeSessionValue(CacheKey.SessionGuid);
    };
    //#region #Start Order Type Section
    OrderPromotionComponent.prototype.orderTypeChange = function (orderType) {
        this.mailAlreadyExist = false;
        this.orderTypePrevValue = orderType;
        this.updateCartProduct = 0;
        this.updateMemberDetail = null;
        this.orderFormGroup.controls['orderType'].setValue(orderType);
        if (!this.isOrderSessionInfo) {
            this.address = null;
            this.showSelectedShipMethod = false;
            this.showShippingData = false;
            this.paymentComponentSettings.savedCards = [];
        }
        if (!this.isOrderSessionInfo) {
            this.hasPersistedMemberId && orderType === OrderType.REGULAR ? this.clearAllTheForms(true, true) : this.clearAllTheForms(true, true, true);
        }
        else {
            this.clearAllTheForms();
        }
        if (orderType === OrderType.REGULAR) {
            this.onselectRegularOrder();
        }
        else if (orderType === OrderType.POS) {
            this.onSelectPOSOrder();
        }
        else if (orderType === OrderType.NEW_GUEST_RETAIL || orderType === OrderType.NEW_RETAIL) {
            this.onSelectNewGuestOrRetailFlow();
        }
        else if (orderType === OrderType.NEW_FPC) {
            this.isNewFPC = true;
        }
        else if (orderType === OrderType.SERVICE_ORDER) {
            this.isNewFPC = false;
        }
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    };
    /**
     * @description This method used to settings for POS order flow
     * onselectRegularOrder()
     * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.onSelectPOSOrder = function () {
        this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required,
            Utils.noEmptyString, Utils.searchByMemberValidation]);
        this.disableDelivery = true;
        this.orderFormGroup.patchValue({
            deliveryPreference: DeliveryPreference.PICKUP
        });
        if (this.orderFromLookup) {
            this.getDistributorInfo();
        }
        this.updateTotalsAndShipMethod();
    };
    /**
     * @description This method used to settings for regular order flow
     * onselectRegularOrder()
     * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.onselectRegularOrder = function () {
        if (this.createOrderInfo && this.createOrderInfo.distributorId) {
            this.fboid = this.createOrderInfo.distributorId;
        }
        if (this.hasPersistedMemberId && (!this.fboid || !this.orderFormGroup.controls['memberInfo'].value)) {
            this.fboid = this.persistedMemberId;
        }
        this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required,
            Utils.noEmptyString, Utils.searchByMemberValidation]);
        this.disableDelivery = false;
        this.orderFormGroup.patchValue({
            deliveryPreference: DeliveryPreference.DELIVERY
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFromLookup || this.hasPersistedMemberId) {
            this.getDistributorInfo();
        }
    };
    /**
     * @description This method used to reset settings for new guest order flow
     * onSelectNewGuestOrRetailFlow()
     * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.onSelectNewGuestOrRetailFlow = function () {
        var _this = this;
        this.fboid = '';
        this.selectedIsoCountryCode = 'usa';
        this.memberInfo = null;
        this.orderFormGroup.controls['memberInfo'].clearValidators();
        this.orderFormGroup.controls['memberInfo'].updateValueAndValidity();
        this.memberTypeId = this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL ? MemberTypeEnum.GUEST
            : MemberTypeEnum.RETAIL;
        this.stores.forEach(function (allowedCountry) {
            var countryObj = _this.countries.filter(function (country) {
                return allowedCountry.isocodeThree === country.isocodeThree;
            })[0];
            if (countryObj) {
                allowedCountry.id = countryObj.countryId;
                allowedCountry.name = countryObj.name;
                allowedCountry.isoCodeThree = countryObj.isocodeThree;
                allowedCountry.isoCodeTwo = countryObj.isocodeTwo;
            }
        });
        var countryId = this.stores.find(function (store) { return store.isocodeThree.toUpperCase() === IsoCodeThree.USA; }).id || this.stores[0].id;
        this.isOrderSessionInfo ? this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId)
            : this.orderFormGroup.controls['countryId'].setValue(countryId);
        this.selectedCountry();
        this.disableDelivery = false;
        this.pickupDeliveryOptionAvailable = false;
        this.paymentComponentSettings.billingAddress = null;
        if (!(this.orderFormGroup.value.deliveryPreference) || !(this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY)) {
            this.orderFormGroup.patchValue({
                deliveryPreference: DeliveryPreference.DELIVERY
            });
        }
        this.showDropShipPersonAddressForm = false;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    };
    //#region #Start Build Forms Section
    /**
     * build Form
     */
    OrderPromotionComponent.prototype.buildForm = function () {
        var isServiceOrder = this._cacheService.get(CacheKey.IsServiceOrder);
        var orderType = isServiceOrder ? OrderType.SERVICE_ORDER : (this.hasPOSOrderPermissions && !this.hasRegularOrderPermissions ? OrderType.POS : OrderType.REGULAR);
        this._cacheService.remove(CacheKey.IsServiceOrder);
        this.orderFormGroup = this._formbuilder.group({
            orderType: [orderType],
            memberInfo: ['', [Validators.required, Utils.noEmptyString, Utils.searchByMemberValidation]],
            items: this._formbuilder.array(this.items),
            countryId: ['', [Validators.required]],
            deliveryPreference: [DeliveryPreference.DELIVERY],
            shippingAddressId: [''],
            shipMethodId: ['', [Validators.required]],
            originalShippingCost: [0, [Validators.required]],
            shippingCost: [''],
            shippingCostPercentage: [''],
            itemSearch: [''],
            itemLevelSearch: [''],
            shippingCostSelector: [this.selectEnum.firstOption.toString()],
            paymentInstrumentId: ['', [Validators.required]],
            paymentSelector: [],
            backDateOrder: [false],
            saveForFutureUse: [false],
            language: [],
            isContactSponsor: [null],
            isShippingDiscountApplied: [false],
            originalShippingTax: [0, [Validators.required]]
        });
        this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
        this.buildPudoLocationSearchForm();
        this.buildPayByLinkForm();
    };
    /**
     * set Distributor Info from FboId
     */
    OrderPromotionComponent.prototype.getDistributorInfo = function () {
        this.orderFormGroup.controls['memberInfo'].setValue(this.fboid);
        this.searchMember();
    };
    OrderPromotionComponent.prototype.getDistributorInfoFromStorage = function () {
        this.createOrderInfo = this._cacheService.get('CreateOrderInfo');
        this._cacheService.remove('CreateOrderInfo');
        if (this.createOrderInfo) {
            this.fboid = this.createOrderInfo.distributorId;
            this.shoppingBagClicked = this.createOrderInfo.shoppingBagClicked;
            this.orderFromLookup = true;
        }
    };
    OrderPromotionComponent.prototype.onKeydown = function (event) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    };
    /**
     * create item number
     * @returns FormGroup
     */
    OrderPromotionComponent.prototype.createItemNumberGroup = function () {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
            disableDelete: [false],
            disableDecrement: [true],
            isDepositFeeProduct: [false],
            depositFeeEnabled: [false]
        });
    };
    /**
    * ShippingAddressForm Intialize
    */
    OrderPromotionComponent.prototype.createNewShippingAddress = function () {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    };
    OrderPromotionComponent.prototype.getZipCodePatterns = function () {
        var _this = this;
        this._commonService.getZipCodePatterns().subscribe(function (response) {
            _this.zipCodePattern = response;
            var pattern = _this.zipCodePattern.filter(function (x) { return x.isoCodeThree
                === _this.selectedIsoCountryCode.toUpperCase(); })[0];
            _this.zipPattern = pattern ? pattern.zipPattern : null;
        });
        return Validators.pattern(new RegExp(this.zipPattern));
    };
    OrderPromotionComponent.prototype.buildPudoLocationSearchForm = function (zipCode, city, addressLine1, country, externalId) {
        if (zipCode === void 0) { zipCode = ''; }
        if (city === void 0) { city = ''; }
        if (addressLine1 === void 0) { addressLine1 = ''; }
        if (country === void 0) { country = ''; }
        if (externalId === void 0) { externalId = ''; }
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        });
        var countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    };
    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    OrderPromotionComponent.prototype.getCountries = function () {
        var _this = this;
        var allCountries = JSON.parse(localStorage.getItem("appadmin.Countries"));
        if (allCountries) {
            this.countries = allCountries;
            this._cacheService.set(CacheKey.COUNTRIES, this.countries);
            this.stores = this.countries.filter(function (country) { return country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled && _this.isLiveCountry(country.isocodeThree); });
            if (!this.orderFromLookup && this.fboid) {
                this.getDistributorInfo();
            }
            else if (this.isOrderSessionInfo) {
                this.orderFormGroup.controls['memberInfo'].setValue(this.orderSession.memberInfo);
                this.searchMember();
                this.orderFormGroup.controls['orderType'].setValue(this.orderSession.orderType);
                if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                }
                this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
            }
            this.orderFromLookup = this.isOrderSessionInfo ? this.orderSession.orderFromLookup : this.orderFromLookup;
        }
    };
    /**
     * @description this method will check Give country Titan Live Country Or Not
     * @author Akhil
     * @date 2021-09-16
     * @param {string} countryCode
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.isLiveCountry = function (countryCode) {
        if (environment.liveCountries) {
            var liveCountries = environment.liveCountries.toLowerCase().split(',');
            if (liveCountries && liveCountries.length) {
                return liveCountries.some(function (liveCountryCode) { return liveCountryCode.toLowerCase() === countryCode.toLowerCase(); });
            }
        }
        return true;
    };
    /**
     * get States
     */
    OrderPromotionComponent.prototype.getStates = function () {
        var _this = this;
        this._customerService.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
            }
        });
    };
    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    OrderPromotionComponent.prototype.getCountryDetailsByCountryIdOrCode = function (countryId, countryCode) {
        var countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter(function (x) { return x.countryId === countryId; })[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter(function (x) { return x.isocodeThree === countryCode; })[0];
        }
        return countryObj;
    };
    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    OrderPromotionComponent.prototype.getStateDetailsByStateIdOrCode = function (stateId, stateCode, countryCode) {
        var stateObj = {};
        if (stateId) {
            stateObj = this.states.filter(function (x) { return x.id === stateId; })[0];
        }
        if (stateCode && countryCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode && x.countryCode === countryCode; })[0];
        }
        else if (stateCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode; })[0];
        }
        return stateObj;
    };
    /**
     * event for OrderBackDate CheckBox change
     */
    OrderPromotionComponent.prototype.backDateOrderChange = function (event) {
        this.orderFormGroup.controls['backDateOrder'].setValue(event.target.checked);
    };
    /**
     * On Country Select
     */
    OrderPromotionComponent.prototype.selectedCountry = function () {
        this.isWhosaleCheckNotCalculated = false;
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        this.isMemberHasAccessToOrder = true;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
        var selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.countryId : null;
        if (selectedCountryID) {
            var countryObj = this.countries.filter(function (x) { return x.countryId === +selectedCountryID; })[0];
            if (this.memberInfo) {
                this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
            }
            this.orderFormGroup.controls['countryId'].disable();
            if (countryObj) {
                this.translateOptions.translateParams.countryName = countryObj.name;
                this.selectedIsoCountryCode = countryObj.isocodeThree;
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                if (this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState) {
                    this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                    this._cacheService.set(CacheKey.COUNTRY_ID, countryObj.countryId);
                    this.getCitiesByStates();
                }
                else {
                    this._cacheService.remove(CacheKey.COUNTRY_CODE);
                    this._cacheService.remove(CacheKey.COUNTRY_ID);
                }
                if (this.memberInfo && this.memberInfo.memberId && this.checkoutConfig && this.checkoutConfig.displayBusinessEntity) {
                    this.loadMemberBasicInfo(this.memberInfo.memberId);
                }
                this.getPaymentRules();
                this.countryCode = countryObj.isocodeThree;
                this.getZipCodePatterns();
                this.showShippingData = true;
                this.documentsRequest = null;
                this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                this.selectedCountryCodeTwo = countryObj.isocodeTwo;
                this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
                this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
                this.storeInfo = null;
                this.sponsorConfig = this._sponsorConfigService.getSettings(countryObj.isocodeThree);
                this.storeId = 0;
                this._enrollmentMessageService.setStoreInfo(this.storeInfo);
                this.getStoreInfo(countryObj.isocodeThree);
                this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
                if (this.checkoutConfig && this.checkoutConfig.loadParticipatingCountries) {
                    this.getParticipatingCountries(countryObj.isocodeThree);
                }
                if (!this.orderFormGroup.value.orderType || (this.orderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                    && this.orderFormGroup.value.orderType !== this.orderType.NEW_RETAIL)
                    && this.checkoutConfig && !this.checkoutConfig.loadParticipatingCountries) {
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, selectedCountryID);
                }
                this.clearAllTheForms(false);
                this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
                this.address = null;
            }
        }
    };
    /**
    * @description This method used to load guest data from order session
    * loadGuestOrderSession()
    * @returns void
    */
    OrderPromotionComponent.prototype.loadGuestOrderSession = function () {
        if (this.isOrderSessionInfo) {
            this.personalInformation = this.orderSession.personalInformation;
            this.mailAlreadyExist = this.orderSession.mailAlreadyExist;
            this.mailingAddress = this.orderSession.mailingAddress;
            this.memberCommunicationPreferences = this.orderSession.memberCommunicationPreferences;
            this.liveFormAddress = this.orderSession.liveFormAddress;
            this.orderFormGroup.controls['isContactSponsor'].setValue(this.memberCommunicationPreferences.email);
            this.retuningGuestUser = this.orderSession.retuningGuestUser;
            this.agreementDocuments = this.orderSession.documents;
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language);
            this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
            this.guestToRetailShippingId = this.orderSession.verifiedShippingAddressId;
            this.isOverrideMinimumLimit = this.orderSession.isOverrideMinimumLimit;
            this.fetchTermsConditionDocument(this.agreementDocuments);
            if (this.orderSession.shippingAddressId || this.orderSession.shippingAddressInfo || this.orderSession.pudoaddress) {
                this.address = this.orderSession.shippingAddressInfo;
                if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                    this.address = this.orderSession.pudoaddress;
                    this.pudoAddress = this.address;
                }
                this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                if (this.address) {
                    this.shippingAddressInfo = this.address;
                    this.shippingAddressInfo.phoneNumber = this.address.phoneNumber ? this.address.phoneNumber : this.address.phone ? this.address.phone : null;
                    this.shippingAddressInfo.email = this.address.email ? this.address.email : null;
                    this.savedAddressId = this.address.id;
                    this.constructSchemaFormUrl(this.countryCode);
                    this.address.isSavedAddress = this.orderSession.isSavedAddress;
                    this.showShippingData = true;
                    this.address.id = this.orderSession.shippingAddressId;
                    this.pudoAddress = this.address;
                }
            }
            else {
                this.constructSchemaFormUrl(this.countryCode);
            }
            // check for shpping address when order info is in cache
            this.loadproductsFromSession();
        }
    };
    /**
    * @description This method used to get cart items by member
    * getCartItemsByMemberAndCartTypeId()
    * @returns void
    */
    OrderPromotionComponent.prototype.getCartItemsByMemberAndCartTypeId = function (storeInfo, isSaveBagClicked) {
        var _this = this;
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId, CartTypes.OrderCart, storeInfo)
            .subscribe(function (cartInfo) {
            if (cartInfo && cartInfo.sessionGuid) {
                _this.memberCart = cartInfo;
                if (!_this.isOrderSessionInfo && cartInfo.items && cartInfo.items.length && !isSaveBagClicked) {
                    var productIds = cartInfo.items.map(function (x) { return x.productId; });
                    _this.getProductsByIds(productIds, storeInfo);
                }
            }
            else {
                _this.memberCart = null;
            }
            if (isSaveBagClicked) {
                _this.saveBag(true);
            }
        }, function (error) {
            new Error(error);
        });
    };
    OrderPromotionComponent.prototype.getCitiesByStates = function () {
        var _this = this;
        var countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe(function (response) {
            console.log(response);
            if (response) {
                _this.cityList = response;
                _this._cacheService.set(CacheKey.Cities, response);
            }
        });
    };
    OrderPromotionComponent.prototype.buildReferenceNumberForm = function () {
        this.paymentReferenceNumber = this._formbuilder.group({
            referenceNumber: ['']
        });
    };
    OrderPromotionComponent.prototype.paymentReferenceNumberFormValidations = function () {
        var paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        this.paymentReferenceNumber.get('referenceNumber').clearValidators();
        if (paymentSelectorValue === this.paymentTypeEnum.Orange_Money) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required, Validators.maxLength(18), Validators.pattern('[O,o]{1}[M,m]{1}[ ]{0,1}[0-9]{1,}')]);
        }
        else if (paymentSelectorValue === this.paymentTypeEnum.Money_order) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required, Validators.maxLength(18), Validators.pattern('[W,w]{1}[A,a]{1}[V,v]{1}[E,e]{1}[ ]{0,1}[0-9]{1,}')]);
        }
    };
    /**
     * get products by Ids
     */
    OrderPromotionComponent.prototype.getProductsByIds = function (productsIds, storeInfo) {
        var _this = this;
        var fpc5PercentEnabled = false;
        var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
        // HARD_DOWNGRADE CHECK FOR FPC USERS
        memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id, memberTitleId, this.purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, storeInfo.taxInclusive).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.loadproducts(response);
            }
        });
    };
    /**
     *load procducts from session
     */
    OrderPromotionComponent.prototype.loadproducts = function (products) {
        var _this = this;
        products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
                    var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (_this.isOrderSessionInfo) {
                        var productInfo = _this.orderSession.products.find(function (item) { return product.id === item.productId; });
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                    else if (_this.orderFormGroup && !_this.isOrderSessionInfo) {
                        var productInfo = null;
                        if (_this.memberCart && _this.memberCart.items.length > 0) {
                            productInfo = _this.memberCart.items.find(function (item) { return product.id === item.productId; });
                        }
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                    if (items.controls[index].controls['quantity'].value === 1) {
                        items.controls[index].controls['disableDecrement'].setValue(true);
                    }
                    else {
                        items.controls[index].controls['disableDecrement'].setValue(false);
                    }
                    if (depositFeeEnabled) {
                        _this.getDepositFeeProduct(product, true);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo) {
            this.getShipMethods();
        }
    };
    /**
    * Save and update bag items
    * @returns void
    */
    OrderPromotionComponent.prototype.saveBag = function (isFallBack) {
        var _this = this;
        var items = this.getOrderLineItems(this.countryTaxInclusive);
        if (items && items.length) {
            if (this.memberCart && this.memberCart.sessionGuid) {
                this.prepareCartUpdateRequest();
                this._customerService.updateCart(this.memberCart, CartTypes.OrderCart, this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(function (response) {
                    if (response) {
                        _this.createSuccessNotification(response);
                        _this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                    }
                });
            }
            else {
                if (!isFallBack) {
                    this.getCartItemsByMemberAndCartTypeId(this.storeInfo, true);
                }
                else {
                    var cart = this.prepareCartCreateRequest();
                    this._customerService.saveCart(cart, CartTypes.OrderCart, this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(function (response) {
                        if (response) {
                            _this.createSuccessNotification(response);
                            _this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                        }
                    });
                }
            }
            this.getShoppingCartCount(this.storeInfo);
        }
    };
    /**
    * show success notification after updating cart items
    * createSuccessNotification()
    * @returns void
    */
    OrderPromotionComponent.prototype.createSuccessNotification = function (response) {
        this.memberCart = response;
        var notification = this._translatePipe.get('order.Member cart items updated successfully')['value'];
        this._commonService.createNotification('', notification, NotificationType.SUCCESS);
    };
    /**
    * prepare create request
    * prepareCartCreateRequest()
    * @returns void
    */
    OrderPromotionComponent.prototype.prepareCartCreateRequest = function () {
        var items = this.getOrderLineItems(this.countryTaxInclusive);
        var memberCart = { items: [] };
        items.forEach(function (item) {
            var productItem = {
                productId: item.productId,
                quantity: item.quantity
            };
            memberCart.items.push(productItem);
        });
        return memberCart;
    };
    /**
    * prepare update request
    * prepareCartUpdateRequest()
    * @returns void
    */
    OrderPromotionComponent.prototype.prepareCartUpdateRequest = function () {
        var _this = this;
        var items = this.getOrderLineItems(this.countryTaxInclusive);
        items.forEach(function (item) {
            var product = _this.memberCart.items.find(function (itm) { return itm.productId === item.productId; });
            if (product) {
                _this.memberCart.items.forEach(function (cart) {
                    if (cart.productId === product.productId) {
                        cart.quantity = _this.shoppingBagClicked ? item.quantity : cart.quantity + Number(item.quantity);
                    }
                });
            }
            else {
                var productItem = {
                    productId: item.productId,
                    quantity: item.quantity
                };
                _this.memberCart.items.push(productItem);
            }
        });
        if (this.shoppingBagClicked) {
            this.memberCart.items = this.memberCart.items.filter(function (item) {
                return items.map(function (product) { return product.productId; }).indexOf(item.productId) > -1;
            });
        }
    };
    /**
    * removing not available cart items based on logged in user
    * @param  {Cart} orderCart
    * @param  {CartItem[]} unAvailableCartItems
    */
    OrderPromotionComponent.prototype.deleteCart = function (sessionGuid) {
        if (sessionGuid) {
            this.shoppingCartCount = 0;
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid, this.storeInfo.id).subscribe(function (response) {
            });
        }
    };
    /**
     * @description constructing the schema form url
     * @date 2018-11-27
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.constructSchemaFormUrl = function (countryCode) {
        var _this = this;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.mailingSchemaUrl = countryCode.toLowerCase() + '-mailing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(function () {
            _this.address = _this.address;
            _this.mailingAddress = _this.mailingAddress;
            _this.displayMailingAddressForm = true;
            _this.showAddressForm = true;
            _this.shippingDeliveryOptionAvailable = true;
        }, 500);
        this.orderFormGroup.controls['countryId'].enable();
    };
    /**
     * @description get member cart items list
     * @date 2019-10-15
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getMemberCartItems = function (storeInfo) {
        if (this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId(storeInfo);
        }
        else {
            this.memberCart = null;
        }
    };
    // get existing shopping cart item count
    OrderPromotionComponent.prototype.getShoppingCartCount = function (storeInfo) {
        var _this = this;
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId, CartTypes.OrderCart, storeInfo)
            .subscribe(function (cartInfo) {
            _this.existingItemCount = 0;
            if (cartInfo && cartInfo.sessionGuid) {
                _this.memberCartInfo = cartInfo;
                _this.existingItemCount = 0;
                var cartItems = cartInfo.items;
                for (var index = 0; cartItems.length > 0 && cartItems.length > index; index++) {
                    _this.existingItemCount += cartItems[index].quantity;
                }
                _this.shoppingCartCount = _this.existingItemCount;
            }
            else {
                _this.existingItemCount = 0;
            }
        }, function (error) {
            new Error(error);
        });
    };
    /**
     * Get Store Info
     * @param countryCode
     */
    OrderPromotionComponent.prototype.getStoreInfo = function (countryCode, member) {
        var _this = this;
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(function (response) {
                if (response) {
                    var storeInfo_1 = response;
                    _this.storeDetails = response;
                    if (!_this.shoppingBagClicked && _this.orderFormGroup.value.orderType === _this.orderType.REGULAR && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST) {
                        _this.getShoppingCartCount(storeInfo_1);
                    }
                    _this.distributorMaxCC = storeInfo_1.distributorMaxCC;
                    if (_this.memberInfo && _this.memberInfo.fboId && _this.memberInfo.memberAllowedCountries
                        && _this.memberInfo.memberAllowedCountries.length > 0
                        && (+_this.memberInfo.memberTypeId === MemberTypeEnum.FPC || +_this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                        if (countryCode) {
                            _this.getWholsesaleQualifiedDetails(_this.memberInfo.fboId, countryCode, storeInfo_1);
                        }
                        else {
                            _this.getMemberDiscountPercentages(storeInfo_1);
                        }
                    }
                    else {
                        _this.getMemberDiscountPercentages(storeInfo_1);
                    }
                    _this.storeId = response.id;
                    _this.countryCode = countryCode;
                    _this.getZipCodePatterns();
                    _this.countryTaxInclusive = storeInfo_1.taxInclusive;
                    _this.shippingAddressInfoConfig = _this._shippingAddressInfoConfigService.getSettings(countryCode);
                    _this.appConfig = _this._appConfigService.getSettings(countryCode, _this.memberInfo); //storeConfiguration
                    if (_this.appConfig.enablePaymentReferenceNumber) {
                        _this.buildReferenceNumberForm();
                    }
                    _this.getOrderRules(storeInfo_1);
                    if (_this.appConfig.isWireTransferLabelWithoutGmbh) {
                        _this.translateOptions.translateText = "checkout.Forever Living Products {{countryName}}";
                    }
                    if (response.languages && response.languages.length > 0) {
                        _this.storeDefaultLanguage = response.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
                        _this.languageCulture = _this.storeDefaultLanguage;
                        _this.payByLinkLanguageShortCode = response.languages.find(function (languageCulture) { return languageCulture.default; }).languageCode;
                    }
                    else {
                        _this.storeDefaultLanguage = _this.languageCode;
                        _this.languageCulture = _this.languageCulture;
                        _this.payByLinkLanguageShortCode = _this.payByLinkLanguageShortCode;
                    }
                    if (_this.customBankTransferDetailsConfiguration && _this.customWireTransferDetailsConfiguration && _this.selectedIsoCountryCode) {
                        var language = _this._cacheService.get(CacheKey.Language);
                        _this.showCustomerBankTransferDetails = _this.customBankTransferDetailsConfiguration.includes(_this.selectedIsoCountryCode) && language.toLowerCase() == _this.storeDefaultLanguage.toLowerCase();
                        _this.showCustomerWireTransferDetails = _this.customWireTransferDetailsConfiguration.includes(_this.selectedIsoCountryCode) && language.toLowerCase() == _this.storeDefaultLanguage.toLowerCase();
                    }
                    if (_this.orderFormGroup.value.orderType === _this.orderType.REGULAR) {
                        var memberType = void 0;
                        if (+_this.memberInfo.memberTypeId === MemberTypeEnum.GUEST) {
                            memberType = MemberType.GUEST;
                            _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                            if (_this.isOrderSessionInfo) {
                                _this.sponsorInformation = _this.orderSession.sponsorInformation;
                            }
                        }
                        else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
                            memberType = MemberType.Distributor;
                            _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                        }
                        else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
                            memberType = MemberType.PREFERRED_CUSTOMER;
                            _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                        }
                        else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                            memberType = MemberType.RETAIL;
                            _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                        }
                        _this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                        var getDeliveryOptionsRequest = {
                            memberTypeId: _this.memberInfo ? _this.memberInfo.memberTypeId : MemberTypeEnum.RETAIL,
                            memberType: memberType.toUpperCase(),
                            source: Source.CSP,
                            countryCode: countryCode,
                            purchaseFlow: _this.deliveryOptionPurchaseFlow,
                            storeId: _this.storeId
                        };
                        _this.shippingDeliveryOptionAvailable = false;
                        _this.pickupDeliveryOptionAvailable = false;
                        _this._orderService.getDeliveryOptions(countryCode, getDeliveryOptionsRequest).subscribe(function (res) {
                            if (res) {
                                _this.dropShipDeliveryOptionDisabled = false;
                                res.forEach(function (option) {
                                    if (option.optionValue === DelivaryOptionType.Delivery) {
                                        _this.shippingDeliveryOptionAvailable = true;
                                    }
                                    if (option.optionValue === DelivaryOptionType.Pickup) {
                                        _this.pickupDeliveryOptionAvailable = true;
                                    }
                                    if (option.optionValue === DelivaryOptionType.Dropship) {
                                        if (option.optionDisabled) {
                                            _this.dropShipDeliveryOptionDisabled = true;
                                        }
                                        else if (_this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                            _this.dropShipOptionAvailable = true;
                                        }
                                        else {
                                            _this.pickupDeliveryOptionAvailable = true;
                                        }
                                    }
                                });
                                // Dynamic Delivery option changes .
                                var isDropShip = res.find(function (x) { return x.optionValue == DelivaryOptionType.Dropship; });
                                var isPickUp = res.find(function (x) { return x.optionValue == DelivaryOptionType.Pickup; });
                                if (environment.scandinavianCountries && countryCode) {
                                    var scandinavianCountries = environment.scandinavianCountries;
                                    _this.scandinavianCountry = scandinavianCountries.split(",").find(function (country) { return country === countryCode; });
                                }
                                // For Scandian country checking for Pickup
                                if (_this.scandinavianCountry && isPickUp) {
                                    _this.isPickUpOptionExist = true;
                                }
                                // For Non-Scandian country checking for DropShip
                                if (!_this.scandinavianCountry && isDropShip && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && !_this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                    _this.isDropShipOptionExist = true;
                                }
                                // For Non-Scandian country checking for PickUp
                                if (!_this.scandinavianCountry && isPickUp && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                    _this.isPickUpOptionExist = true;
                                }
                                if (!_this.scandinavianCountry && isPickUp && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                    _this.isPickUpOptionExist = true;
                                }
                                if (!_this.pickupDeliveryOptionAvailable &&
                                    (+_this.orderFormGroup.controls['orderType'].value === OrderType.POS)) {
                                    _this.showPOSOrderValidation = true;
                                }
                                else {
                                    _this.showPOSOrderValidation = false;
                                    _this.storeInfo = storeInfo_1;
                                    if (_this.memberInfo) {
                                        _this.memberInfo = __assign({}, _this.memberInfo, { displayMiddleName: _this.storeInfo.displayMiddleName });
                                    }
                                    _this.storeInfo.ccNumberDecimals = 3;
                                    _this.overrideMinimumLimitIsEnabled = _this.getOverrideMinimumLimit();
                                    _this.storeInfo.ccNumberFormat = 'CR';
                                    _this.storeInfo.ccSymbol = 'CC';
                                    if (_this.memberInfo) {
                                        _this.loadSavedCardsForMemberId(_this.memberInfo.memberId, countryCode);
                                        _this.achToken = '';
                                        //this.getSavedEchecks();
                                    }
                                    if (_this.orderSession && _this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                                        _this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                                        _this.constructSchemaFormUrl(_this.countryCode);
                                        _this.validationsOnDeliveryPreference();
                                    }
                                    _this.paymentComponentSettings.languageCode = _this.languageCode;
                                    _this.paymentComponentSettings.storeId = _this.storeInfo.id;
                                    _this.paymentComponentSettings.currencyCode = _this.storeInfo.currencyCode;
                                    _this.paymentComponentSettings.numberDecimals = _this.storeInfo.numberDecimals;
                                    _this.countryCode = countryCode;
                                    _this.getZipCodePatterns();
                                    _this.memberId = _this.memberInfo ? _this.memberInfo.memberId : null;
                                    if (_this.isOrderSessionInfo) {
                                        _this.updateTotalsAndShipMethod();
                                    }
                                }
                                if (_this.orderSession && _this.orderSession.deliveryPreference === _this.deliveryPreference.DROPSHIP
                                    && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                    _this.getPudoLocations();
                                }
                            }
                        });
                        _this.getStorePromotions();
                        _this.getPaymentMethodsByStore();
                    }
                    else {
                        _this.guestFlowSettings(response);
                        _this.getStorePromotions();
                    }
                    _this.phoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.countryCode);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Store Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    };
    /**
     * @description
     * @date 2020-04-20
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getMemberRankLevelHistory = function (orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow) {
        var _this = this;
        if (!isFboUpgradeFlow) {
            return;
        }
        this.isFBOValidationPending = true;
        if (this.memberInfo && this.memberInfo.memberId && storeInfo && storeInfo.countryId) {
            this._commonService.getMemberRankLevelHistory(this.memberInfo.memberId, storeInfo.countryId)
                .subscribe(function (response) {
                if (response) {
                    _this.memberLevelHistory = response;
                    var memberLevelInfo = _this.memberLevelHistory
                        .find(function (memberLevel) { return memberLevel.memberTitleId === MemberTitleExtEnums.PreferredCustomer; });
                    var isMemberFboUpgraded = memberLevelInfo ? true : false;
                    var enrollmentWindowDate = void 0;
                    enrollmentWindowDate = _this.memberInfo.enrolmentDate ? new Date(_this.memberInfo.enrolmentDate)
                        : new Date(_this.memberInfo.createdDate);
                    enrollmentWindowDate.setHours(0, 0, 0, 0);
                    enrollmentWindowDate.setDate(enrollmentWindowDate.getDate() + _this.restrictedDays);
                    var currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    _this.isFBOValidationPending = false;
                    if (isMemberFboUpgraded && (enrollmentWindowDate.getTime() > currentDate.getTime())) {
                        orderRulesRequest.optinFbo = true;
                        _this.isMemberFboUpgraded = true;
                        _this.getBusinessOrderRules(orderRulesRequest, userInfo, true);
                    }
                    else {
                        _this.isMemberFboUpgraded = false;
                        _this.getBusinessOrderRules(orderRulesRequest);
                        _this.getMemberOrderRules(userInfo, false);
                    }
                }
                else {
                    _this.memberLevelHistory = [];
                    _this.isMemberFboUpgraded = false;
                    _this.isFBOValidationPending = false;
                    _this.getMemberOrderRules(userInfo, false);
                    _this.getBusinessOrderRules(orderRulesRequest);
                }
            });
        }
    };
    /**
     * @description
     * @date 2019-10-23
     * @private
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.loadMemberShoppingCart = function (storeInfo) {
        // get Member cart items when shopping bag clicked
        if (this.orderFormGroup.value.orderType === this.orderType.REGULAR && !this.memberCartSessionGuid
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId(storeInfo);
        }
        else if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.memberCart = null;
        }
        else {
            this.memberCart = null;
        }
    };
    /**
     * @description
     * @date 2019-10-21
     * @private
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getMemberDiscountPercentages = function (storeInfo) {
        var _this = this;
        this.loadMemberShoppingCart(storeInfo);
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var wholeSaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false;
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        var memberTitleID = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberInfo) {
            this.memberInfo.transactionalWholesaleQualified = wholeSaleQualified;
            this.memberInfo.transactionalOptin = optin;
        }
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, storeInfo.id).
            subscribe(function (response) {
            _this.memberDiscountPercentage = response;
        });
    };
    /**
    * @description This method used to load default settings for guest flow
    * guestFlowSettings()
    * @returns void
    */
    OrderPromotionComponent.prototype.guestFlowSettings = function (response) {
        var _this = this;
        this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.getPaymentMethodsByStore(this.memberTypeId);
        this.loadPreferences(response);
        this.loadDeliveryOptions(response);
        if (this.isOrderSessionInfo) {
            this.rebindSponsorData = this.orderSession.rebindSponsorData;
            this.sponsorInformation = this.orderSession.sponsorInformation;
        }
        this.storeId = response.id;
        this.storeInfo = response;
        // if(this.storeInfo){
        // this.memberInfo = {...this.memberInfo, displayMiddleName : this.storeInfo.displayMiddleName};
        // }
        this._enrollmentMessageService.setStoreInfo(this.storeInfo);
        this.storeLanguages = response.languages;
        this.paymentComponentSettings.languageCode = this.languageCode;
        this.overrideMinimumLimitIsEnabled = this.getOverrideMinimumLimit();
        this.paymentComponentSettings.storeId = this.storeInfo.id;
        this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
        this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
        this.storeInfo.ccNumberDecimals = 3;
        this.storeInfo.ccNumberFormat = 'CR';
        this.storeInfo.ccSymbol = 'CC';
        if (this.appConfig && this.storeInfo && this.appConfig.enablePrivacyPreference) {
            this.storeInfo.enablePrivacyPreference = this.appConfig.enablePrivacyPreference;
            this.isPrivacyPreference = this.storeInfo.enablePrivacyPreference;
        }
        else {
            this.isPrivacyPreference = false;
        }
        if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
            this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
            this.constructSchemaFormUrl(this.countryCode);
            this.validationsOnDeliveryPreference();
        }
        if (response.languages && response.languages.length > 0) {
            this.storeDefaultLanguage = this.storeLanguages.find(function (languageCulture) {
                return languageCulture.default;
            }).cultureName || this.storeLanguages[0].cultureName;
        }
        this.isOrderSessionInfo ?
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language)
            : this.orderFormGroup.controls['language'].setValue(this.storeLanguages.find(function (item) { return item.default; }).cultureName);
        this.storeLangCultureId = this.orderFormGroup.get('language').value ? this.storeLanguages.
            find(function (language) { return language.cultureName.toLowerCase() == _this.orderFormGroup.get('language').value.toLowerCase(); }).cultureId : "";
        this.orderFormGroup.controls['countryId'].enable();
        if (this.isOrderSessionInfo) {
            this.updateTotalsAndShipMethod();
        }
        if (this.orderSession && this.orderSession.deliveryPreference === this.deliveryPreference.DROPSHIP
            && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.getPudoLocations();
        }
        this.constructSchemaFormUrl(this.countryCode);
        if (this.isOrderSessionInfo) {
            this.loadGuestOrderSession();
        }
        else {
            this.documentsRequest = null;
            this.prepareAgreementDocumentsRequest();
        }
    };
    /**
    * @description This method used to load delivery options based on member type
    * loadDeliveryOptions()
    * @returns void
    */
    OrderPromotionComponent.prototype.loadDeliveryOptions = function (response) {
        var _this = this;
        var memberType = '';
        var purchaseFlow = '';
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            memberType = MemberType.RETAIL;
            this.deliveryOptionPurchaseFlow = PurchaseFlows.ENROLLMENT;
        }
        else if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            memberType = UserTitleType.GUEST;
            this.deliveryOptionPurchaseFlow = PurchaseFlows.ENROLLMENT;
        }
        var getDeliveryOptionsRequest = {
            memberTypeId: this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL ? MemberTypeEnum.RETAIL
                : MemberTypeEnum.GUEST,
            memberType: memberType.toUpperCase(),
            source: Source.CSP,
            countryCode: this.countryCode,
            purchaseFlow: this.deliveryOptionPurchaseFlow,
            storeId: this.storeId
        };
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this._orderService.getDeliveryOptions(this.countryCode, getDeliveryOptionsRequest).subscribe(function (res) {
            if (res) {
                _this.dropShipDeliveryOptionDisabled = false;
                res.forEach(function (option) {
                    if (option.optionValue === DelivaryOptionType.Delivery) {
                        _this.shippingDeliveryOptionAvailable = true;
                    }
                    if (option.optionValue === DelivaryOptionType.Pickup) {
                        _this.pickupDeliveryOptionAvailable = true;
                    }
                    if (option.optionValue === DelivaryOptionType.Dropship) {
                        if (option.optionDisabled) {
                            if (option.optionDisabled) {
                                _this.dropShipDeliveryOptionDisabled = true;
                            }
                            _this.dropShipDeliveryOptionDisabled = true;
                        }
                        else if (_this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                            _this.dropShipOptionAvailable = true;
                        }
                        else {
                            _this.pickupDeliveryOptionAvailable = true;
                        }
                    }
                    // Dynamic Delivery option changes .
                    var isDropShip = res.find(function (x) { return x.optionValue == DelivaryOptionType.Dropship; });
                    var isPickUp = res.find(function (x) { return x.optionValue == DelivaryOptionType.Pickup; });
                    if (environment.scandinavianCountries && _this.countryCode) {
                        var scandinavianCountries = environment.scandinavianCountries;
                        _this.scandinavianCountry = scandinavianCountries.split(",").find(function (country) { return country === _this.countryCode; });
                    }
                    // For Scandian country checking for Pickup
                    if (_this.scandinavianCountry && isPickUp) {
                        _this.isPickUpOptionExist = true;
                    }
                    // For Non-Scandian country checking for DropShip
                    if (!_this.scandinavianCountry && isDropShip && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && !_this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                        _this.isDropShipOptionExist = true;
                    }
                    // For Non-Scandian country checking for PickUp
                    if (!_this.scandinavianCountry && isPickUp && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                        _this.isPickUpOptionExist = true;
                    }
                    if (!_this.scandinavianCountry && isPickUp && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                        _this.isPickUpOptionExist = true;
                    }
                    _this.loadSavedCardsForMemberId(0, _this.selectedIsoCountryCode);
                });
            }
        });
    };
    //#endregion
    // region #Start Member Function Section
    /**
     * On Member Details Search
     */
    OrderPromotionComponent.prototype.searchMember = function () {
        this.isWhosaleCheckNotCalculated = false;
        this.isMemberHasAccessToOrder = true;
        this.searchReqValues = this.orderFormGroup.getRawValue();
        var distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        var fboId = this.searchReqValues.memberInfo;
        if (new RegExp(distributorIdPattern).test(this.searchReqValues.memberInfo)) {
            fboId = fboId.replace(/-|\s/g, '');
        }
        this.memberSearchSubmitted = true;
        this.memberInfo = null;
        if (this.orderFormGroup.value.memberInfo && this.orderFormGroup.value.memberInfo.length > 0) {
            this.getMemberInfo(fboId);
        }
    };
    /**
     * Get Member Info by EmailID or FBOID
     */
    OrderPromotionComponent.prototype.getMemberInfo = function (memberDetails) {
        var _this = this;
        var type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this.isActive = true;
        this._orderService.getMemberInfo(memberDetails, type).subscribe(function (response) {
            if (response && response.memberId) {
                _this.memberInfo = response;
                _this.isBWPEnabled = _this.memberInfo.memberMetaData.find(function (x) { return x.customKey === MemberMetaDataEnum.BWPENABLED && x.customValue === '1'; });
                _this.dateOfBirthMember = response.dateOfBirth;
                if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
                    _this.getMembergovernmentIdentificationsInfo(response.memberId);
                }
                _this._commonService.getMemberStatus(_this.memberInfo.fboId).subscribe(function (accountInfo) {
                    if (accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !_this.accountViewPermission) {
                        var memberlevel = _this._commonService.getMemberLevel(_this.memberInfo.memberLevelID);
                        var memberDetails_1 = {
                            fboId: _this.memberInfo.fboId,
                            firstName: _this.memberInfo.firstName,
                            lastName: _this.memberInfo.lastName,
                            memberLevel: memberlevel
                        };
                        _this.accountRestriction = true;
                        _this.memberDetails = memberDetails_1;
                        _this.orderFormGroup.controls['countryId'].setValue('');
                    }
                    else {
                        _this.getMemberInformation(memberDetails, response);
                    }
                    _this.bonusInfoAvailable = false;
                });
            }
            else {
                _this.clearAllTheForms(true, true);
                var notification = _this._translatePipe.get('order.Member Details Not Found');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    OrderPromotionComponent.prototype.getMemberInformation = function (memberDetails, response) {
        this.persistedMemberId = memberDetails;
        this.hasPersistedMemberId = true;
        this.storeInfo = null;
        if (response.memberTitleId && response.memberTypeId && (response.memberTitleId === MemberTitleExtEnums.Novus_Customer
            && +response.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
            response.memberTitleId = MemberTitleExtEnums.PreferredCustomer;
        }
        // Add Validation for Member Level
        this.getMemberLevelInfo(response);
    };
    OrderPromotionComponent.prototype.getMemberLevelInfo = function (memberResponse) {
        this.processMemberResponse(memberResponse);
        this.accountMemberInfo = Object.assign({}, memberResponse);
    };
    OrderPromotionComponent.prototype.processMemberResponse = function (response) {
        var _this = this;
        this.memberInfo = response;
        this.memberInfo.enrolmentDate = this.memberInfo.lastUpgradedDate;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        }
        else if (+response.memberTypeId === MemberTypeEnum.FPC || this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        else if (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (+response.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        this.orderTaxResponse = null;
        this.isCalculateTax = false;
        this.memberStatus = response.memberStatus;
        if (this.memberStatus && this.memberStatus.id) {
            this.isActive = (this.memberStatus.id === +MemberStatus.Active);
        }
        else {
            this.isActive = false;
        }
        if (+response.memberTypeId === MemberTypeEnum.GUEST) {
            this.memberInfo.memberLevel = MemberType.GUEST;
            this.isGuestMemberType = true;
        }
        this.memberSearchSubmitted = false;
        this.memberTypeId = this.memberInfo.memberTypeId;
        this._translatePipe.get('order.Member Details Found').subscribe(function (response) {
            if (response) {
                _this._commonService.createNotification('', response, NotificationType.SUCCESS);
            }
        });
        this.clearAllTheForms();
        this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
        if (this.memberInfo.memberAllowedCountries) {
            this.populateCountries(this.memberInfo.memberAllowedCountries);
        }
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.paymentComponentSettings.distributorId = this.memberInfo.fboId;
        this.paymentComponentSettings.uniqueRefId = this.memberInfo.uniqueRefID ? this.memberInfo.uniqueRefID : '';
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        var memberTitleID = this._orderService.getMemberTitleId(this.memberInfo);
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(memberTitleID);
    };
    /**
     * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
     * @param memberID
     * @param countryCode
     */
    OrderPromotionComponent.prototype.getWholsesaleQualifiedDetails = function (fboId, memberHomeCountry, storeInfo) {
        var _this = this;
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe(function (res) {
            try {
                if (res) {
                    _this.isWhosaleCheckNotCalculated = false;
                    if (res && res.error) {
                        _this.wholesaleCheckErrorNotifications();
                    }
                    _this.memberInfo.optin = res.optIn ? res.optIn : false;
                    _this.memberInfo.wholeSaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                    // Member wholesale qualified eligibility check
                    _this.memberInfo.transactionalWholesaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                    _this.memberInfo.transactionalOptin = res.optIn ? res.optIn : false;
                    var balance = void 0;
                    try {
                        balance = Number(res.balance);
                    }
                    catch (_a) {
                        balance = _this.distributorMaxCC;
                    }
                    if (!balance) {
                        balance = _this.distributorMaxCC;
                    }
                    _this.existingCC = balance;
                    _this.getMemberDiscountPercentages(storeInfo);
                }
            }
            catch (error) {
                _this.getMemberDiscountPercentages(storeInfo);
                _this.wholesaleCheckErrorNotifications();
            }
        }, function (error) {
            _this.getMemberDiscountPercentages(storeInfo);
            _this.wholesaleCheckErrorNotifications();
        });
    };
    OrderPromotionComponent.prototype.loadMemberBasicInfo = function (memberId) {
        var _this = this;
        if (memberId && !this.businessEntityId) {
            this._customerService.getMemberBasicInfoById(memberId)
                .subscribe(function (res) {
                if (res && res.businessEntities) {
                    var activeBusinessEntity_1 = res.businessEntities.find(function (entity) { return entity.status === RowStatus.Active && entity.countryCodeId; });
                    var country = _this.countries && _this.countries.find(function (country) { return country && activeBusinessEntity_1 && country.countryId === activeBusinessEntity_1.countryCodeId; });
                    if (activeBusinessEntity_1 && country.isocodeThree.toLowerCase() === _this.countryCode.toLowerCase()) {
                        if (_this._orderService.isValidDate(activeBusinessEntity_1.startDate, activeBusinessEntity_1.endDate)) {
                            _this.businessEntityId = activeBusinessEntity_1.id;
                        }
                        else {
                            _this.businessEntityId = null;
                        }
                    }
                }
            }, function (error) { });
        }
    };
    /**
     * @description to display Error Message If WholesaleCheck  are not calculated
     * @author Akhil
     * @date 2021-02-10
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.wholesaleCheckErrorNotifications = function () {
        this.isWhosaleCheckNotCalculated = true;
        var notification = this._translatePipe.get('order.The order is not receiving the PC Wholesale response from Valence. Please try again later.');
        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
    };
    /**
 * Member Allowed Countries Filter
 * @param memberAllowedCountries
 */
    OrderPromotionComponent.prototype.populateCountries = function (memberAllowedCountries) {
        var _this = this;
        this.memberCountries = [];
        this.dropShipDeliveryOptionDisabled = false;
        var countries = this._cacheService.get(CacheKey.COUNTRIES);
        if (countries && !this.stores) {
            this.countries = countries;
            this.stores = countries.filter(function (country) { return country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled; });
        }
        if (memberAllowedCountries && memberAllowedCountries.length > 0 && this.countries && this.countries.length > 0) {
            memberAllowedCountries.forEach(function (allowedCountry) {
                var countryObj = _this.stores
                    .filter(function (country) { return country.titanPlatformEnabled && allowedCountry.isoCodeThree === country.isocodeThree; })[0];
                if (countryObj) {
                    if (!(_this.memberCountries.findIndex(function (country) { return country.isoCodeThree === countryObj.isocodeThree; }) >= 0)) {
                        _this.memberCountries.push({
                            id: countryObj.countryId, name: countryObj.name, isoCodeThree: countryObj.isocodeThree,
                            isoCodeTwo: countryObj.isocodeTwo, homeCountry: allowedCountry.homeCountry
                        });
                        if (allowedCountry.homeCountry)
                            _this.homeCountry = allowedCountry.isoCodeThree;
                    }
                }
            });
            this.sortTableByColumn('name');
            if (this.isOrderSessionInfo) {
                this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId);
                this.selectedCountry();
            }
            else if (this.createOrderInfo && this.createOrderInfo.countryId && this.shoppingBagClicked) {
                //  When we click shoppingbag icon from memberinfo tab(not for homecountry)
                this.orderFormGroup.controls['countryId'].setValue(this.createOrderInfo.countryId);
                this.selectedCountry();
            }
            else if (this.memberCountries.length > 0) {
                var countryObj = this.memberCountries.find(function (country) { return country.homeCountry === true; });
                if (countryObj) {
                    this.orderFormGroup.controls['countryId'].setValue(countryObj.id);
                    this.translateOptions.translateParams.countryName = countryObj.name;
                }
                else {
                    this.orderFormGroup.controls['countryId'].setValue(this.memberCountries[0].id);
                }
                this.selectedCountry();
            }
        }
    };
    OrderPromotionComponent.prototype.sortTableByColumn = function (property) {
        var direction = 1;
        this.memberCountries.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            }
            else if (a[property] > b[property]) {
                return 1 * direction;
            }
            else {
                return 0;
            }
        });
    };
    /**
    *
    * @param memberId get Member Addresses
    */
    OrderPromotionComponent.prototype.getMemberAddressByMemberId = function (memberId, countryId) {
        var _this = this;
        this.shippingAddressInfo = null;
        this.billingAddressInfo = null;
        this._orderService.getMemberAddressByMemberId(memberId, countryId).subscribe(function (response) {
            _this.memberAddressDetails = [];
            _this.memberShippingDetails = [];
            if (response && response.length > 0) {
                _this.memberAddressDetails = response.filter(function (x) { return x.addressTypeId === AddressType.SHIPPING; });
                _this.memberAddressDetails = _this._commonService.sortMemberAddress(_this.memberAddressDetails);
                _this.addressSearchResult = _this.memberAddressDetails;
                if (!_this.isOrderSessionInfo && (_this.orderSession === null || !_this.orderSession.shippingAddressId)) {
                    _this.address = _this.memberAddressDetails.find(function (x) { return x.defaultAddress === true; });
                    if (_this.address) {
                        _this.address.phone = _this.address.phoneNumber;
                        _this.address.email = _this.address.email ? _this.address.email : null;
                        _this.address.isShowStateCode = _this.checkoutConfig.showStateCode;
                        _this.address.isSavedAddress = true;
                        _this.shippingAddressInfo = _this.address;
                        _this.savedAddressId = _this.address.id;
                        _this.showShippingData = true;
                        _this.constructSchemaFormUrl(_this.countryCode);
                    }
                    else {
                        if (_this.memberAddressDetails && _this.memberAddressDetails.length > 0) {
                            _this.address = _this.memberAddressDetails[0];
                            _this.shippingAddressInfo = _this.address;
                        }
                        _this.constructSchemaFormUrl(_this.countryCode);
                    }
                }
                _this.memberShippingDetails = response.filter(function (x) { return x.addressTypeId === AddressType.SHIPPING; });
                if (_this.isOrderSessionInfo) {
                    _this.storeInfo = _this.orderSession.storeInfo;
                    if (_this.storeInfo && _this.memberInfo) {
                        _this.memberInfo = __assign({}, _this.memberInfo, { displayMiddleName: _this.storeInfo.displayMiddleName });
                    }
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(_this.orderSession.saveForFutureUse);
                    // check for shpping address when order info is in cache
                    if (_this.orderSession.shippingAddressId) {
                        _this.address = _this.memberShippingDetails.find(function (x) { return x.id === _this.orderSession.shippingAddressId; });
                        _this.orderFormGroup.controls['shippingAddressId'].setValue(_this.orderSession.shippingAddressId, { onlySelf: true });
                        if (_this.address) {
                            _this.address.phone = _this.address.phoneNumber;
                            _this.address.email = _this.address.email ? _this.address.email : null;
                            _this.address.isSavedAddress = true;
                            _this.shippingAddressInfo = _this.address;
                            _this.savedAddressId = _this.address.id;
                            _this.constructSchemaFormUrl(_this.countryCode);
                            _this.showShippingData = true;
                        }
                        else {
                            _this.mapShippingAddressDetailsFromSession();
                        }
                    }
                    else {
                        _this.mapShippingAddressDetailsFromSession();
                    }
                    if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP ||
                        _this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        _this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                        _this.constructSchemaFormUrl(_this.countryCode);
                        _this.validationsOnDeliveryPreference();
                    }
                    _this.loadproductsFromSession();
                }
            }
            else {
                if (_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(_this.orderSession.saveForFutureUse);
                    if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP ||
                        _this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        _this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                        _this.constructSchemaFormUrl(_this.countryCode);
                        _this.validationsOnDeliveryPreference();
                    }
                    else {
                        if (_this.orderSession.shippingAddressId) {
                            _this.address = _this.orderSession.shippingAddressInfo;
                            _this.orderFormGroup.controls['shippingAddressId'].setValue(_this.orderSession.shippingAddressId, { onlySelf: true });
                            if (_this.address) {
                                _this.shippingAddressInfo = _this.address;
                                _this.savedAddressId = _this.address.id;
                                _this.constructSchemaFormUrl(_this.countryCode);
                                _this.address.isSavedAddress = _this.orderSession.isSavedAddress;
                                _this.showShippingData = true;
                                _this.verifiedShippingAddressId = _this.orderSession.verifiedShippingAddressId;
                                _this.address.id = _this.orderSession.shippingAddressId;
                            }
                        }
                        else {
                            _this.mapShippingAddressDetailsFromSession();
                        }
                    }
                    // check for shpping address when order info is in cache
                    _this.loadproductsFromSession();
                }
                else {
                    if (_this.countryCode === _this.homeCountry && _this.memberInfo && _this.memberInfo.address && _this.allowMemberInfoAddress()) {
                        _this.address = _this.memberInfo.address;
                        _this.address.email = _this.memberInfo.email ? _this.memberInfo.email : null;
                        _this.address.firstName = _this.memberInfo.firstName;
                        _this.address.middleName = _this.memberInfo.middleName;
                        _this.address.lastName = _this.memberInfo.lastName;
                        _this.address.stateCode = _this.memberInfo.address.stateCode;
                        _this.address.countryCode = _this.countryCode;
                        if (!_this.address.countryId) {
                            _this.address.countryId = _this.memberCountries.find(function (country) { return country.isoCodeThree === _this.countryCode; }).id;
                        }
                        _this.address.isShowStateCode = _this.checkoutConfig.showStateCode;
                        _this.shippingAddressInfo = _this.address;
                        _this.savedAddressId = _this.address.id;
                        _this.showShippingData = true;
                    }
                    else if (_this.memberInfo) {
                        _this.address = {};
                        _this.address.email = _this.memberInfo.email ? _this.memberInfo.email : null;
                        _this.address.firstName = _this.memberInfo.firstName;
                        _this.address.middleName = _this.memberInfo.middleName;
                        _this.address.lastName = _this.memberInfo.lastName;
                        _this.address.countryCode = _this.countryCode;
                        _this.address.countryId = _this.memberCountries.find(function (country) { return country.isoCodeThree === _this.countryCode; }).id;
                        var notification = _this._translatePipe.get('order.Address Information for this member is not available to populate');
                        _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    if (_this.memberInfo.memberContacts && _this.memberInfo.memberContacts.length > 0) {
                        var memberContact = _this.getPhoneNumber(_this.memberInfo.memberContacts);
                        if (memberContact) {
                            _this.address.phoneType = memberContact.contactTypeID;
                            _this.address.phone = memberContact.value ? memberContact.value : null;
                        }
                    }
                    _this.constructSchemaFormUrl(_this.countryCode);
                }
            }
            if (_this.memberAddressDetails && _this.memberAddressDetails.length === 0) {
                _this.orderFormGroup.controls['shippingAddressId'].setValue('');
            }
        }, function (error) {
            _this.orderFormGroup.controls['countryId'].enable();
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Addresses');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            _this.constructSchemaFormUrl(_this.countryCode);
        });
    };
    OrderPromotionComponent.prototype.allowMemberInfoAddress = function () {
        var _this = this;
        if (this.memberInfo.address.countryId && this.memberCountries) {
            var country = this.memberCountries.find(function (country) { return country.isoCodeThree === _this.countryCode; });
            return country.id === this.memberInfo.address.countryId;
        }
        return true;
    };
    OrderPromotionComponent.prototype.getPhoneNumber = function (memberContacts) {
        var phoneType = this.checkoutConfig.removeMobileField ? ContactTypeValue.PHONE : this.checkoutConfig.removePhoneField ? ContactTypeValue.MOBILE : ContactTypeValue.MOBILE;
        var phoneNumber = memberContacts.find(function (item) { return (item.contactTypeID == phoneType) && item.value; });
        return phoneNumber;
    };
    /**
   * Mapping Shipping address from session
   */
    OrderPromotionComponent.prototype.mapShippingAddressDetailsFromSession = function () {
        if (this.orderSession && this.orderSession.shippingAddressInfo) {
            this.address = this.orderSession.shippingAddressInfo;
            this.shippingAddressInfo = this.address;
            this.shippingAddressInfo.email = this.address.email ? this.address.email : null;
            this.shippingAddressInfo.phoneNumber = this.address.phoneNumber ? this.address.phoneNumber : this.address.phone ? this.address.phone : null;
            this.savedAddressId = this.address.id;
            this.verifiedShippingAddressId = this.orderSession.verifiedShippingAddressId;
            this.address.isSavedAddress = this.orderSession.isSavedAddress;
            this.showShippingData = true;
        }
        this.constructSchemaFormUrl(this.countryCode);
    };
    // endregion
    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    OrderPromotionComponent.prototype.deliveryPreferenceOnChange = function () {
        this.deliveryPreferenceType = this.orderFormGroup.value.deliveryPreference;
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.isCalculateTax = false;
        this.shippingAddressChanged = false;
        this.dropShipAddress = null;
        this.dropLoactionSelected = false;
        if (this.countryCode.toUpperCase() == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.DELIVERY && this.enableNexioPaymentForPickUpCenter) {
            this.getDeliveryOptionsPayment();
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        if (this.shippingAddressInfoConfig && ((this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist) && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        }
        else {
            this.showPudoPickupPersonAddressForm = false;
            this.displayPudoAddress = false;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
            this.showPudoPickupPersonAddressForm = true;
        }
        else {
            this.showDropShipPersonAddressForm = false;
            this.displayDropAddress = false;
        }
        this.getShipMethods();
        this.constructSchemaFormUrl(this.countryCode);
        this.validationsOnDeliveryPreference();
        this.clearPudoLocationSearchData();
        //this.updateTotalsAndShipMethod();
    };
    /**
     * update validations on delivery preference
     */
    OrderPromotionComponent.prototype.validationsOnDeliveryPreference = function () {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = null;
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].disable();
            this.getShipMethods(true);
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.selectedpickup = undefined;
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
                this.mailingAddress = null;
                this.liveFormAddress = null;
            }
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
            this.updateTotalsAndShipMethod();
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.pudoShippingMethod = this.orderSession && this.orderSession.pudoShippingMethod ? this.orderSession.pudoShippingMethod : this.pudoShippingMethod;
            if (this.orderSession && this.orderSession.buildPudoLocationSearchForm) {
                this.pudoLocationSearchForm.controls['zipCode'].setValue(this.orderSession.buildPudoLocationSearchForm.zipCode);
                this.pudoLocationSearchForm.controls['city'].setValue(this.orderSession.buildPudoLocationSearchForm.city);
                this.pudoLocationSearchForm.controls['externalId'].setValue(this.orderSession.buildPudoLocationSearchForm.externalId);
                this.pudoLocationSearchForm.controls['zipCode'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['city'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['externalId'].updateValueAndValidity();
                if (this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    this.showPudoPickupPersonAddressForm = true;
                    this.displayPudoAddress = true;
                }
                else if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    this.showDropShipPersonAddressForm = true;
                    this.displayDropAddress = true;
                }
                this.pudoAddress = this.orderSession.pudoaddress ? this.orderSession.pudoaddress : this.pudoAddress;
                this.pudoShippingAddressInfo = this.orderSession.pudoShippingAddressInfo ? this.orderSession.pudoShippingAddressInfo : this.pudoAddress;
            }
            this.selectedPudoCollectionPoint = this.orderSession && this.orderSession.selectedPudoCollectionPoint ? this.orderSession.selectedPudoCollectionPoint : this.selectedPudoCollectionPoint;
            this.shippingAddressSelectionChange();
            this.updateTotalsAndShipMethod();
        }
    };
    /**
     * map the billing address fields
     */
    OrderPromotionComponent.prototype.mapBillingAddress = function () {
        var _this = this;
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && (this.shippingAddressInfo && this.shippingAddressInfo.countryId)
            || (this.memberInfo && this.memberInfo.address && this.memberInfo.address.countryId) || (this.mailingAddress)) {
            var country = void 0;
            var address_1 = (this.memberInfo && this.memberInfo.address) || this.mailingAddress || this.shippingAddressInfo;
            this.paymentComponentSettings.billingAddress = address_1;
            if (address_1 && (address_1.stateCode === PaymentConstants.PuertoRico
                || address_1.stateCode === PaymentConstants.MarshallIslands
                || address_1.stateCode === PaymentConstants.VirginIslands)) {
                if (address_1.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(function (x) { return x.isocodeThree.toLowerCase()
                        === address_1.stateCode.toLowerCase(); })[0];
                }
                else {
                    country = this.countries.filter(function (x) { return x.isocodeTwo.toLowerCase()
                        === address_1.stateCode.toLowerCase(); })[0];
                }
            }
            else {
                country = this.countries.filter(function (x) { return x.countryId === address_1.countryId; })[0];
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = address_1.postalCode;
        }
        else if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.paymentComponentSettings.billingAddress = this.pudoAddress;
            var country = this.countries.filter(function (x) { return x.countryId === _this.pudoAddress.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.pudoAddress.postalCode;
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.pudoShippingAddressInfo) {
                var pudoShippingAddressInfo_1 = this.pudoShippingAddressInfo;
                this.paymentComponentSettings.billingAddress = pudoShippingAddressInfo_1;
                var country_1 = this.countries.filter(function (x) { return x.countryId === pudoShippingAddressInfo_1.countryId; })[0];
                this.paymentComponentSettings.billingAddress.countryCodeTwo = country_1 ? country_1.isocodeTwo : '';
                this.paymentComponentSettings.billingAddress.zipCode = pudoShippingAddressInfo_1.postalCode;
            }
        }
    };
    /**
     * On Shipping Address Selected
     */
    OrderPromotionComponent.prototype.selectedShippingAddress = function (address) {
        this.addressSearchResult = this.memberAddressDetails;
        var addressDetailId = address.id;
        address.isSavedAddress = true;
        if (addressDetailId && this.memberShippingDetails) {
            var shippingAddress = this.memberShippingDetails.filter(function (x) { return x.id === addressDetailId; });
            if (shippingAddress && shippingAddress[0]) {
                this.shippingAddressInfo = shippingAddress[0].shippingAddress;
            }
        }
        this.savedAddressId = address.id;
        address.isShowStateCode = this.checkoutConfig.showStateCode;
        this.shippingAddressInfo = address;
        this.address = address;
        this.address.phone = this.address.phoneNumber;
        this.address.email = this.address.email ? this.address.email : null;
        this.showSavedAddress = false;
        this.updateTotalsAndShipMethod();
    };
    OrderPromotionComponent.prototype.prepareNewAddress = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(+address.countryId, null);
            var stateObj = this.getStateDetailsByStateIdOrCode(+address.stateId, null);
            var addressObj = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                phone: address.phone,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: stateObj.stateCode || '',
                stateId: address.stateId,
                postalCode: address.postalCode,
                country: countryObj.isocodeThree || '',
                countryCodeThree: countryObj.isocodeThree || '',
                countryId: address.countryId,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
            };
            return addressObj;
        }
    };
    /**
    * This method used to map communication preference
    */
    OrderPromotionComponent.prototype.checkContactSponsor = function () {
        var memberCommunicationPreferences = {
            email: this.orderFormGroup.value.isContactSponsor,
            phone: false
        };
        this.memberCommunicationPreferences = memberCommunicationPreferences;
    };
    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    OrderPromotionComponent.prototype.mapVerifiedAddressToFormFields = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, address.state, address.country);
            var mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3 ? address.addressLine3 : '',
                addressLine4: address.addressLine4 ? address.addressLine4 : '',
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj ? stateObj.id : null,
                stateCode: stateObj ? stateObj.stateCode : null,
                countryCode: countryObj ? (countryObj.countryCode || countryObj.isocodeThree) : null,
                countryId: countryObj ? countryObj.countryId : null,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                latitude: address.latitude,
                longitude: address.longitude,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null,
                isShowStateCode: this.checkoutConfig.showStateCode
            };
            return mapAddressToFields;
        }
    };
    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    OrderPromotionComponent.prototype.useNewShippingAddress = function (addressInfo) {
        if (addressInfo) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(addressInfo.countryId, null);
            var stateObj = this.getStateDetailsByStateIdOrCode(addressInfo.stateId, null);
            this.shippingAddressInfo = {
                shipToName: addressInfo.name,
                firstName: addressInfo.firstName,
                middleName: addressInfo.middleName,
                lastName: addressInfo.lastName,
                addressLine1: addressInfo.addressLine1,
                addressLine2: addressInfo.addressLine2,
                addressLine3: addressInfo.addressLine3,
                addressLine4: addressInfo.addressLine4,
                city: addressInfo.city,
                stateId: stateObj.id,
                stateName: stateObj.stateName || '',
                state: stateObj.stateCode || '',
                stateCode: stateObj.stateCode || '',
                countryId: countryObj.countryId,
                countryName: countryObj.name || '',
                country: countryObj.isocodeThree || '',
                countryCode: countryObj.isocodeThree || '',
                postalCode: addressInfo.postalCode || addressInfo.zip,
                zip: addressInfo.postalCode || addressInfo.zip,
                phone: addressInfo.phone,
                addressVerified: addressInfo.addressVerified,
                latitude: addressInfo.latitude,
                longitude: addressInfo.longitude,
                phoneType: addressInfo.phoneType,
                isShowStateCode: addressInfo.isShowStateCode,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: addressInfo.disableAddressBlock,
                deliveryInstruction: addressInfo.deliveryInstruction,
                email: addressInfo.email ? addressInfo.email : null
            };
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.pudoShippingAddressInfo = this.shippingAddressInfo;
                this.showPudoPickupPersonAddressForm = false;
            }
            else {
                this.shippingAddressInfo = this.shippingAddressInfo;
            }
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        }
        else {
            this.showAddressFormValidations = true;
        }
    };
    /**
     * save address method
     */
    OrderPromotionComponent.prototype.saveAddress = function (addressDetails) {
        var _this = this;
        var saveAddressRequest = {
            id: null,
            memberId: this.memberInfo ? this.memberInfo.memberId : (this.guestToRetailMember ? this.guestToRetailMember.memberId : null),
            addressLine1: addressDetails.addressLine1,
            addressLine2: addressDetails.addressLine2,
            addressLine3: addressDetails.addressLine3 ? addressDetails.addressLine3 : '',
            addressLine4: addressDetails.addressLine4 ? addressDetails.addressLine4 : '',
            shipToName: addressDetails.name,
            city: addressDetails.city,
            stateId: addressDetails.stateId,
            countryId: addressDetails.countryId,
            postalCode: addressDetails.postalCode || addressDetails.zip,
            contactTypeID: 1,
            defaultAddress: false,
            addressVerified: addressDetails.addressVerified,
            latitude: addressDetails.latitude,
            longitude: addressDetails.longitude,
            addressTypeId: 40,
            loggedInUserId: this.memberInfo ? this.memberInfo.userId : (this.guestToRetailMember ? this.guestToRetailMember.userId : null),
            responseCodes: addressDetails.responseCodes ? addressDetails.responseCodes : null,
            phone: addressDetails.phone,
            phoneNumber: addressDetails.phone,
            firstName: addressDetails.firstName,
            middleName: addressDetails.middleName,
            lastName: addressDetails.lastName,
            phoneType: addressDetails.phoneType,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            disableAddressBlock: addressDetails.disableAddressBlock,
            deliveryInstruction: addressDetails.deliveryInstruction,
            email: addressDetails.email ? addressDetails.email : null
        };
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(function (response) {
            if (response && response.addressDetail) {
                if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled && _this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.DROPSHIP) {
                    _this.pudoAddress = addressDetails;
                    _this.pudoAddress.id = response.addressDetail.id;
                    _this.savedPudoAddressId = response.addressDetail.id;
                }
                else {
                    _this.verifiedShippingAddressId = response.addressDetail.id;
                    _this.address = addressDetails;
                    _this.address.id = response.addressDetail.id;
                    _this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                    _this.savedAddressId = response.addressDetail.id;
                    if (_this.shipMethodId && _this.shipMethodId.nativeElement) {
                        _this.shipMethodId.nativeElement.focus();
                    }
                }
                if (saveAddressRequest.saveForFutureUse) {
                    _this.messageService.setAddressSaved(true);
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to Save Member Address');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    OrderPromotionComponent.prototype.reEnterShippingAddress = function () {
        this.orderFormGroup.get('shippingAddressForm').reset();
    };
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    OrderPromotionComponent.prototype.selectShippingMethod = function (shippingMethod, isDeliveryOptionChange) {
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        if (shippingMethod) {
            if (this.countryCode == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.PICKUP && this.enableNexioPaymentForPickUpCenter) {
                this.getPickupDetailsForUSA(shippingMethod);
            }
            if (shippingMethod && (shippingMethod.pickUpLocation && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP))) {
                this.taxCalculationStatus = true;
                this.getProcuctRestrictions(shippingMethod, shippingMethod.pickUpLocation, isDeliveryOptionChange);
                if (this.orderFormGroup.value.shipMethodId) {
                    this.selectedpickup = this.orderFormGroup.value.shipMethodId;
                }
            }
            else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo && (this.orderSession.shippingCostValue > 0 || this.orderSession.isShippingDiscountApplied) ?
                    this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.orginalShippingCost = this.memberInfo && this.memberInfo.vatRegistered ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                    this.shippingCostChange();
                }
                else {
                    this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        }
    };
    OrderPromotionComponent.prototype.selectPudoCollectionPoint = function (collectionPoint) {
        this.dropShipAddress = null;
        this.selectedPudoCollectionPoint = collectionPoint;
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.getPudoDropShipPersonAddress(collectionPoint);
            this.dropLoactionSelected = true;
            this.getShipMethods();
        }
        this.dropLoactionSelected = false;
        this.calculateOrderTax();
    };
    OrderPromotionComponent.prototype.getProcuctRestrictions = function (shippingMethod, pickupAddress, isDeliveryOptionChange) {
        var _this = this;
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        var productRestrictionModel = this.prepareProductRestrictionModelRequest(pickupAddress);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe(function (response) {
            if (response && response.success && response.productModels) {
                _this.getRestrictedProducts(response.productModels);
                _this.taxCalculationStatus = true;
            }
            else {
                _this.taxCalculationStatus = true;
                _this.shipMethod = shippingMethod;
                _this.showSelectedShipMethod = true;
                _this.importFeeValue = _this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, _this.storeInfo);
                _this.shippingCost = _this.isOrderSessionInfo ? _this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                _this.originalShippingTax = shippingMethod.shippingTax || 0;
                _this.shippingTax = shippingMethod.shippingTax || 0;
                _this.orginalShippingCost = _this.memberInfo && _this.memberInfo.vatRegistered ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + _this.shippingTax;
                _this.orderFormGroup.patchValue({
                    originalShippingCost: _this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                if (!_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['shippingCostSelector'].setValue(_this.selectEnum.firstOption.toString());
                    _this.shippingCostChange();
                }
                else {
                    _this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    _this.updateTotalsAndShipMethod();
                }
            }
        });
    };
    /**
     * @description this method used for preparing product restriction odel request for pickup
     * @memberof ShippingAddressNewComponent
     */
    OrderPromotionComponent.prototype.prepareProductRestrictionModelRequest = function (pickupAddress) {
        var productRestrictionModel;
        productRestrictionModel = {
            countryCode: pickupAddress.countryCode,
            stateCode: pickupAddress.stateCode
        };
        var productModel = [];
        if (this.products && this.products && this.products.length > 0) {
            this.products.forEach(function (item) {
                productModel.push({ itemNumber: item.itemNumber });
            });
        }
        productRestrictionModel.productModels = productModel;
        return productRestrictionModel;
    };
    OrderPromotionComponent.prototype.getShippingCost = function () {
        this.calculateOrderTax();
    };
    /**
     * Get Ship Methods By Products and Store
     */
    OrderPromotionComponent.prototype.getShipMethods = function (isDeliveryOptionChange) {
        var _this = this;
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        var shippingOptions;
        var items;
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
        this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
        this.orderFormGroup.controls['shippingCost'].setValue('');
        if (!this.pudoShippingAddressInfo) {
            this.getPudoPickupPersonAddress();
        }
        if (this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || this.shippingAddressInfoConfig)) {
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY || this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    if ((_this.shippingAddressInfo || (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled) || _this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) || _this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                        _this.shipMethods = response;
                        _this.shippingMethods = response.shippingMethods;
                        //Process the free shipping based on promotions
                        items = _this.orderFormGroup.get('items') ? _this.orderFormGroup.get('items') : null;
                        _this._commonService.applyPromotionFreeShipping(_this.shippingMethods, _this.promotionModels, items, _this.totalCommissionableVolume);
                        _this.importFeeEnabled = response.importFeeEnabled;
                        if (_this.shippingMethods.length > 0) {
                            _this.shippingMethods.forEach(function (shipMethod) {
                                if (shipMethod.shippingCharge && shipMethod.shippingCharge > shipMethod.shippingTax) {
                                    shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                                }
                                else {
                                    shipMethod.shippingCharge = 0;
                                }
                                shipMethod.shippingCharge = _this._currencyPipe
                                    .getFormatedCurrency(shipMethod.shippingCharge, _this.storeInfo);
                                shipMethod.importFeeEnabled = response.importFeeEnabled;
                            });
                            if (_this.isOrderSessionInfo) {
                                _this.orderFormGroup.patchValue({
                                    shippingCostSelector: _this.orderSession.shippingCostSelector,
                                    originalShippingCost: _this.orderSession.originalShippingCost,
                                    shipMethodId: _this.orderSession.shipMethodId,
                                    shippingCost: _this.orderSession.shippingCost,
                                    shippingCostPercentage: _this.orderSession.shippingCostPercentage,
                                    isShippingDiscountApplied: _this.orderSession.isShippingDiscountApplied
                                });
                                var shipMethodId_1 = _this.orderFormGroup.value.shipMethodId;
                                if (shipMethodId_1 && _this.shippingMethods) {
                                    var shippingObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_1; })[0];
                                    if (shippingObj) {
                                        _this.selectShippingMethod(shippingObj, isDeliveryOptionChange);
                                        _this.getShippingCost();
                                    }
                                }
                                else {
                                    _this.orderFormGroup.patchValue({
                                        shippingCost: 0,
                                        originalShippingCost: 0,
                                        shippingCostPercentage: 0,
                                        isShippingDiscountApplied: false,
                                        originalShippingTax: 0
                                    });
                                    if (_this.shippingMethods[0].shippingMethodId) {
                                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            _this.orderFormGroup.controls['shipMethodId']
                                                .setValue(_this.shippingMethods[0].shippingMethodId);
                                        }
                                        else {
                                            _this.orderFormGroup.controls['shipMethodId'].setValue(_this.shippingMethods[0].shippingMethodId);
                                        }
                                        var isRetailFreeShippingObj = _this.isRetailFreeShipping();
                                        var obj = isRetailFreeShippingObj ? isRetailFreeShippingObj : _this.shippingMethods[0];
                                        _this.selectShippingMethod(obj, isDeliveryOptionChange);
                                    }
                                }
                            }
                            else {
                                _this.orderFormGroup.patchValue({
                                    shippingCost: 0,
                                    originalShippingCost: 0,
                                    shippingCostPercentage: 0,
                                    isShippingDiscountApplied: false,
                                    originalShippingTax: 0
                                });
                                if (_this.shippingMethods[0].shippingMethodId) {
                                    var shippingInfoObj = void 0;
                                    if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                        if (_this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                            shippingInfoObj = response.shippingMethods.find(function (x) { return !x.pudoEnabled; });
                                        }
                                        if (_this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                                            shippingInfoObj = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                                        }
                                        if (_this.selectedpickup && _this.isPickUpOptionExist && _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +_this.selectedpickup; })[0];
                                        }
                                        else {
                                            if (!shippingInfoObj) {
                                                shippingInfoObj = _this.shippingMethods[0];
                                            }
                                        }
                                        _this.pudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                                        if (!_this.pudoShippingMethod) {
                                            _this.getPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                                        }
                                        else {
                                        }
                                    }
                                    else {
                                        if (_this.selectedpickup && _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +_this.selectedpickup; })[0];
                                        }
                                        else {
                                            shippingInfoObj = _this.shippingMethods[0];
                                        }
                                    }
                                    if (shippingInfoObj) {
                                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            _this.orderFormGroup.controls['shipMethodId']
                                                .setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        else {
                                            _this.orderFormGroup.controls['shipMethodId'].setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        var isRetailFreeShippingObj = _this.isRetailFreeShipping();
                                        var obj = isRetailFreeShippingObj ? isRetailFreeShippingObj : shippingInfoObj;
                                        _this.selectShippingMethod(obj, isDeliveryOptionChange);
                                    }
                                }
                            }
                            setTimeout(function () {
                                _this.orderSession = null;
                                _this.isOrderSessionInfo = false;
                            }, 500);
                        }
                    }
                }
                else if (response && response.productModels && response.productModels.length > 0) {
                    _this.getRestrictedProducts(response.productModels);
                }
                else if (response && response.validations.length > 0) {
                    _this.shipMethodValidation = response.validations[0];
                }
                else if (response && !(response.success)) {
                    _this.shippingMethods = [];
                    _this.shippingCost = 0;
                    _this.orderFormGroup.patchValue({
                        shippingCost: 0,
                        originalShippingCost: 0,
                        shippingCostPercentage: 0,
                        isShippingDiscountApplied: false,
                        originalShippingTax: 0
                    });
                }
                if (_this.isDropShipOptionExist && !_this.pudoShippingMethod) {
                    _this.getDropShipPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Ship Methods');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
        else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }
    };
    OrderPromotionComponent.prototype.getPudoPickupPersonAddress = function () {
        var address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                var mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if (!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        }
        else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    };
    OrderPromotionComponent.prototype.preparePudoLocationRequest = function () {
        var _this = this;
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        var request = null;
        if (this.pudoLocationSearchForm) {
            var pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true : this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
                if (this.countries && this.storeInfo && this.storeInfo.homeIsocodeThree && pudoLocationSearchFormData.zipCode) {
                    var country = this.countries.find(function (x) { return x.isocodeThree.toUpperCase() === _this.storeInfo.homeIsocodeThree.toUpperCase(); });
                    request = {
                        countryIsoCode: country.isocodeTwo || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        // as per centiro api we need to send  . (period) if there is no city
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || '',
                        languageCode: "en",
                    };
                }
            }
        }
        return request;
    };
    OrderPromotionComponent.prototype.usePudoAddressAsShipAddress = function () {
        var _this = this;
        if (this.pudoLocationSearchForm) {
            var pudoLocationSearchFormData_1 = this.pudoLocationSearchForm.value;
            var countryObj_1 = this.getCountryDetailsByCountryIdOrCode(null, pudoLocationSearchFormData_1.country);
            this._customerService.getStatesByCountryId(countryObj_1.countryId)
                .subscribe(function (states) {
                if (states && states.length) {
                    var defaultState = states[0];
                    _this.shippingAddressInfo = {
                        addressId: null,
                        addressLine1: pudoLocationSearchFormData_1.addressLine1,
                        addressLine2: pudoLocationSearchFormData_1.addressLine2,
                        addressLine3: pudoLocationSearchFormData_1.addressLine3,
                        addressLine4: pudoLocationSearchFormData_1.addressLine4,
                        addressType: AddressType.MAILING,
                        addressVerified: pudoLocationSearchFormData_1.addressVerified,
                        city: pudoLocationSearchFormData_1.city,
                        country: pudoLocationSearchFormData_1.country,
                        countryCode: countryObj_1.isoCodeThree,
                        countryId: countryObj_1.countryId,
                        email: pudoLocationSearchFormData_1.email ? pudoLocationSearchFormData_1.email : null,
                        firstName: pudoLocationSearchFormData_1.firstName,
                        isSavedAddress: false,
                        isShowStateCode: pudoLocationSearchFormData_1.isShowStateCode,
                        lastName: pudoLocationSearchFormData_1.lastName,
                        latitude: pudoLocationSearchFormData_1.latitude,
                        longitude: pudoLocationSearchFormData_1.longitude,
                        middleName: pudoLocationSearchFormData_1.middleName,
                        phone: pudoLocationSearchFormData_1.phone,
                        phoneNumber: pudoLocationSearchFormData_1.phone,
                        phoneType: pudoLocationSearchFormData_1.phoneType,
                        postalCode: pudoLocationSearchFormData_1.postalCode || pudoLocationSearchFormData_1.zip,
                        state: defaultState.stateCode,
                        stateCode: defaultState.stateCode,
                        stateId: defaultState.id,
                        validAddress: true,
                        zip: pudoLocationSearchFormData_1.postalCode || pudoLocationSearchFormData_1.zip,
                    };
                    if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled && _this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.DROPSHIP) {
                        _this.pudoShippingAddressInfo = _this.shippingAddressInfo;
                    }
                    if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.dropShipLocationsEnabled && _this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.DROPSHIP) {
                        _this.shippingAddressInfo = _this.pudoShippingAddressInfo;
                    }
                }
            });
        }
    };
    OrderPromotionComponent.prototype.getPudoLocationMap = function (geoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if (environment.restrictGoogleMapNavigation) {
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                    ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    };
    OrderPromotionComponent.prototype.loadPUDOLocations = function () {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        }
        else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    };
    OrderPromotionComponent.prototype.getPudoLocations = function () {
        var _this = this;
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            this.usePudoAddressAsShipAddress();
        }
        var pudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(function (res) {
                _this.loadingPudoPickupLocations = false;
                if (res && res.collectionPoints && res.collectionPoints.length) {
                    _this.pudoLocationsNotFound = false;
                    res.collectionPoints.sort(function (x, y) { return x.distance - y.distance; });
                    _this.pudoCollectionPoints = res.collectionPoints;
                    _this.calculateOrderTax();
                    _this.prepareBusinessHours();
                    if (_this.pudoLocationSearchForm && _this.pudoLocationSearchForm.value && _this.pudoLocationSearchForm.value.externalId) {
                        _this.selectedPudoCollectionPoint = _this.pudoCollectionPoints.find(function (x) { return x.externalId == _this.pudoLocationSearchForm.value.externalId; });
                    }
                }
                else {
                    _this.pudoLocationsNotFound = true;
                }
            }, function (error) {
                _this.loadingPudoPickupLocations = false;
                _this.pudoLocationsNotFound = true;
            });
        }
    };
    OrderPromotionComponent.prototype.prepareBusinessHours = function () {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach(function (collectionPoint) {
                if (collectionPoint && collectionPoint.openingHours) {
                    var businessHours_1 = [];
                    collectionPoint.openingHours.forEach(function (opening) {
                        if (opening && opening.hours) {
                            var hours_1 = [];
                            opening.hours.forEach(function (hour) {
                                hours_1.push({ start: hour.opens, end: hour.closes });
                            });
                            var businessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours_1
                            };
                            businessHours_1.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours_1;
                }
            });
        }
    };
    OrderPromotionComponent.prototype.getPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    _this.pudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                    if (mappingRequired) {
                        if (_this.pudoShippingMethod) {
                            _this.pudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                        _this.getPudoLocations();
                    }
                }
            }, function (error) {
            });
        }
    };
    OrderPromotionComponent.prototype.prepareShippingOptionsRequest = function () {
        var shippingOptions = {
            productModels: this.getProductModels(),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this.getWarehouseAddress(),
            toAddress: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? this.getShippingAddress() : (this.shippingAddressInfoConfig.dropShipLocationsEnabled
                && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress() : this.gtePudoPickupPersonAddress(),
            storeId: this.storeInfo.id,
            requestID: 2,
            memberTypeId: this.memberInfo && (this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR || this.memberInfo.memberTypeId === MemberTypeEnum.FPC)
                ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,
            priceTypeId: this.getPriceTypeId(),
            memberLevelId: this.memberInfo && (this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER)
                ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
            orderSubTotal: this.subTotal ? this.subTotal : 0,
            orderTaxInclusiveSubTotal: this._commonService.getProductsTotalTax(this.products, this.subTotal, this.storeInfo),
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: this.getPurchaseFlowId(),
            shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP ? ShippingType.DROPSHIP : ShippingType.PICKUP),
            storeHomeCountryCode: this.selectedIsoCountryCode,
            vatInclusive: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false,
            initialOrder: false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? true : false,
            bwpEnabled: this.isBWPEnabled && this.isBWPEnabledProduct && this.storeInfo && this.storeInfo.bwpEnabled ? true : false
        };
        //order source only for AUT && DEU Country
        if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
            shippingOptions.source = Source.CSP;
        }
        return shippingOptions;
    };
    OrderPromotionComponent.prototype.gtePudoPickupPersonAddress = function () {
        var address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                var mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if (!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        }
        else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    };
    /** Products
    * @returns Products
    */
    OrderPromotionComponent.prototype.getProductModels = function () {
        var productModels = [];
        if (this.products && this.products.length > 0) {
            for (var index = 0; index < this.products.length; index++) {
                var product = this.products[index];
                if (product) {
                    var productModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }
            }
        }
        return productModels;
    };
    /**
     * Decrement the item Quantity
     * @returns void
     */
    OrderPromotionComponent.prototype.decrementQuantity = function (index) {
        var _this = this;
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        var product = items.controls[index].controls['productItem'].value;
        var previousProductQty = product.quantity;
        if (items && items.length > 0 && this.storeInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            if (items.controls[index].controls['quantity'].value === 1) {
                items.controls[index].controls['disableDecrement'].setValue(true);
            }
            else {
                items.controls[index].controls['disableDecrement'].setValue(false);
            }
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            this.setFocusbyID('quantity-' + (index));
            if (this.productAssociationInfo) {
                var productid_1 = items.value[index].productId;
                var associateProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productid_1; });
                if (associateProduct_1) {
                    var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_1.depositFeeProductId; });
                    if (sameProductIndex >= 0) {
                        this.decrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);
            this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(function () {
                    //New logic to bind promtoion product from promotion engine
                    var freeProductsInfo = _this.validatePromotionCriteria(items);
                    var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items, _this.orderFormGroup, _this.promotionIds);
                    _this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                    if (productIds && productIds.length) {
                        _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    }
                    else {
                        _this.updateTotalsAndShipMethod();
                    }
                }, 500);
        }
    };
    /**
    * Increment the item Quantity
    * @returns void
    */
    OrderPromotionComponent.prototype.incrementQuantity = function (index) {
        var _this = this;
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            var product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock) && !(product.stockAvailable && !product.manageStock)) {
                items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                items.controls[index].controls['disableIncrement'].setValue(true);
            }
            else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            var quantityFieldLength = items.controls[index].controls['quantity'].value ? items.controls[index].controls['quantity'].value.toString().length : 0;
            if (quantityFieldLength > 3) {
                items.controls[index].controls['disableIncrement'].setValue(true);
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
            }
            items.controls[index].controls['disableDecrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            this.setFocusbyID('quantity-' + (index));
            if (this.productAssociationInfo) {
                var productid_2 = items.value[index].productId;
                var associateProduct_2 = this.productAssociationInfo.find(function (x) { return x.productId === productid_2; });
                if (associateProduct_2) {
                    var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_2.depositFeeProductId; });
                    if (sameProductIndex >= 0) {
                        this.incrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);
            this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(function () {
                    //New logic to bind promtoion product from promotion engine
                    var freeProductsInfo = _this.validatePromotionCriteria(items);
                    var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items, _this.orderFormGroup, _this.promotionIds);
                    if (productIds && productIds.length) {
                        _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    }
                    else {
                        _this.updateTotalsAndShipMethod();
                    }
                }, 500);
        }
    };
    OrderPromotionComponent.prototype.quantityChange = function (event, index) {
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    };
    /**
    * @param  {number} index
    * @returns void
    */
    OrderPromotionComponent.prototype.updateQuantity = function (event, index) {
        var _this = this;
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            var items_1 = this.orderFormGroup.get('items');
            if (items_1 && items_1.length > 0 && this.storeInfo) {
                var quantity = event.target ? +event.target.value : event;
                if (!items_1.controls[index].controls['quantity'].dirty && event.target) {
                    return;
                }
                items_1.controls[index].controls['quantity'].markAsPristine();
                var product = items_1.controls[index].controls['productItem'].value;
                var previousProductQty = product.quantity;
                if (items_1.controls[index].controls['quantity'].value > 1 ||
                    (quantity && parseInt(quantity, 10))) {
                    if (product && quantity > product.stockQuantity && product.manageStock) {
                        items_1.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                        items_1.controls[index].controls['disableIncrement'].setValue(true);
                    }
                    else {
                        items_1.controls[index].controls['quantity'].setValue(quantity);
                        items_1.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    items_1.controls[index].controls['disableDecrement'].setValue(false);
                }
                if (items_1.controls[index].controls['quantity'].value === 0) {
                    items_1.controls[index].controls['quantity'].setValue(1);
                    quantity = 1;
                    items_1.controls[index].controls['disableIncrement'].setValue(false);
                    items_1.controls[index].controls['disableDecrement'].setValue(true);
                }
                items_1.controls[index].controls['quantity'].updateValueAndValidity();
                clearTimeout(this.clickTimeout[items_1.controls[index].controls['productId'].value]);
                var productid_3 = items_1.value[index].productId;
                if (this.productAssociationInfo) {
                    var associateProduct_3 = this.productAssociationInfo.find(function (x) { return x.productId === productid_3; });
                    if (associateProduct_3) {
                        var sameProductIndex = items_1.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_3.depositFeeProductId; });
                        if (sameProductIndex >= 0) {
                            var depositFeeProductQuantity = +items_1.value[sameProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - previousProductQty;
                            depositFeeProductQuantity = depositFeeProductQuantity + quantity;
                            if (depositFeeProductQuantity > 0) {
                                this.updateQuantity(depositFeeProductQuantity, sameProductIndex);
                            }
                        }
                    }
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod(false);
                }
                this.isFocused = false;
                this.clickTimeout[items_1.controls[index].controls['productId'].value] =
                    setTimeout(function () {
                        //New logic to bind promtoion product from promotion engine
                        var freeProductsInfo = _this.validatePromotionCriteria(items_1);
                        _this._commonService.removeNonPromotionProducts(freeProductsInfo, items_1);
                        var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items_1, _this.orderFormGroup, _this.promotionIds);
                        if (productIds && productIds.length) {
                            _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                        }
                        else {
                            _this.updateTotalsAndShipMethod();
                        }
                    }, 500);
            }
        }
    };
    /**
     * @description open/close when restricted products shown
     * @date 2019-08-07
     * @param {boolean} isOpen
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.restrictionPopupOpen = function (isOpen) {
        this.isRestrictionPopupOpened = isOpen;
    };
    /**
     * disabling Submit button
     */
    OrderPromotionComponent.prototype.disableSubmitButton = function () {
        this.taxCalculationStatus = true;
    };
    /**
     * @returns void
     */
    OrderPromotionComponent.prototype.deleteItem = function (index) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        var product = items.controls[index].controls['productItem'].value;
        var productQuantity = +items.controls[index].controls['quantity'].value;
        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                var depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                var productId_1 = items.value[index].productId;
                var parentProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productId_1; });
                if (parentProduct_1) {
                    // remove the parent product
                    items.removeAt(index);
                    var depositFeeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === parentProduct_1.depositFeeProductId; });
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            var depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity;
                                items.setValue(items.value);
                            }
                            else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    }
                    else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                }
                else {
                    items.removeAt(index);
                }
            }
            else {
                items.removeAt(index);
            }
        }
        setTimeout(function () {
            if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                _this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod(false);
        //New logic to bind promtoion product from promotion engine
        var freeProductsInfo = this.validatePromotionCriteria(items);
        var productIds = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        }
        else {
            this.updateTotalsAndShipMethod();
        }
    };
    OrderPromotionComponent.prototype.confirm = function (index) {
        if (index === 0 || index > 0) {
            this.deleteItem(index);
        }
    };
    OrderPromotionComponent.prototype.addItemNumber = function () {
        this.items = this.orderFormGroup.get('items');
        this.items.push(this.createItemNumberGroup());
    };
    // endregion
    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    OrderPromotionComponent.prototype.clearAllTheForms = function (clearCountry, clearShippingAddress, clearMember) {
        if (clearCountry === void 0) { clearCountry = true; }
        if (clearShippingAddress === void 0) { clearShippingAddress = true; }
        if (clearMember === void 0) { clearMember = false; }
        this.showSelectedShipMethod = false;
        this.shippingAddressInfo = null;
        this.selectedpayvisionCardInfo = null;
        this.shipMethod = null;
        this.savedCards = [];
        this.bankDetailsList = [];
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        this.shippingCost = 0;
        this.shippingTax = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.isCalculateTax = false;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.verifiedShippingAddressId = 0;
        this.agreementDocuments = [];
        this.memberLevelHistory = [];
        this.isMemberFboUpgraded = false;
        this.isFBOValidationPending = false;
        this.personalInformation = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.address = null;
        this.sponsorInformation = null;
        this.retuningGuestUser = null;
        this.isSubmitted = false;
        this.businessEntityId = null;
        this.isPaymentWithSavedCard = false;
        this.orderFormGroup.get('items').reset();
        var arr = this.orderFormGroup.controls.items;
        arr.controls = [];
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.shippingCost = 0;
        this.memberCommunicationPreferences = {
            email: true,
            phone: false
        };
        this.orderFormGroup.patchValue({
            shippingCostSelector: this.selectEnum.firstOption.toString(),
            shippingCostPercentage: 0,
            originalShippingCost: 0,
            paymentSelector: this.selectEnum.firstOption.toString(),
            paymentInstrumentId: '',
            isShippingDiscountApplied: false,
            originalShippingTax: 0
        });
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearCountry) {
            this.orderFormGroup.controls['countryId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['countryId'].updateValueAndValidity();
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL && this.stores && this.stores.length > 0) {
                var countryId = this.stores.find(function (store) { return store.isocodeThree.toUpperCase() === IsoCodeThree.USA; }).id || this.stores[0].id;
                this.orderFormGroup.controls['countryId'].setValue(countryId);
                this._enrollmentMessageService.setClearGuestForm();
            }
            else {
                this.orderFormGroup.controls['countryId'].setValue('');
            }
            this.memberCountries = [];
            this.shippingAddressInfoConfig = null;
        }
        if (clearMember) {
            this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required]);
            this.orderFormGroup.controls['memberInfo'].updateValueAndValidity();
            this.orderFormGroup.controls['memberInfo'].setValue('');
            this.memberInfo = null;
            this.shippingAddressInfoConfig = null;
        }
        if (clearShippingAddress) {
            this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.shippingMethods = [];
            this.memberAddressDetails = [];
        }
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        this.orderFormGroup.controls['itemSearch'].setValue('');
        this.orderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.showDropShipPersonAddressForm = false;
        this.pudoAddress = null;
        this.savedPudoAddressId = null;
        this.pudoAddressSubmitted = false;
        this.buildPudoLocationSearchForm();
        this.loadingPudoPickupLocations = false;
        this.displayPudoAddress = false;
        this.buildPayByLinkForm();
        this.isOverrideMinimumLimit = false;
        this.savedCards = [];
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo = [];
    };
    /**
     * update Totals and ShipMethod
     */
    OrderPromotionComponent.prototype.updateTotalsAndShipMethod = function (isShippingMethod) {
        var _this = this;
        if (isShippingMethod === void 0) { isShippingMethod = true; }
        /**   if(this.isPromotionEngineEnabled) {
              this.getPromotionProducts();
          }*/
        this.taxCalculationStatus = true;
        this.subTotal = 0;
        this.retailSubTotal = 0;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.isCalculateTax = false;
        if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.itemCount = this.shoppingCartCount;
        }
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            var _loop_1 = function (index) {
                var product = items.controls[index].controls['productItem'].value;
                var quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    var existProduct_1 = this_1.products.filter(function (productObj) { return productObj.id === product.id; })[0];
                    if (!existProduct_1) {
                        product.quantity = quantity;
                        this_1.products.push(product);
                    }
                    else {
                        var productIndex = this_1.products.findIndex(function (item) { return item.id === existProduct_1.id; });
                        this_1.products[productIndex].quantity = this_1.products[productIndex].quantity + quantity;
                    }
                    if (this_1.appConfig && this_1.appConfig.freeShippingFPCOrder) {
                        this_1.getMemberShippingDiscountOffer(this_1.memberInfo.memberId);
                    }
                    else {
                        this_1.memberShippingDiscountOfferEligible = false;
                    }
                    var shippingAddress_1 = this_1.getShippingAddress();
                    if (shippingAddress_1 && shippingAddress_1.countryId && this_1.countries && this_1.countries.length > 0) {
                        var country = this_1.countries.find(function (x) { return x.countryId === shippingAddress_1.countryId; });
                        this_1.countryTaxInclusive = this_1.getCountryTaxInclusiveInfo(country);
                    }
                    var isEnableVATCalculation = this_1.appConfig && this_1.appConfig.enableVATCalculation;
                    var taxCalculated = (this_1.appConfig && (this_1.appConfig.displayTaxInclusivePrice || this_1.appConfig.enableVatItemizationForNonVat)) ? false : true;
                    this_1.displayPriceConfig = this_1._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this_1.storeInfo.taxInclusive, this_1.memberInfo, taxCalculated, this_1.countryTaxInclusive, this_1.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    var retailPrice = product.retailPrice;
                    if (this_1.displayPriceConfig) {
                        retailPrice = this_1.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this_1.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }
                    this_1.subTotal = this_1.subTotal + this_1.getItemTotalSum(product);
                    this_1.retailSubTotal = this_1.retailSubTotal + (retailPrice * +quantity);
                    this_1.totalCommissionableVolume = this_1.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    this_1.shoppingCartCount += +product.quantity;
                }
            };
            var this_1 = this;
            for (var index = 0; index < items.length; index++) {
                _loop_1(index);
            }
            this.depositFeeProductCount = this.getDepositFeeProductCount();
            if (this.shoppingCartCount && this.depositFeeProductCount) {
                this.shoppingCartCount = this.shoppingCartCount - this.depositFeeProductCount;
            }
            if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this.itemCount = this.shoppingCartCount - this.itemCount;
            }
            else {
                this.itemCount = this.shoppingCartCount;
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && (!(this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) || !this.checkoutConfig.enableMinAndMaxLimitRules)) {
                var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
                var literatureItems = this.getLiteratureItems(this.products);
                if (this.isMemberFboUpgraded) {
                    this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
                    if (this.upgradeFboLimitExceeded) {
                        this.checkMemberAccess();
                        if (isShippingMethod) {
                            this.getShipMethods();
                        }
                        return;
                    }
                    else {
                        this.isMemberHasAccessToOrder = true;
                    }
                }
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    var hasMinValueIgnoreProduct = this._enrollmentCommonService.checkMinValueProduct(this.products, this.orderRules);
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                    if (subTotal > this.orderRules.maxValue) {
                        clearTimeout(this.cartMessageID);
                        var cartValueExceeded = this._translatePipe.get('order.Your cart must not exceed');
                        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
                        var cartValueExceededNotification_1 = cartValueExceeded.value + ' <b class="helvetica-bold">' +
                            maxValue + '</b>';
                        if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                            this.cartMessageID = setTimeout(function () {
                                _this._commonService.createNotification('', cartValueExceededNotification_1, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }, 100);
                        }
                        this.cartLimitExceed = true;
                    }
                    else if ((subTotal < this.orderRules.minValue && !hasMinValueIgnoreProduct) && !this.isOverrideMinimumLimit) {
                        clearTimeout(this.cartMessageID);
                        var cartMinimumLimit = this._translatePipe.get('order.Order must meet a minimum of');
                        if (this.products && this.products.length &&
                            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                            && this.appConfig.displayPurchaseLimitationMessage
                            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                            cartMinimumLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                        }
                        if (this.overrideMinimumLimitIsEnabled) {
                            var overrideLimitLink = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                            var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                            var cartMinimumLimitNotification_1 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                            this.cartMessageID = setTimeout(function () {
                                var toast = _this._commonService.createNotification('', cartMinimumLimitNotification_1, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                toast.click.subscribe(function (event) {
                                    if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                        _this.overrideMinimumLimit.open();
                                    }
                                });
                            }, 100);
                            this.cartLimitNotReach = false;
                        }
                        else {
                            var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                            var cartMinimumLimitNotification_2 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>';
                            this.cartMessageID = setTimeout(function () {
                                _this._commonService.createNotification('', cartMinimumLimitNotification_2, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                            }, 100);
                            this.cartLimitNotReach = true;
                        }
                    }
                    else {
                        this._commonService.removeNotification(Constants.MIN_LIMIT);
                        this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                    }
                }
                else {
                    this.cartLimitExceed = false;
                    this.cartLimitNotReach = false;
                    this.minMaxPriceValidation = false;
                }
            }
            else {
                this.itemCount = 0;
            }
            this.validateThreshold();
            this.validateOrderLimit(true);
            if (isShippingMethod) {
                this.getShipMethods();
            }
        }
        else if (this.isMemberFboUpgraded) {
            var subTotal = this.calculateItemsSubTotal(this.storeInfo);
            this.isMemberHasAccessToOrder = true;
            this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
        }
        this.getItemsTotals();
    };
    OrderPromotionComponent.prototype.getDepositFeeProductCount = function () {
        var _this = this;
        var depositFeeProductCount = 0;
        this.products.forEach(function (item) {
            var depositFeeProduct = null;
            depositFeeProduct = _this.productAssociationInfo.find(function (x) { return x.depositFeeProductId === item.id; });
            depositFeeProductCount = depositFeeProduct ? (depositFeeProductCount + item.quantity) : depositFeeProductCount;
        });
        return depositFeeProductCount;
    };
    OrderPromotionComponent.prototype.getOverrideMinimumLimit = function () {
        if (this.userInfo && this.userInfo.allowedOperatingCountries && this.storeInfo && this.storeInfo.operatingCountry && !this.userInfo.hasSystemRole && this.operatingCountry) {
            var isoCodeThree_1 = this.storeInfo.operatingCountry;
            var allowedCountryIds = [];
            var operatingCountryId = this.operatingCountry.filter(function (operatingCountry) { return operatingCountry.value == isoCodeThree_1; });
            allowedCountryIds = this.userInfo.allowedOperatingCountries.split(",");
            if (operatingCountryId && operatingCountryId.length > 0) {
                return allowedCountryIds.includes(operatingCountryId[0].id.toString()) && this.hasMinimumOverrideLimit;
            }
            else {
                return false;
            }
        }
        return this.userInfo && this.userInfo.hasSystemRole === true ? true : false;
    };
    OrderPromotionComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerService.getOperatingCountries().subscribe(function (response) {
            if (response) {
                _this.operatingCountry = response;
            }
        }, function (err) {
            console.log(err);
        });
    };
    OrderPromotionComponent.prototype.closeOverrideMinimumLimit = function () {
        this.isOverrideMinimumLimit = false;
        this.overrideMinimumLimit.close();
    };
    OrderPromotionComponent.prototype.overrideMinimumLimitValueCheck = function (event) {
        this.isOverrideMinimumLimit = event.currentTarget.checked;
    };
    OrderPromotionComponent.prototype.closeNotification = function () {
        this._commonService.removeNotification(Constants.MIN_LIMIT);
        this.overrideMinimumLimit.close();
    };
    OrderPromotionComponent.prototype.getItemsTotals = function () {
        this.taxInclusiveSubTotal = this.getTaxbasedSubtotal(true);
        this.taxExclusiveSubTotal = this.getTaxbasedSubtotal(false);
        this.restrictPaymentsByItemTotals();
    };
    OrderPromotionComponent.prototype.restrictPaymentsByItemTotals = function () {
        var _this = this;
        if (this.paymentDroolsResponse && this.paymentDroolsResponse.length > 0) {
            this.paymentDroolsResponse.forEach(function (x) {
                if (x.taxInclusivePrice && _this.taxInclusiveSubTotal > 0) {
                    if (!(x.minValue < _this.taxInclusiveSubTotal && x.maxValue >= _this.taxInclusiveSubTotal)) {
                        if (x.paymentMethod == PaymentMethodTypeConstants.DirectDebit) {
                            _this.direct_debit_show = false;
                        }
                        if (x.paymentMethod == PaymentMethodTypeConstants.SingleDebit) {
                            _this.single_debit_show = false;
                        }
                    }
                    else {
                        if (_this.initialPaymentMethods.find(function (pm) { return pm.paymentMethodName === PaymentMethodTypeConstants.DirectDebit; })) {
                            _this.direct_debit_show = true;
                        }
                        if (_this.initialPaymentMethods.find(function (pm) { return pm.paymentMethodName === PaymentMethodTypeConstants.SingleDebit; })) {
                            _this.single_debit_show = true;
                        }
                    }
                }
                if (!x.taxInclusivePrice && _this.taxExclusiveSubTotal > 0) {
                    if (!(x.minValue < _this.taxExclusiveSubTotal && x.maxValue >= _this.taxExclusiveSubTotal)) {
                        if (x.paymentMethod == PaymentMethodTypeConstants.DirectDebit) {
                            _this.direct_debit_show = false;
                        }
                        if (x.paymentMethod == PaymentMethodTypeConstants.SingleDebit) {
                            _this.single_debit_show = false;
                        }
                    }
                    else {
                        if (_this.initialPaymentMethods.find(function (pm) { return pm.paymentMethodName === PaymentMethodTypeConstants.DirectDebit; })) {
                            _this.direct_debit_show = true;
                        }
                        if (_this.initialPaymentMethods.find(function (pm) { return pm.paymentMethodName === PaymentMethodTypeConstants.SingleDebit; })) {
                            _this.single_debit_show = true;
                        }
                    }
                }
            });
        }
    };
    OrderPromotionComponent.prototype.getTaxbasedSubtotal = function (taxInclusive) {
        var total = 0;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0) {
            if (taxInclusive) {
                items.value.forEach(function (element) {
                    total = total + element.quantity * element.productItem.applicablePrice;
                });
            }
            if (!taxInclusive) {
                items.value.forEach(function (element) {
                    total = total + element.quantity * element.productItem.catalogPrice;
                });
            }
        }
        return total;
    };
    /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
    OrderPromotionComponent.prototype.calculateSubtotalWithWholesalePrice = function (orderSubTotal) {
        var _this = this;
        var subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(function (item) {
                subTotal += ((_this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    };
    /**
     * @description
     * @date 2019-09-03updateMemberOptin
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.openMemberLevelChange = function (requestUrl) {
        var _this = this;
        this.fpcOrderGlobalUrl = requestUrl;
        this.setDefaultPickerDate();
        this.personalInfoConfig = this._personalInfoConfigService.getSettings(this.countryCode);
        this.createOptUpdateForm();
        this._configurationService.setEnrollCountry(this.countryCode);
        var operatingCompany = this.storeInfo && this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null;
        var storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
        this._customerService.getMemberBankDetails(this.memberInfo.memberId, storeId, operatingCompany).subscribe(function (bankDetailResponse) {
            if (_this.memberInfo.pcSponsorEligible && bankDetailResponse && bankDetailResponse.accountNumber) {
                _this.bonusInfoAvailable = true;
            }
        });
        this.getFboDocuments();
        this.updateMemberLevelPopup.closeOnOutsideClick = false;
        this.updateMemberLevelPopup.closeOnEscape = false;
    };
    /**
     * @description
     * @date 2019-09-11
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.createOptUpdateForm = function () {
        this.optInCheck = false;
        this.isFPCOptInEnabled = false;
        if (this.fboUpgradeForm) {
            this.fboUpgradeForm.controls['dateOfBirth'].clearValidators();
            this.fboUpgradeForm.controls['dateOfBirth'].setValue('');
            this.fboUpgradeForm.controls['governmentId'].clearValidators();
            this.fboUpgradeForm.controls['governmentId'].setValue('');
            this.fboUpgradeForm.patchValue({
                wholesaleQualified: true,
                fpcToFboOptIn: [],
                dateOfBirth: '',
                governmentId: ''
            });
        }
        else {
            this.fboUpgradeForm = this._formbuilder.group({
                wholesaleQualified: [true],
                fpcToFboOptIn: [],
                dateOfBirth: ['', [ValidateDateOfBirth.DOBFormat]],
                governmentId: ['']
            });
        }
        this.getGovermentIdentificationPatterns();
        this.showOptin = true;
    };
    /**
     * @description
     * @date 2019-09-11
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.updateMemberOptin = function (legalRequirements, isValid) {
        this.formSubmitted = true;
        this.isSubmitted = true;
        if (this.optInCheck) {
            if ((this.personalInfoConfig && this.personalInfoConfig.showBusinessInfoSection && !this.validateBusinessInformation()) || (this.personalInfoConfig.bonusInfoPaymentOptions && !this.bonusInfoAvailable && !this.isSelectedBonusPaymentOptionType)) {
                this.legalRequirements = legalRequirements;
                this.setBusinessInformation();
            }
            else {
                this.validateMemberUpdateInformation(legalRequirements);
            }
        }
        else {
            this.submitPlaceOrder(this.fpcOrderGlobalUrl);
            this.document.documentElement.classList.remove('optin-popup');
            this.updateMemberLevelPopup.close();
        }
    };
    OrderPromotionComponent.prototype.validateMemberUpdateInformation = function (legalRequirements) {
        var _this = this;
        if (!this.bonusInfoAvailable) {
            if (this.beneluxCountry) {
                this.setBonusInformation();
                if (this.accountNumber !== undefined && this.accountNumber !== "") {
                    if (this.bonusInfoAgreements && this.bonusInfoAgreements.length > 0) {
                        var agreements = this.bonusInfoAgreements.filter(function (x) { return x.isSelected === false; });
                        this.bonusInfoAgreementCheckError = agreements && agreements.length === 0 ? false : true;
                    }
                }
            }
            if (this.personalInfoConfig.showBonusInfoSection && this.personalInfoConfig.bonusInfoPaymentOptions
                && !this.bonusInformation && this.bonusPaymentOptionType !== BonusPaymentOption.DECIDE_LATER) {
                this.setBonusInformation();
            }
        }
        if (!this.governmentIdExist && !this.invalidGovernmentId
            && !this.governmentIdValidInProgress && !this.agreementCheckError && !this.bonusInfoAgreementCheckError) {
            if (!legalRequirements.dateOfBirth) {
                return;
            }
            this.legalRequirements = legalRequirements;
            if (this.beneluxCountry) {
                setTimeout(function () {
                    _this.getSponsorInfoByReferralOrAutoSuggest(_this.memberInfo.sponsorId);
                }, 2500);
            }
            else {
                this.getSponsorInfoByReferralOrAutoSuggest(this.memberInfo.sponsorId);
            }
        }
        else {
            return;
        }
    };
    OrderPromotionComponent.prototype.validateBusinessInformation = function () {
        if (this.personalInfoConfig && this.personalInfoConfig.showBusinessInfoSection) {
            if (this.businessInformation && this.businessInformation.isBusinessInfoValid) {
                return true;
            }
            else
                return false;
        }
        return true;
    };
    /**
 * @description formatting dob to the yyyy-mm-dd
 * @date 2019-09-12
 * @param {LegalRequirements} legalRequirements
 * @returns {LegalRequirements}
 * @memberof OrderPromotionComponent
 */
    OrderPromotionComponent.prototype.dateOfBirthFormat = function (legalRequirements) {
        var characterCheck = /[a-zA-z]/;
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.Object) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._d;
            legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                .format(DateConstants.DOBFormat);
        }
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.String) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._i;
            var dateParts = legalRequirements.dateOfBirth.split('-');
            if (characterCheck.test(dateParts[1])) {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                    .format(DateConstants.DOBFormat);
            }
            else {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format(DateConstants.DOBFormat);
            }
        }
        return legalRequirements;
    };
    /**
    * Government ID changes
    * @memberof PersonalInfoComponent
    */
    OrderPromotionComponent.prototype.governmentIdChanges = function () {
        this.invalidGovernmentId = false;
        this.governmentIdExist = false;
    };
    /**
     * @description
     * @date 2019-09-16
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getFboDocuments = function (selectedLanguage, optInCheck) {
        var _this = this;
        var customerTypeId = (this.documentsRequest && this.documentsRequest.customerTypeId) ? this.documentsRequest.customerTypeId : DocumentLibraryMemberId.Distributor;
        var displaySetionId = (this.documentsRequest && this.documentsRequest.displaySectionId) ? this.documentsRequest.displaySectionId : DisplaySectionId.FBO_Checkout_Page;
        this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, selectedLanguage ? selectedLanguage : this.storeDefaultLanguage)
            .subscribe(function (response) {
            if (response && response[0].body) {
                response[0].body = orderBy(response[0].body, ['documentUrl'], ['asc']);
                _this.agreementDocuments = response[0].body;
                if (!optInCheck && _this.agreementDocuments && _this.agreementDocuments.length) {
                    _this.agreementDocuments.forEach(function (item) {
                        item.isSelected = true;
                    });
                }
                if (environment.scandinavianCountries && _this.countryCode) {
                    var scandinavianCountries = environment.scandinavianCountries;
                    _this.scandinavianCountry = scandinavianCountries.split(",").find(function (country) { return country === _this.countryCode; });
                }
                _this.fetchTermsConditionDocument(_this.agreementDocuments);
                _this._configurationService.setEnrollCountry(_this.countryCode);
                if (_this.personalInfoConfig && _this.personalInfoConfig.showBusinessInfoSection) {
                    _this.businessInfoSchemaUrl = _this.countryCode.toLowerCase() + '-bonus-info.json?templateVersion='
                        + environment.templateVersion;
                }
                if (_this.countryCode.toLowerCase() === IsoCodeThree.SWE.toLowerCase()) {
                    _this.bonusInfoSchemaUrl = _this.countryCode.toLowerCase() + '-bankgiro-bonus-info.json?templateVersion= '
                        + environment.templateVersion;
                }
                else {
                    _this.bonusInfoSchemaUrl = _this.countryCode.toLowerCase() + '-bonus-info.json?templateVersion='
                        + environment.templateVersion;
                }
                _this.setFboBonusInformationPermissions(_this.storeInfo.id);
                _this._configurationService.setBonusInfoSchemaUrl(_this.bonusInfoSchemaUrl);
                _this._personalMessageService.setRebindBonusinfoForm(true);
                _this.beneluxCountry = (_this.personalInfoConfig.showBonusInfoSection && _this.personalInfoConfig.showBonusDebitInforMenu) ? true : false;
                if (_this.beneluxCountry) {
                    if (!_this.optInCheck) {
                        _this._personalMessageService.setDisableBonusInfoForm(true);
                    }
                    if (!_this.scandinavianCountry) {
                        _this.fetchBonusInfoTermsAndConditions(_this.countryCode, _this.storeDefaultLanguage);
                    }
                }
                _this.document.documentElement.classList.add('optin-popup');
                _this.updateMemberLevelPopup.open();
                setTimeout(function () {
                    _this._personalMessageService.setDisableBonusInfoForm(true);
                }, 1500);
            }
            else {
                var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    /**
     * @description
     * @date 2019-09-16
     * @param {*} dateMomentObj
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.convertToSpecificDateFormat = function (dateMomentObj) {
        var characterCheck = /[a-zA-z]/;
        var dateInputPattern = /^[a-zA-Z0-9\-]*$/;
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            this.fboUpgradeForm.patchValue({
                dateOfBirth: moment(dateMomentObj, 'DD-MMM-YYYY')
            });
        }
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj.value._i === DateConstants.String) {
            dateMomentObj = dateMomentObj.value._i;
            if (dateInputPattern.test(dateMomentObj)) {
                var dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, DateConstants.DateFormat);
                }
                else {
                    dateMomentObj = moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                        .format(DateConstants.DateFormat);
                }
                this.fboUpgradeForm.patchValue({
                    dateOfBirth: moment(dateMomentObj, DateConstants.DateFormat)
                });
                this.datePickerStartDateAt = new Date(dateMomentObj);
            }
            else {
                this.datePickerStartDateAt = new Date();
            }
        }
    };
    OrderPromotionComponent.prototype.setDefaultPickerDate = function () {
        this.datePickerStartDateAt.setFullYear(new Date().getFullYear() - 18);
    };
    /**
     * @description
     * @date 2019-09-09
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.optInSelect = function (optin) {
        this.isFPCOptInEnabled = true;
        this.isSubmitted = false;
        this.fboUpgradeForm.controls['fpcToFboOptIn'].setValue(optin);
        this.optInCheck = optin;
        this.agreementDocuments.forEach(function (x) {
            x.isSelected = optin;
        });
        if (!optin) {
            this.fboUpgradeForm.controls['dateOfBirth'].clearValidators();
            this.fboUpgradeForm.controls['governmentId'].clearValidators();
            this.fboUpgradeForm.controls['dateOfBirth'].setValue('');
            this.fboUpgradeForm.controls['governmentId'].setValue('');
            this.fboUpgradeForm.controls['governmentId'].updateValueAndValidity();
            this.agreementCheckError = false;
            this.bonusInfoAgreementCheckError = false;
            this.invalidGovernmentId = false;
            this.governmentIdExist = false;
            if (this.beneluxCountry) {
                this._personalMessageService.setDisableBonusInfoForm(true);
            }
        }
        else {
            var dateMomentObj = Utils.convertToSpecificDateFormat(this.dateOfBirthMember, DateConstants.DateFormat);
            if (dateMomentObj) {
                if (this.fboUpgradeForm.controls['dateOfBirth'].valid) {
                    this.fboUpgradeForm.controls['dateOfBirth'].clearValidators();
                    this.fboUpgradeForm.controls['dateOfBirth'].setValue(dateMomentObj);
                }
            }
            else {
                this.fboUpgradeForm.controls['dateOfBirth'].setValidators([Validators.required, ValidateDateOfBirth.DOBFormat]);
                this.fboUpgradeForm.controls['dateOfBirth'].updateValueAndValidity();
            }
            if (this.beneluxCountry || (this.appConfig && this.appConfig.hideGovernmentidFPCToFBOUpgrade)) {
                this._personalMessageService.setDisableBonusInfoForm(false);
                this.invalidGovernmentId = false;
                this.governmentIdExist = false;
                this.fboUpgradeForm.controls['governmentId'].clearValidators();
                this.fboUpgradeForm.controls['governmentId'].setValue('');
                this.fboUpgradeForm.controls['governmentId'].updateValueAndValidity();
            }
            else {
                this.getGovermentIdentificationPatterns();
            }
        }
    };
    /**
     * @description
     * @date 2019-09-16
     * @param {number} index
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.checkFboOptIn = function (index) {
        this.agreementDocuments[index].isSelected = !this.agreementDocuments[index].isSelected;
        this.checkDocumentsSelected();
    };
    OrderPromotionComponent.prototype.checkPaymentTermsAndPolicies = function (index) {
        this.paymentTermsAndPoliciyDocuments[index].isSelected = !this.paymentTermsAndPoliciyDocuments[index].isSelected;
        this.checkPaymentDocumentsSelected();
    };
    /**
     * @description
     * @date 2019-09-16
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.checkDocumentsSelected = function () {
        var selectedDocuments = this.agreementDocuments.filter(function (x) { return x.isSelected; });
        if (selectedDocuments && selectedDocuments.length === this.agreementDocuments.length) {
            this.agreementCheckError = false;
            this.formSubmitted = false;
        }
        else {
            this.agreementCheckError = true;
            this.formSubmitted = false;
        }
    };
    OrderPromotionComponent.prototype.checkPaymentDocumentsSelected = function () {
        if (this.paymentTermsAndPoliciyDocuments && !this.paymentTermsAndPoliciyDocuments.every(function (x) { return x.isSelected; })) {
            this.agreementCheckError = true;
        }
        else {
            this.agreementCheckError = false;
        }
    };
    /**
     * @description
     * @date 2019-09-03
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.closePopUpforMemberLevelChange = function () {
        this.formSubmitted = false;
        this.createOptUpdateForm();
        this.document.documentElement.classList.remove('optin-popup');
        this.updateMemberLevelPopup.close();
        this.isSubmitted = false;
    };
    /**
     * @description
     * @date 2019-09-16
     * @param {FormControl} governmentIdControl
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.validateGovernmentId = function (governmentIdControl) {
        var _this = this;
        this.governmentIdExist = false;
        this.invalidGovernmentId = false;
        var governmentId = governmentIdControl.value;
        var isGovernmentIdValid = governmentIdControl.valid;
        if (governmentId && governmentId.length > 0 && isGovernmentIdValid) {
            this.governmentIdValidInProgress = true;
            this._documentService.validateGovernmentId(governmentId, this.countryCode, this.storeId, this.memberId)
                .subscribe(function (response) {
                _this.invalidGovernmentId = false;
                if (response && response._body === 'false') {
                    _this.governmentIdExist = false;
                }
                else {
                    _this.governmentIdExist = true;
                }
                _this.governmentIdValidInProgress = false;
            }, function (errResponse) {
                if (errResponse) {
                    _this.governmentIdExist = false;
                    _this.governmentIdValidInProgress = false;
                    var response = JSON.parse(errResponse._body);
                    if (response && response.validations && !response.statusCode
                        && response.validations.length > 0) {
                        _this.invalidGovernmentId = true;
                    }
                    else {
                        _this.invalidGovernmentId = false;
                    }
                }
            });
        }
    };
    // endregion
    /**
     * Selected Shipping Address
     */
    OrderPromotionComponent.prototype.getShippingAddress = function () {
        var shippingAddressdata = null;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            shippingAddressdata = this.pudoShippingAddressInfo;
        }
        else if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            shippingAddressdata = this.pudoShippingAddressInfo;
        }
        else {
            shippingAddressdata = this.shippingAddressInfo;
        }
        if (shippingAddressdata) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, shippingAddressdata.countryCode);
            var shippingAddress = {
                addressLine1: shippingAddressdata.addressLine1,
                addressLine2: shippingAddressdata.addressLine2,
                addressLine3: shippingAddressdata.addressLine3,
                addressLine4: shippingAddressdata.addressLine4,
                addressVerified: shippingAddressdata.addressVerified,
                latitude: shippingAddressdata.latitude,
                longitude: shippingAddressdata.longitude,
                city: shippingAddressdata.city || null,
                state: shippingAddressdata.stateName,
                stateCode: shippingAddressdata.stateCode,
                countryCode: shippingAddressdata.countryCode ? shippingAddressdata.countryCode : shippingAddressdata.country,
                country: shippingAddressdata.countryName ? shippingAddressdata.countryName : countryObj && countryObj.name ? countryObj.name : shippingAddressdata.countryCode ? shippingAddressdata.countryCode : shippingAddressdata.country,
                postalCode: shippingAddressdata.postalCode ? shippingAddressdata.postalCode : null,
                zip: shippingAddressdata.postalCode ? shippingAddressdata.postalCode : null,
                countryId: shippingAddressdata.countryId,
                stateId: shippingAddressdata.stateId,
                name: shippingAddressdata.shipToName,
                firstName: shippingAddressdata.firstName,
                middleName: shippingAddressdata.middleName,
                lastName: shippingAddressdata.lastName,
                addressType: this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ? AddressType.PICKUP_PERSON : AddressType.SHIPPING,
                isShowStateCode: shippingAddressdata.isShowStateCode,
                phone: shippingAddressdata.phone ? this.getValidPhoneNumber(shippingAddressdata.phone) : shippingAddressdata.phoneNumber ? this.getValidPhoneNumber(shippingAddressdata.phoneNumber) : null,
                phoneNumber: shippingAddressdata.phoneNumber ? this.getValidPhoneNumber(shippingAddressdata.phoneNumber) : shippingAddressdata.phone ? this.getValidPhoneNumber(shippingAddressdata.phone) : null,
                countryCodeTwo: this.selectedCountryCodeTwo,
                phoneType: shippingAddressdata.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: shippingAddressdata.deliveryInstruction,
                email: shippingAddressdata.email ? shippingAddressdata.email : null
            };
            return shippingAddress;
        }
        return null;
    };
    OrderPromotionComponent.prototype.getValidPhoneNumber = function (phoneNumber) {
        if (phoneNumber && this.storeDetails && this.storeDetails.foreverDirectEnabled) {
            phoneNumber = phoneNumber.replace(/[a-zA-Z ]/g, '');
            if (phoneNumber.substring(0, 1) !== '+' && phoneNumber.substring(0, 2) !== '00') {
                phoneNumber = '+' + phoneNumber;
            }
        }
        else {
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        return phoneNumber;
    };
    /**
 * Selected Shipping Address
 */
    OrderPromotionComponent.prototype.getBillingAddress = function () {
        var _this = this;
        var countryId = 0;
        if (!this.billingAddressInfo) {
            this.billingAddressInfo = this.paymentComponentSettings.billingAddress || (this.mailingAddress ? this.mailingAddress : (this.shippingAddressInfo ? this.shippingAddressInfo : null));
        }
        if (this.countries && this.billingAddressInfo && !this.billingAddressInfo.countryId) {
            var billingCountry = void 0;
            if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length > 2) {
                billingCountry =
                    this.countries.find(function (x) { return x.isocodeThree.toLowerCase()
                        === _this.billingAddressInfo.countryCode.toLowerCase(); });
            }
            else if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length === 2) {
                billingCountry =
                    this.countries.find(function (x) { return x.isocodeTwo.toLowerCase()
                        === _this.billingAddressInfo.countryCode.toLowerCase(); });
            }
            if (billingCountry) {
                countryId = billingCountry.countryId;
            }
        }
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode ? this.billingAddressInfo.countryCode : this.selectedIsoCountryCode,
            country: this.billingAddressInfo.countryCode ? this.billingAddressInfo.countryCode : this.selectedIsoCountryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    };
    OrderPromotionComponent.prototype.getPickUpAddress = function () {
        if (this.shipMethod && this.shipMethod.pickUpLocation
            && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);
            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
                this.shipMethod.pickUpLocation.country = countryObj.isocodeThree ? countryObj.isocodeThree : '';
                this.shipMethod.pickUpLocation.countryCodeTwo = countryObj.isocodeTwo ? countryObj.isocodeTwo : '';
                this.shipMethod.pickUpLocation.countryCode = countryObj.isocodeThree ? countryObj.isocodeThree : '';
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            this.setPickupAddress = this.shipMethod.pickUpLocation;
            return this.shipMethod.pickUpLocation;
        }
        else {
            return null;
        }
    };
    /**
 *
 * @param shippingMethod
 */
    OrderPromotionComponent.prototype.getShippingMethodWarehouseAddress = function () {
        if (this.shipMethod && this.shipMethod.warehouseAddress) {
            this.shipMethod.warehouseAddress.postalCode = this.shipMethod.warehouseAddress.zip;
            this.shipMethod.warehouseAddress.country = this.shipMethod.warehouseAddress.countryCode;
            return this.shipMethod.warehouseAddress;
        }
    };
    /**
     * Store Ware house Address
     */
    OrderPromotionComponent.prototype.getWarehouseAddress = function () {
        var warehouseAddress = null;
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                country: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: this.storeInfo.warehouseAddress.name ? this.storeInfo.warehouseAddress.name : null
            };
        }
        return warehouseAddress;
    };
    OrderPromotionComponent.prototype.getPurchaseFlowId = function () {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PurchaseFlowType.Retail;
        }
        else {
            return PurchaseFlowType.WholeSale;
        }
    };
    OrderPromotionComponent.prototype.getPriceTypeId = function () {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PriceType.RETAILPRICE;
        }
        else {
            return PriceType.WHOLESALEPRICE;
        }
    };
    /**
     * verifyOrderRules
     * @returns boolean
     */
    OrderPromotionComponent.prototype.verifyOrderRules = function (isBackOrderDate) {
        var valid;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false, cartLimitExceed: false, cartLimitNotReach: false, purchaseLimitExceed: false };
        var monthlyCCValid = false;
        var thresholdCrossed = false;
        var totalPoints = this.calculateTotalPoints();
        var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        var literatureItems = this.getLiteratureItems(this.products);
        valid.purchaseLimitExceed = this.validateMemberMonthlyAmountLimit(totalPoints);
        // changes for order min/max for taxInclusive stores PS2022-1077
        if (this.storeInfo && this.storeInfo.taxInclusive && !this.appConfig.enableVATCalculation) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    this.isOverrideMinimumLimit === true ? valid.cartLimitNotReach = false : valid.cartLimitNotReach = true;
                }
            }
            else if ((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
            }
            else if ((this.isOverrideMinimumLimit && subTotal <= this.orderRules.maxValue) ||
                (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
                if (this.isOverrideMinimumLimit) {
                    valid.cartLimitNotReach = false;
                }
            }
            else {
                thresholdCrossed = true;
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        else {
            thresholdCrossed = true;
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            var maxValue = void 0;
            if (!this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && this.orderRules.monthlyValueType === ValueType.CC) {
                maxValue = this.orderRules.maxCCValue >= this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                maxValue = this.orderRules.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else {
                maxValue = this.orderRules && this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }
            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }
            // Monthly CC override for member
            if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
                var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                var endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if ((this.memberOrderCCInfo && (totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules && this.orderRules.maxCCValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                }
                else {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules.maxCCValue < this.memberCCOverride.cVLimit) &&
                        ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            var details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC);
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    };
    OrderPromotionComponent.prototype.getLiteratureItems = function (products) {
        var _this = this;
        var literatureItems;
        if (products && products.length) {
            literatureItems = products.filter(function (item) { return item.literature; });
            if (this.orderRules && this.orderRules.itemNumbers && this.orderRules.itemNumbers.length) {
                var tripackItems = products.filter(function (item) { return _this.orderRules.itemNumbers.indexOf(+item.itemNumber) > -1; });
                if (tripackItems && tripackItems.length) {
                    literatureItems.push(tripackItems);
                }
            }
        }
        return literatureItems;
    };
    OrderPromotionComponent.prototype.validateMemberMonthlyAmountLimit = function (totalPoints) {
        var purchaseLimitExceed = false;
        var memberOrderRules = this.memberOrderCCInfo;
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE
            && memberOrderRules && (totalPoints + memberOrderRules.actualTotalValue) > this.orderRules.maxValue) {
            purchaseLimitExceed = true;
        }
        return purchaseLimitExceed;
    };
    /**
     * Get total points
     */
    OrderPromotionComponent.prototype.calculateTotalPoints = function () {
        var _totalCV = 0;
        for (var i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    };
    OrderPromotionComponent.prototype.subscribeSaveAddress = function () {
        var _this = this;
        this.messageService.getAddressSaved().subscribe(function (data) {
            if (!_this.address) {
                _this.address = {};
            }
            _this.address.isSavedAddress = data;
        });
    };
    /**
  * on click of checkout
  * @memberof CartComponent
  */
    OrderPromotionComponent.prototype.createOrder = function () {
        var _this = this;
        this.checkMemberAccess();
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP
            && !this.selectedPudoCollectionPoint) {
            return;
        }
        if (this.isWhosaleCheckNotCalculated) {
            this.wholesaleCheckErrorNotifications();
            return;
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this._cacheService.set(CacheKey.CARTUPDATED, 'true');
        if (this.isMemberHasAccessToOrder && !this.upgradeFboLimitExceeded) {
            this.isSubmitted = true;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (this.products && this.products.length) {
                var productIds = this.products.map(function (item) { return item.id; });
                if (productIds && productIds.length) {
                    var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
                        ? this.memberInfo.wholeSaleQualified : false;
                    var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                    var memberTitleId = this.memberInfo && this.memberInfo.memberTitleId;
                    var purchaseFlowType = PurchaseFlows.PERSONAL;
                    if (this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL) {
                        purchaseFlowType = PurchaseFlows.RETAIL;
                    }
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                    if ((this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DELIVERY || this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled)) {
                        this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe(function (products) {
                            _this.outOfStockItems = _this.stockAvailabilityCheck(products);
                            if (_this.outOfStockItems.length) {
                                _this.outOfStockModal.open();
                                _this.isSubmitted = false;
                            }
                            else {
                                _this.submitOrder();
                            }
                        });
                    }
                    else if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP) {
                        // pickup products stock availability check
                        var shipMethodId_2 = this.orderFormGroup.value.shipMethodId;
                        if (shipMethodId_2 && this.shippingMethods) {
                            var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_2; })[0];
                            if (shippingObj && shippingObj.shippingMethodId) {
                                this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                            }
                            else {
                                this.isSubmitted = false;
                            }
                        }
                        else {
                            this.isSubmitted = false;
                            var notification = 'Pickup location not available, Please select.';
                            this._commonService.createNotification('', notification, NotificationType.ERROR);
                        }
                    }
                }
            }
        }
    };
    /**
     * @description To check stock available
     * @date 2019-09-20
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.stockAvailabilityCheck = function (products) {
        var cartProducts = this.products;
        if (cartProducts && products && products.length) {
            var noStockItems_1 = [];
            products.forEach(function (product) {
                var cartItem = cartProducts.find(function (item) { return item.id === product.id; });
                if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    cartItem.stockQuantity = product.stockQuantity;
                    noStockItems_1.push(cartItem);
                }
            });
            return noStockItems_1;
        }
        return [];
    };
    OrderPromotionComponent.prototype.validateThreshold = function () {
        var totalPoints = this.calculateTotalPoints();
        var subTotal = this.calculateItemsSubTotal(this.storeInfo);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0)) <= this.orderRules.maxValue) {
            this.thresholdCrossed = false;
        }
        else if (this.appConfig.displayMinValidation && this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal < this.orderRules.minValue) {
            this.cartLimitExceed = false;
            this.cartLimitNotReach = true;
            this.thresholdCrossed = true;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal <= this.orderRules.maxValue) {
            if (this.appConfig.displayMinValidation) {
                this.cartLimitNotReach = false;
            }
            this.thresholdCrossed = false;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal > this.orderRules.maxValue) {
            this.thresholdCrossed = true;
            this.cartLimitExceed = true;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            var details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC);
            this.cartLimitExceed = details.cartLimitExceed;
            this.thresholdCrossed = details.thresholdCrossed;
            this.memberCCLimitExceeded = details.monthlyCCValid;
            this.monthlyCCValue = details.monthlyCCValue;
            this.cartLimitNotReach = details.cartLimitNotReach;
        }
        else {
            this.thresholdCrossed = (!this.orderRules && this.appConfig.disableRetailOrderRules && (this.memberTypeId === MemberTypeEnum.RETAIL || MemberTypeEnum.GUEST)) ? false : true;
        }
        // Monthly CC override for member
        if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
            var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
            var endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                .format(DateConstants.DateFormat);
            if (this.memberOrderCCInfo) {
                if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                    && (new Date(currentDate) <= new Date(endDate))) {
                    this.thresholdCrossed = true;
                }
                else if ((this.orderRules.maxCCValue < this.memberCCOverride.cVLimit) &&
                    ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                    && (new Date(currentDate) <= new Date(endDate))) {
                    this.thresholdCrossed = false;
                }
            }
        }
    };
    OrderPromotionComponent.prototype.pickupStockAvailabilityCheck = function (productIds, pickUpLocationId) {
        var _this = this;
        var noStockItems = [];
        var cartProducts = this.products;
        if (pickUpLocationId && pickUpLocationId > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(pickUpLocationId, productIds).subscribe(function (response) {
                var posProducts = response;
                if (posProducts && posProducts.length > 0) {
                    posProducts.forEach(function (pickUpProduct) {
                        var cartProduct = cartProducts.find(function (product) { return product.id === pickUpProduct.productId; });
                        if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                            cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                            noStockItems.push(cartProduct);
                        }
                    });
                }
                _this.outOfStockItems = noStockItems;
                if (_this.outOfStockItems && _this.outOfStockItems.length > 0) {
                    _this.outOfStockModal.open();
                    _this.isSubmitted = false;
                }
                else {
                    _this.submitOrder();
                }
            }, function (error) {
                var notification = _this._translatePipe.get('orderdetails.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isSubmitted = false;
            });
        }
    };
    OrderPromotionComponent.prototype.closeOutOfStockForm = function () {
        this.outOfStockModal.close();
        this.isSubmitted = false;
    };
    OrderPromotionComponent.prototype.submitOrder = function (url) {
        this.isSubmitted = true;
        if (this.address && !this.address.isSavedAddress && this.orderFormGroup.value.saveForFutureUse) {
            if (!(this.shippingAddressInfo && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP)) {
                this.saveAddress(this.getShippingAddress());
            }
        }
        if (this.appConfig.enablePaymentReferenceNumber) {
            if (this.paymentReferenceNumber.value.referenceNumber) {
                this.paymentComponentSettings.authorizationCode = this.paymentReferenceNumber.value.referenceNumber;
            }
        }
        var requestUrl = '';
        this.isSubmitted = true;
        this.isnewcardAdded = false;
        requestUrl = url || ApiUrlConstants.orderApiUrl + '/V1/orders';
        if (this.orderFormGroup.valid) {
            if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                var isBackDateOrder = this.orderFormGroup.value.backDateOrder;
                this.getMemberOrderRules(this.memberInfo, isBackDateOrder, requestUrl);
            }
            else {
                this.validateThreshold();
                this.placeOrder(requestUrl);
            }
        }
    };
    /**
     * @description Clear the out of stock items and update the tax
     * @date 2019-09-25
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.clearOutOfStockItems = function () {
        var items = this.orderFormGroup.get('items');
        if (this.outOfStockItems && this.outOfStockItems.length) {
            var productIds = this.outOfStockItems.map(function (product) { return product.id; });
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    };
    /**
     * @description Remove out of stock items from cart items
     * @date 2019-09-25
     * @param {FormArray} items
     * @param {number[]} productIds
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.removeOutOfStockItems = function (items, productIds) {
        productIds.forEach(function (id) {
            var productIndex = items.value.findIndex(function (product) { return product.productId === id; });
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    };
    /**
     * @description submit enrollment
     * @date 2019-09-05
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.submitEnrollment = function () {
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            this._enrollmentMessageService.setSubmitGuestForm(true);
        }
        else if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            this._enrollmentMessageService.setSubmitPersonalInfoForm(true);
        }
        if (this.appConfig.enablePaymentReferenceNumber) {
            if (this.paymentReferenceNumber.value.referenceNumber) {
                this.paymentComponentSettings.authorizationCode = this.paymentReferenceNumber.value.referenceNumber;
            }
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this.isSubmitted = true;
        if (this.agreementCheck && ((this.guestFormValidated && this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL))) {
            this.isnewcardAdded = false;
            this.processEnrollMember();
        }
        else if (this.personalInfoFormValid && this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL
            && this.agreementCheck && this.personalInformation && this.sponsorInformation
            && this.mailingAddress) {
            this.isnewcardAdded = false;
            this.placeEnrollRequest();
        }
    };
    /**
     * @description this method will load sponsor
     * based on sponsorid if we don't have sponsor info
     * @date 2019-09-10
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.processEnrollMember = function () {
        if (this.shippingAddressInfo || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP && this.selectedPudoCollectionPoint) || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP)) {
            if (this.rebindSponsorData && this.rebindSponsorData.selectedWizard === SponsorWizardSearchType.SearchByIKnowSponsor
                && !this.sponsorInformation) {
                this.isSubmitted = false;
                this._enrollmentMessageService.setIsSponsorInfoSelected(false);
            }
            else if (this.retuningGuestUser) {
                this.submitOrder();
            }
            else if ((this.sponsorConfig
                && this.sponsorConfig.loadSponsorWizardInGuestFlow && this.sponsorInformation) || (this.isEnableFboReferralId())) {
                this.placeEnrollRequest();
            }
            else {
                //if(this.appConfig.useAnonymousRetailFboId) {
                this.getBusinessEntityByHomeCountryCode(this.storeInfo.homeIsocodeThree);
                //} else {
                //this.getSponsorInfoByReferralOrAutoSuggest();
                //}
            }
        }
    };
    /**
     * @description this method is used
     * to get selected sponsorinfo from sposor component
     * @date 2019-09-18
     * @memberof PersonalInfoComponent
     */
    OrderPromotionComponent.prototype.getSelectedSponserInfo = function (sponsorInformation) {
        this.sponsorInformation = sponsorInformation;
        if (this.sponsorInformation) {
            this.isSubmitted = false;
        }
        else {
            this.isSubmitted = true;
        }
    };
    OrderPromotionComponent.prototype.pudoAddressInputChange = function (address) {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
            }
        }
    };
    /**
     * @description this method will fire when we chaneg textbox value
     * in address block
     * @date 2018-08-20
     * @memberof PersonalInfoComponent
     */
    OrderPromotionComponent.prototype.getAddressOnInputChange = function (address) {
        if (!this.sponsorInformation) {
            this.liveFormAddress = address;
            this._enrollmentMessageService.setSponsorPreference(this.liveFormAddress);
        }
        if (this.mailingAddress && !this.shippingAddressInfo) {
            this.prepopulateShippingAddress();
        }
    };
    OrderPromotionComponent.prototype.addressChangedByUser = function (changed) {
        this.shippingAddressChanged = changed;
        if (changed) {
            this.selectedPudoCollectionPoint = null;
        }
    };
    /**
     * @description this method will prepopulate shipping address
     * @date 2019-09-10
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.prepopulateShippingAddress = function () {
        var _this = this;
        if (this.appConfig && this.appConfig.skipAddressVerification && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
        var address = this.mailingAddress;
        if (this.liveFormPersonalInfo) {
            address.firstName = this.liveFormPersonalInfo.firstName;
            address.lastName = this.liveFormPersonalInfo.lastName;
            address.middleName = this.liveFormPersonalInfo.middleName;
            address.email = this.liveFormPersonalInfo.email;
            address.phoneNumber = this.liveFormPersonalInfo.phoneNumber;
            address.phoneType = this.liveFormPersonalInfo.phoneType;
        }
        this.address = address;
        this.showAddressForm = false;
        this.displayPudoAddress = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        setTimeout(function () {
            _this.address = _this.address;
            _this.showAddressForm = true;
            _this.pudoAddress = _this.address;
            _this.pudoShippingAddressInfo = _this.address;
            _this.displayPudoAddress = true;
            if (_this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.DROPSHIP) {
                _this.getPudoLocations();
            }
        }, 500);
    };
    /**
     * @description this method will load sponsor
     * based on sponsorid if we don't have sponsor info
     * @date 2019-09-10
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getSponsorInfoByReferralOrAutoSuggest = function (sponsorId, enableFboReferralId, isSponsorsearch) {
        var _this = this;
        if ((this.personalInformation || this.memberInfo) || enableFboReferralId) {
            var sponsorSearchRequest_1 = this.searchSponsorRequest(sponsorId);
            if (sponsorSearchRequest_1) {
                this.sponsorPollCount = 0;
                this._commonService
                    .searchSponsors(sponsorSearchRequest_1)
                    .subscribe(function (sponsorSearchResponse) {
                    if (_this.sponsorPollCount < _this.sponsorMaxPollCount) {
                        _this.sponsorPollCount = _this.sponsorPollCount + 1;
                        if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                            _this.processSearchSponsorResponse(sponsorSearchResponse, sponsorId, isSponsorsearch, null, sponsorSearchRequest_1.Option);
                        }
                        else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                            sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                            setTimeout(function () {
                                _this.searchSponsorByPolling(sponsorSearchResponse, sponsorId, isSponsorsearch, sponsorSearchRequest_1.Option);
                            }, 2000);
                        }
                        else {
                            _this.isSponsorFound = false;
                            _this.displayErrorMessage(null);
                        }
                    }
                    else {
                        _this.isSponsorFound = false;
                        _this.displayErrorMessage(null);
                    }
                }, function (errResponse) {
                    _this.displayErrorMessage(errResponse);
                    _this.isSponsorFound = false;
                });
            }
            else {
                this.isSponsorFound = false;
                this.displayErrorMessage(null);
            }
        }
        else {
            this.isSponsorFound = false;
            this.displayErrorMessage(null);
        }
    };
    /**
     * @description this method will help
     * to close progress bar once done with request
     * @date 2018-08-17
     * @private
     * @memberof CheckoutNewComponent
     */
    OrderPromotionComponent.prototype.displayErrorMessage = function (errResponse) {
        this.isSubmitted = false;
        this.fieldErrors = [];
        if (!this.isSponsorFound && !this.sponsorInformation) {
            var notification = this._translatePipe.get('order.Sponsor not found');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (errResponse && (errResponse.validations && errResponse.validations.length > 0
            || errResponse.length > 0)) {
            this.fieldErrors = errResponse.validations || errResponse;
        }
    };
    /**
     *  Generate Request for sponsor request
     *  generateSponsorRequest
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.searchSponsorRequest = function (sponsorId) {
        var _this = this;
        var sponsorSearchRequest;
        if (sponsorId) {
            sponsorId = sponsorId.indexOf('@') > -1 ? sponsorId : sponsorId.split('-').join('');
            sponsorSearchRequest = {
                UserName: sponsorId.indexOf('@') > -1 ? '' : sponsorId.trim(),
                Email: sponsorId.indexOf('@') > -1 ? sponsorId.trim() : '',
                FirstName: '',
                LastName: '',
                CountryId: '',
                PreferenceValue: '',
                PostalCode: '',
                StateId: '',
                City: '',
                Option: SponsorSearchOption.SearchByIKnowSponsor,
                EnableLongPoll: environment.enableLongPoll,
                Store: this.countryCode
            };
        }
        else if (this.shippingAddressInfo) {
            var shippingAddress = this.shippingAddressInfo;
            var language = this.storeInfo.languages.find(function (x) { return x.cultureName.toLowerCase()
                === _this.orderFormGroup.value.language.toLowerCase(); });
            sponsorSearchRequest = {
                UserName: '',
                Email: '',
                FirstName: '',
                LastName: '',
                StateId: shippingAddress && shippingAddress.stateId ? String(shippingAddress.stateId) : '',
                City: this.sponsorConfig && this.sponsorConfig.sponsorCityFieldRequired ? shippingAddress.city : '',
                CountryId: String(shippingAddress.countryId),
                CountryCode: shippingAddress.countryCode ? shippingAddress.countryCode : shippingAddress.country,
                PreferenceValue: language ? String(language.languageId) : '',
                PostalCode: shippingAddress.postalCode,
                Option: this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea ?
                    SponsorSearchOption.SearchByArea : SponsorSearchOption.SearchByIDontHaveSponsor,
                EnableLongPoll: environment.enableLongPoll,
                Store: this.countryCode
            };
        }
        return sponsorSearchRequest;
    };
    /**
   * @description we will load sponsor by pooling mechanism
   * @date 2019-09-10
   * @private
   * @param {SponsorSearchRequest} sponsorSearchRequest
   * @param {number} [searchOption]
   * @memberof OrderPromotionComponent
   */
    OrderPromotionComponent.prototype.searchSponsorByPolling = function (searchResponse, sponsorId, isSponsorSearch, searchOption) {
        var _this = this;
        this._commonService
            .getSearchSponsorsByUUID(searchResponse)
            .subscribe(function (sponsorSearchResponse) {
            if (sponsorSearchResponse) {
                if (_this.sponsorPollCount < _this.sponsorMaxPollCount) {
                    _this.sponsorPollCount = _this.sponsorPollCount + 1;
                    if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                        _this.processSearchSponsorResponse(sponsorSearchResponse, sponsorId, isSponsorSearch, null, searchOption);
                    }
                    else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                        sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(function () {
                            _this.searchSponsorByPolling(sponsorSearchResponse, sponsorId, isSponsorSearch, searchOption);
                        }, 2000);
                    }
                    else {
                        _this.isSponsorFound = false;
                        _this.displayErrorMessage(null);
                    }
                }
                else {
                    _this.isSponsorFound = false;
                    _this.displayErrorMessage(null);
                }
            }
        }, function (error) {
            _this.isSponsorFound = false;
            _this.displayErrorMessage(null);
        });
    };
    /**
     * @description this method will process sponsor response
     * @date 2019-09-10
     * @private
     * @param {SponsorSearchResponse} sponsorSearchResponse
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.processSearchSponsorResponse = function (sponsorSearchResponse, sponsorId, isSponsorSearch, anonymousSponsorSearch, searchOption) {
        var _this = this;
        if ((sponsorSearchResponse && sponsorSearchResponse.sponsorSearchResultModels
            && sponsorSearchResponse.sponsorSearchResultModels.length > 0) || (anonymousSponsorSearch && anonymousSponsorSearch.length > 0)) {
            if (sponsorSearchResponse && sponsorSearchResponse.sponsorSearchResultModels
                && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
                if (sponsorId) {
                    this.sponsorInformation = sponsorSearchResponse.sponsorSearchResultModels
                        .find(function (x) { return x.sponsorId === sponsorId; });
                    if (!this.sponsorInformation) {
                        this.sponsorInformation = sponsorSearchResponse.sponsorSearchResultModels[0];
                    }
                }
                else {
                    this.sponsorInformation = sponsorSearchResponse.sponsorSearchResultModels[0];
                }
                if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                    this.fboReferralId = this.businessEntityDetails.anonymousRetailFboId;
                }
                this.sponsorInformation.uuid = sponsorSearchResponse.uuid;
            }
            else if (anonymousSponsorSearch && anonymousSponsorSearch.length > 0) {
                if (sponsorId) {
                    this.sponsorInformation = anonymousSponsorSearch
                        .find(function (x) { return x.sponsorId === sponsorId; });
                    if (!this.sponsorInformation) {
                        this.sponsorInformation = anonymousSponsorSearch[0];
                    }
                }
                else {
                    this.sponsorInformation = anonymousSponsorSearch[0];
                }
                if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                    this.fboReferralId = this.businessEntityDetails.anonymousRetailFboId;
                }
            }
            this.sponsorInformation
                .sponsorAssignedOptionId = SponsorSearchOption.SearchBySuggestSponsor;
            // Display 'sponsor not found' sponsorid is not empty and corresponding sponsor not found.
            if (this.sponsorInformation) {
                this.sponsorInformation.address = this._commonService
                    .mapAddressModel(this.sponsorInformation);
                this.isSponsorFound = true;
                if (!this.isEnableFboReferralId()) {
                    if (!isSponsorSearch) {
                        this.placeEnrollRequest();
                    }
                }
                else {
                    if (sponsorId) {
                        this._sponsorService.sponsorEligibilityCheck(this.fboReferralId, this.storeInfo.operatingCountry, searchOption).subscribe(function (sponsorSearchResponse) {
                            if (sponsorSearchResponse && (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                                sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS)) {
                                _this.sponsorPollCount = 0;
                                setTimeout(function () {
                                    _this.getSponsorEligibilty(sponsorSearchResponse);
                                }, 3000);
                            }
                            if (!isSponsorSearch) {
                                _this.placeEnrollRequest();
                            }
                        }, function (error) {
                            if (_this.businessEntityDetails && _this.businessEntityDetails.anonymousRetailFboId) {
                                _this.fboReferralId = null;
                            }
                            _this.isSponsorFound = false;
                            _this.displayErrorMessage(null);
                            _this.sponsorInformation = null;
                        });
                    }
                    else {
                        if (!isSponsorSearch) {
                            this.placeEnrollRequest();
                        }
                    }
                }
            }
            else {
                this.isSponsorFound = false;
                this.displayErrorMessage(null);
            }
        }
        else {
            this.isSponsorFound = false;
            this.displayErrorMessage(null);
        }
    };
    /**
     * @description this method will process member
     * enrollment request
     * @date 2019-09-10
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.placeEnrollRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var itemNumber, revisionNumber, new_RevisionNumber, subTotal, maximumCartLimit, maxValue, cartMaximumLimitNotification, exceedPerOrderCC, isLiteratureValidation, invalidProductPopup, totalPoints, exceedPerOrderCC, enrollRequest, notification, notification, compareTaxValues, isOptin_1, recentlyViewedProducts, isProductRevisionNumberMatch_1, memberId_1, transliteratedProps, transliteratedProps, notification, notification, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subTotal = this.calculateItemsSubTotal(this.storeInfo);
                        if (this.storeInfo && this.storeInfo.taxInclusive) {
                            subTotal = this.itemTotal;
                        }
                        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
                            subTotal > this.orderRules.maxValue && (!this.orderRules.validateProductTypes || this.orderRules.validateProductTypes === null)) {
                            if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                                maximumCartLimit = this._translatePipe.get('order.Cart must not exceed');
                                maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
                                cartMaximumLimitNotification = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                                    maxValue + '</b>';
                                this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }
                            else {
                                exceedPerOrderCC = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.', { max: this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue + '.00' || '0', this.storeInfo) });
                                this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }
                            this.isSubmitted = false;
                            return [2 /*return*/];
                        }
                        else {
                            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                        }
                        if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                            isLiteratureValidation = this.isLiteratureValidation(this.products);
                            invalidProductPopup = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}', {
                                min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo),
                                max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue, this.storeInfo)
                            });
                            if (this.validateSubTotalBasedOnType(this.products, subTotal)) {
                                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                this.isSubmitted = false;
                                return [2 /*return*/];
                            }
                        }
                        else {
                            this._commonService.removeNotification(Constants.MIN_LIMIT);
                        }
                        totalPoints = this.calculateTotalPoints();
                        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
                            (totalPoints > this.orderRules.maxValue) &&
                            (this.memberTypeId === MemberTypeEnum.RETAIL ||
                                this.memberTypeId === MemberTypeEnum.GUEST)) {
                            exceedPerOrderCC = this._translatePipe.get('order.Retail Max Order limit reached');
                            this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.RETAIL_LIMIT);
                            this.isSubmitted = false;
                            return [2 /*return*/];
                        }
                        else {
                            this._commonService.removeNotification(Constants.RETAIL_LIMIT);
                        }
                        enrollRequest = this.prepareEnrollSessionRequest();
                        if (enrollRequest && enrollRequest.enrollInfo && enrollRequest.enrollInfo.orderInfo && (enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == null || enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == undefined)) {
                            notification = this._translatePipe.get('order.Please Select shipping method.');
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                        }
                        if (!enrollRequest.enrollInfo.orderInfo.taxMetaData && this.isTaxMetaDataAvailable) {
                            notification = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                            return [2 /*return*/];
                        }
                        compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(enrollRequest.enrollInfo.orderInfo);
                        if (!compareTaxValues) return [3 /*break*/, 3];
                        isOptin_1 = this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.FPC && this.optInCheck;
                        if (!(this.retuningGuestUser || (this.personalInformation &&
                            (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
                                || this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL)) || isOptin_1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getRecentlyviewedProducts(enrollRequest.enrollInfo.orderInfo)];
                    case 1:
                        recentlyViewedProducts = _a.sent();
                        isProductRevisionNumberMatch_1 = true;
                        if (recentlyViewedProducts) {
                            if (recentlyViewedProducts && recentlyViewedProducts.length > 0) {
                                recentlyViewedProducts.forEach(function (recentProduct) {
                                    enrollRequest.enrollInfo.orderInfo.orderLineItems.forEach(function (product) {
                                        if (product.revisionNumber === recentProduct.revisionNumber) {
                                        }
                                        else {
                                            isProductRevisionNumberMatch_1 = false;
                                            itemNumber = product.itemNumber;
                                            revisionNumber = product.revisionNumber;
                                            new_RevisionNumber = recentProduct.revisionNumber;
                                            return;
                                        }
                                    });
                                });
                            }
                        }
                        if (isProductRevisionNumberMatch_1) {
                            if ((isOptin_1) || (this.retuningGuestUser && this.personalInformation
                                && this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL)) {
                                memberId_1 = this.getEnrollmentMemberId();
                                transliteratedProps = this._commonService.mapTransliterateProperties(this.storeDetails, this.orderFormGroup.get('language').value);
                                this._enrollService.updateEnrollment(enrollRequest.enrollInfo, memberId_1, transliteratedProps).subscribe(function (response) {
                                    if (response) {
                                        if (isOptin_1) {
                                            _this.updateAutoshipProfile(memberId_1);
                                            _this.fboUpgradeSuccess(response);
                                        }
                                        else {
                                            _this.enrollmentSuccess(response);
                                        }
                                    }
                                });
                            }
                            else {
                                if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                                    enrollRequest.enrollInfo.orderInfo.addresses.forEach(function (x) {
                                        if (!(x.addressType === AddressType.PICKUP_PERSON || x.addressType === AddressType.PUDO || x.addressType === AddressType.BILLING)) {
                                            _this.verifyPudoAddress = false;
                                        }
                                    });
                                }
                                transliteratedProps = this._commonService.mapTransliterateProperties(this.storeDetails, this.orderFormGroup.get('language').value);
                                if (this.verifyPudoAddress) {
                                    this._enrollService.createEnrollRequest(enrollRequest.enrollInfo, transliteratedProps).subscribe(function (retailResponse) {
                                        if (retailResponse && retailResponse.validations && retailResponse.validations.length > 0) {
                                            if (retailResponse.personalInfo && retailResponse.personalInfo.memberId
                                                && retailResponse.personalInfo.distributorId
                                                && retailResponse.personalInfo.memberTypeId === MemberTypeEnum.GUEST && retailResponse.orderInfo
                                                && retailResponse.orderInfo.memberTypeId === retailResponse.personalInfo.memberTypeId) {
                                                var retuningGuestUser = _this._enrollService.mapAccountResponseToUserInfo(retailResponse.personalInfo);
                                                _this.retuningGuestUser = retuningGuestUser;
                                                _this.submitOrder();
                                            }
                                            else if (retailResponse.personalInfo && retailResponse.personalInfo.memberId
                                                && retailResponse.personalInfo.distributorId
                                                && retailResponse.personalInfo.memberTypeId === MemberTypeEnum.GUEST && retailResponse.orderInfo
                                                && retailResponse.orderInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                                                var retuningGuestUser = _this._enrollService.mapAccountResponseToUserInfo(retailResponse.personalInfo);
                                                _this.retuningGuestUser = retuningGuestUser;
                                                _this.placeEnrollRequest();
                                            }
                                            else {
                                                _this.isSubmitted = false;
                                                _this.retuningGuestUser = null;
                                                _this.mailAlreadyExist = true;
                                                _this._enrollmentMessageService.setIsEmailAlreadyExists(true);
                                                _this._commonService.createNotification('', retailResponse.validations[0].message, NotificationType.ERROR);
                                            }
                                        }
                                        else {
                                            _this.enrollmentSuccess(retailResponse);
                                        }
                                    }, function (errorResponse) {
                                        _this.displayErrorMessage(errorResponse);
                                    });
                                }
                                else {
                                    notification = this._translatePipe.get('order.Unable to Place the Order');
                                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    this.isSubmitted = false;
                                }
                            }
                        }
                        else {
                            notification = this._translatePipe.get('order.Product revision number miss match, ' + 'Item : ' + itemNumber + ', Revision Number : ' + revisionNumber + ', New Revision Number : ' + new_RevisionNumber);
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                        }
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        notification = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                        this.isSubmitted = false;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @description To get update member Id
     * @date 2019-10-04
     * @returns {number}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getEnrollmentMemberId = function () {
        var memberId;
        if (this.retuningGuestUser) {
            memberId = this.retuningGuestUser.memberId;
        }
        else if (this.memberInfo) {
            memberId = this.memberInfo.memberId;
        }
        return memberId;
    };
    /**
     * @description To handle FBO Upgrade success response
     * @date 2019-10-04
     * @private
     * @param {EnrollInfo} response
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.fboUpgradeSuccess = function (response) {
        this.document.documentElement.classList.remove('optin-popup');
        this.updateMemberLevelPopup.close();
        this.saveMemberUpgradeActivityLog(this.memberInfo.memberId, MemberActivityLogType.Upgraded_flag);
        this.displayOrderSuccessDetails(response);
    };
    /**
     * @description To Handle create/update enrollment success response
     * @date 2019-10-04
     * @private
     * @param {EnrollInfo} retailResponse
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.enrollmentSuccess = function (retailResponse) {
        var _this = this;
        if (retailResponse && retailResponse.personalInfo && retailResponse.personalInfo.memberId) {
            var key = this.orderFormGroup.value.orderType === MemberActivityLogType.New_Guest_Retail_Created
                ? MemberActivityLogType.New_Guest_Retail_Created : MemberActivityLogType.New_Retail_Created;
            this.saveMemberUpgradeActivityLog(retailResponse.personalInfo.memberId, key);
        }
        setTimeout(function () {
            _this.displayOrderSuccessDetails(retailResponse);
        }, 2000);
    };
    /**
     * @description This methos used to save member activity log
     * while upgrading from fpc to fbo
     * @date 2019-09-13
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.saveMemberUpgradeActivityLog = function (memberId, key) {
        var activityLogKeys = [];
        if (key === MemberActivityLogType.Upgraded_flag) {
            activityLogKeys.push({
                key: MemberActivityLogType.MemberLevel_change,
                value: UserTitleType.ASSISTANTSUPERVISOR
            });
        }
        else if (key === MemberActivityLogType.Override_Minimum_Limit) {
            activityLogKeys.push({
                key: MemberActivityLogType.Override_Minimum_Limit,
                value: Constants.OVERRIDE_MINIMUM_LIMIT
            });
        }
        else {
            activityLogKeys.push({
                key: key,
                value: this.prepareMemberUpgradeActivityLogValue()
            });
        }
        this._commonService.saveMemberActivity(memberId, activityLogKeys).subscribe();
    };
    /**
     * @description This methos used for prepare activity log value
     * while creating from new guest/ fpc upgrade
     * @date 2019-09-13
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.prepareMemberUpgradeActivityLogValue = function () {
        var logValue = '';
        if (this.agreementDocuments) {
            this.agreementDocuments.forEach(function (x) {
                logValue = logValue + x.displayName + ', ';
            });
        }
        logValue = logValue ? logValue.substring(0, logValue.length - 2) + '.' : logValue;
        return logValue;
    };
    OrderPromotionComponent.prototype.updatePrivacyPreference = function () {
        if ((!this.guestToRetailMember) && this.retuningGuestUser && this.retuningGuestUser.memberId && this.retuningGuestUser.memberPreferences && this.appConfig && this.appConfig.enablePrivacyPreference) {
            this._enrollService.updatePrivacyPreference(this.retuningGuestUser.memberPreferences, this.retuningGuestUser.memberId);
        }
    };
    /**
     * @description this method will display order details
     * @date 2019-09-10
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.displayOrderSuccessDetails = function (retailResponse) {
        var shippingLogInfo = this.getShippingLogInfo();
        if (retailResponse && retailResponse.orderInfo && retailResponse.orderInfo.webOrderId) {
            retailResponse.webOrderId = retailResponse.orderInfo.webOrderId;
            retailResponse.id = retailResponse.orderInfo.id;
            if (shippingLogInfo) {
            }
            this.orderSuccess(retailResponse);
            this.isSubmitted = false;
        }
    };
    /**
     * @description
     * @date 2019-09-10
     * @private
     * @returns {EnrollSession}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.prepareEnrollSessionRequest = function () {
        var memberMailingAddress;
        if (this.optInCheck && this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
            this.personalInformation = this._enrollService.getOptInPersonalInfo(this.memberInfo, this.legalRequirements, this.memberInfo.memberContacts);
            memberMailingAddress = this.memberInfo.address;
        }
        if (this.sponsorInformation && this.orderFormGroup.value.orderType === OrderType.NEW_RETAIL) {
            this.sponsorInformation.memberCommunicationPreferences = this.memberCommunicationPreferences;
        }
        var enrollSession = {
            enrollInfo: {
                personalInfo: this._enrollService.preparePersonalInfo(this.storeInfo, this.orderFormGroup.value.language || this.storeDefaultLanguage, this.personalInformation, this.shippingAddressInfo, this.countryCode, this.orderFormGroup.value.countryId, this.sponsorInformation, this.bonusInfoAgreements, this.memberInfo, this.memberTypeId, this.legalRequirements, this.mailingAddress, memberMailingAddress, null, this.bonusInformation, null, null, this.businessInformation),
                orderInfo: this.prepareOrderRequest(),
                shoppingCartInfo: null,
                sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : '',
                sponsorInfo: this.sponsorInformation
            },
            sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : ''
        };
        if (this.showOptin && enrollSession && enrollSession.enrollInfo.personalInfo &&
            enrollSession.enrollInfo.personalInfo.memberContacts && enrollSession.enrollInfo.personalInfo.memberContacts.length) {
            var mobile = enrollSession.enrollInfo.personalInfo.memberContacts.find(function (x) { return x.contactTypeID === ContactTypeValue.MOBILE; });
            if (!mobile) {
                var homePhone = this.memberInfo.memberContacts.find(function (x) { return x.contactTypeID === ContactTypeValue.MOBILE; });
                if (homePhone) {
                    enrollSession.enrollInfo.personalInfo.memberContacts.push(homePhone);
                }
            }
            var phone = enrollSession.enrollInfo.personalInfo.memberContacts.find(function (x) { return x.contactTypeID === ContactTypeValue.PHONE; });
            if (!phone) {
                var homePhone = this.memberInfo.memberContacts.find(function (x) { return x.contactTypeID === ContactTypeValue.PHONE; });
                if (homePhone) {
                    enrollSession.enrollInfo.personalInfo.memberContacts.push(homePhone);
                }
            }
        }
        var sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid);
        if (sessionGuid && enrollSession && enrollSession.enrollInfo.personalInfo) {
            enrollSession.enrollInfo.personalInfo.sessionGuid = sessionGuid;
        }
        return enrollSession;
    };
    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getGuestPersonalInfo = function (event) {
        this.personalInformation = event.personalInformation;
        this.guestFormValidated = event.guestPersonalInfoFormValidated;
        this.retuningGuestUser = event.userInfo;
        this.mailAlreadyExist = event.personalInformation.mailAlreadyExist;
    };
    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getPersonalInfo = function (event) {
        this.personalInformation = event.personalInformation;
        this.personalInfoFormValid = event.personalInfoFormValid;
        this.retuningGuestUser = event.userInfo;
    };
    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getGuestPersonalInfoFormStatus = function (personalInfo) {
        var _this = this;
        if (!this.shippingAddressInfo) {
            var address_2 = personalInfo;
            if (this.countryCode) {
                var countryCode = this.countries.find(function (x) { return x.isocodeThree === _this.countryCode; });
                this.countryID = countryCode.countryId;
            }
            address_2.countryId = this.countryID;
            this.address = address_2;
            this.showAddressForm = false;
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                    + environment.templateVersion;
            }
            else {
                this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                    + environment.templateVersion;
            }
            /*     this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                     + environment.templateVersion;*/
            setTimeout(function () {
                _this.address = address_2;
                _this.showAddressForm = true;
            }, 200);
            this.emailForm.controls['payByLinkEmail'].setValue(address_2.email);
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            }
            else {
                this.isPayByLinkValid = false;
            }
        }
    };
    /**
     * @description get mail already exists or not
     * @date 2019-10-14
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getMailAlreadyExixts = function (event) {
        this.mailAlreadyExist = event;
    };
    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getPersonalInfoFormStatus = function (event) {
        this.personalInfoFormValid = event.personalInfoFormValid;
        this.liveFormPersonalInfo = event.personalInformationForm.value;
    };
    /**
     * @description  this method is used to
     * get the verified or sugggested address
     * @date 2019-09-18
     * @param {Address} mailingAddress
     * @memberof PersonalInfoComponent
     */
    OrderPromotionComponent.prototype.getMailingAddressInfo = function (address) {
        this.mailingAddress = address;
        this.getAddressOnInputChange(address);
    };
    /**
     * @description to rebind the selected sponsor wizard options and values
     * @date 2019-09-21
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.rebindSponsorOptions = function (rebindSponsorData) {
        this.rebindSponsorData = rebindSponsorData;
    };
    /**
     * @description
     * @date 2021-02-01
     */
    OrderPromotionComponent.prototype.validateOrderLimit = function (quantityUpdate) {
        var _this = this;
        if (!this.orderRules) {
            return;
        }
        var exceedMonthlyCCPopup = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        var exceedMonthlyCCOverridePopup = this._translatePipe
            .get('order.Monthly CC limit reached');
        var orderRulesMaxValue = this.orderRules && this.orderRules.maxValue ? this.orderRules.maxValue : this.orderRules.literatureMaxValue;
        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(((this._commonService.validateNumberDecimalPoint(orderRulesMaxValue) ? orderRulesMaxValue : orderRulesMaxValue + '.00') || '0'), this.storeInfo);
        var exceedPerOrderCC = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.', { max: maxValue });
        var minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum of');
        var maximumCartLimit = this._translatePipe.get('order.Cart must not exceed');
        if (this.thresholdCrossed && this.orderRules && this.orderRules.valueType !== ValueType.BOTH) {
            if (this.cartLimitExceed) {
                var maxValue_1 = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
                var cartMaximumLimitNotification = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    maxValue_1 + '</b>';
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberInfo && this.memberInfo.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                if (this.appConfig.displayMinValidation && this.memberInfo && (this.memberTypeId === MemberTypeEnum.RETAIL || this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                this.isSubmitted = false;
            }
            else if (this.cartLimitNotReach && !quantityUpdate) {
                if (this.products && this.products.length &&
                    this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                    && this.appConfig.displayPurchaseLimitationMessage
                    && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                    minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                }
                if (this.overrideMinimumLimitIsEnabled) {
                    var overrideLimitLink = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                    var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                    var cartMinimumLimitNotification_3 = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                    this.cartMessageID = setTimeout(function () {
                        var toast = _this._commonService.createNotification('', cartMinimumLimitNotification_3, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                        toast.click.subscribe(function (event) {
                            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                _this.overrideMinimumLimit.open();
                            }
                        });
                    }, 100);
                }
                else {
                    var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                    var cartMinimumLimitNotification = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>';
                    this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                }
                this.isSubmitted = false;
            }
            else {
                this._commonService.removeNotification(Constants.MIN_LIMIT);
                this._commonService.removeNotification(Constants.MAX_EXCEEDED);
            }
        }
        else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded) {
            var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
            var endDate = this.memberCCOverride && this.memberCCOverride.effectiveEndDate ? this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                .format(DateConstants.DateFormat) : null;
            var monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + ((this.memberCCOverride && this.memberCCOverride.cVLimit && (new Date(currentDate) <= new Date(endDate))) ? this.memberCCOverride.cVLimit : this.monthlyCCValue) + '</b>';
            if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                if (this.memberCCLimitExceeded) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR);
                }
                if ((this.cartLimitExceed || this.cartLimitNotReach) && !quantityUpdate) {
                    var isLiteratureValidation = this.isLiteratureValidation(this.products);
                    var invalidProductPopup = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}', {
                        min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo),
                        max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue, this.storeInfo)
                    });
                    this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
                else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            }
            else if (!this.appConfig.displayPurchaseLimitationMessage) {
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
                else {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
            }
            else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
            this.isSubmitted = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            var monthlyCCOverrideContent = exceedMonthlyCCOverridePopup.value + ' <b class="helvetica-bold">'
                + this.memberCCOverride.cVLimit + ' CC</b>';
            this._commonService.createNotification('', monthlyCCOverrideContent, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isSubmitted = false;
        }
        else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
        if (this.checkoutConfig.enableMonthlyCCLimitRules) {
            var totalPoints = this.calculateTotalPoints();
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            ;
            if (this.orderRules && totalCC > this.orderRules.maxCCValue && this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                var exceedMonthlyCCPopup_1 = this._translatePipe
                    .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                var monthlyCCContent = exceedMonthlyCCPopup_1.value + ' <b class="helvetica-bold">' + (this.memberCCOverride && this.memberCCOverride.cVLimit ? this.memberCCOverride.cVLimit : this.orderRules.maxCCValue) + '</b>';
                this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                this.isSubmitted = false;
            }
            else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
        }
    };
    /**
     * @description place order
     * @date 2019-05-21
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.placeOrder = function (requestUrl) {
        this.validateOrderLimit(false);
        var currentCC = this.calculateTotalPoints();
        if ((((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo))
            || (!currentCC && this.orderRules.valueType !== ValueType.BOTH)) {
            var availableCC = this.existingCC ? this.existingCC - currentCC
                : this.distributorMaxCC - currentCC;
            var memberHomeCountry = this.memberInfo && this.memberInfo.memberAllowedCountries && this.memberInfo.memberAllowedCountries.length
                ? this.memberInfo.memberAllowedCountries.find(function (country) { return country.homeCountry === true; }) : null;
            var isMemberHomeCountry = memberHomeCountry && this.selectedIsoCountryCode === memberHomeCountry.isoCodeThree ? true : false;
            if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER && isMemberHomeCountry &&
                ((availableCC <= 0 || availableCC >= this.distributorMaxCC) || (this.memberInfo.wholeSaleQualified))
                && this.orderFormGroup.controls['paymentSelector'].value !== this.selectEnum.thirdOption.toString()
                && this.appConfig.fpcToFboUpgradeFlowEnable) {
                this.optInCheck = true;
                this.openMemberLevelChange(requestUrl);
            }
            else {
                this.submitPlaceOrder(requestUrl);
            }
        }
    };
    /**
     * @description
     * @date 2019-09-04
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.submitPlaceOrder = function (requestUrl) {
        var orderRequest = this.prepareOrderRequest();
        if (orderRequest && (orderRequest.orderShippings[0].shipMethodId == undefined || orderRequest.orderShippings[0].shipMethodId == null)) {
            var notification = this._translatePipe.get('order.Please Select shipping method.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
        else if ((orderRequest.taxMetaData && this.isTaxMetaDataAvailable) || (!orderRequest.taxMetaData && !this.isTaxMetaDataAvailable)) {
            this.getAcceptPaymentDocuments();
            var compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(orderRequest);
            if (compareTaxValues) {
                this.comparePriceTier(orderRequest, requestUrl);
            }
            else {
                var notification = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
            }
        }
        else {
            var notification = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    };
    /**
     * @description compare tax
     * @date 2019-10-31
     * @param {Order} orderRequest
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.compareTax = function (orderRequest) {
        if (orderRequest && orderRequest.taxMetaData && orderRequest.taxMetaData.orderTaxCharges
            && orderRequest.taxMetaData.orderTaxCharges.length > 0) {
            var totalTaxAmount_1 = 0;
            orderRequest.taxMetaData.orderTaxCharges.forEach(function (tax) {
                totalTaxAmount_1 = totalTaxAmount_1 + parseFloat(tax.taxAmount.toFixed(2));
            });
            totalTaxAmount_1 = this._currencyPipe.getFormatedCurrency(totalTaxAmount_1, this.storeInfo);
            if (orderRequest.orderTax.toFixed(2) === totalTaxAmount_1.toFixed(2)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    /**
     * create order log request parameter
     */
    OrderPromotionComponent.prototype.createOrderLog = function (res, message) {
        var _this = this;
        var orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': message ? message : 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        this._orderService.createOrderLog(orderLogRequest).subscribe(function (response) { }, function (error) {
            _this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
        });
    };
    OrderPromotionComponent.prototype.orderSuccess = function (response) {
        this.updatePrivacyPreference();
        var subTotal = this.calculateItemsSubTotal(this.storeInfo);
        this.isOverrideMinimumLimit && this.hasMinimumOverrideLimit && subTotal <= this.orderRules.minValue ? this.saveMemberUpgradeActivityLog(this.memberInfo !== null ? this.memberInfo.memberId : response.personalInfo.memberId, MemberActivityLogType.Override_Minimum_Limit) : false;
        this.showSelectedShipMethod = false;
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.orderFromLookup = false;
        this.hasPersistedMemberId = false;
        this.persistedMemberId = '';
        this.fboid = '';
        this.showShippingData = false;
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
            || this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            this.clearGuestFormDetails();
        }
        this.clearAllTheForms(true, true, true);
        this.isSubmitted = false;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.removeSessionGuid();
    };
    /**
     * @description This method used to reset guest flow details
     * @method clearGuestDetails()
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.clearGuestFormDetails = function () {
        this.orderFormGroup.controls['orderType'].setValue(this.orderType.REGULAR);
        this.orderTypePrevValue = this.orderType.REGULAR;
        this.personalInformation = null;
        this.sponsorInformation = null;
        this.retuningGuestUser = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.agreementDocuments = [];
        this.isPrivacyPreference = null;
    };
    OrderPromotionComponent.prototype.openOrderViewTab = function (weborderID) {
        var orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        orderInfo.acceptDocuments = this.acceptPaymentDocuments;
        this.messageService.setOrderHistoryTab(orderInfo);
    };
    OrderPromotionComponent.prototype.getAcceptPaymentDocuments = function () {
        if (+this.orderFormGroup.controls['paymentSelector'].value == this.paymentTypeEnum.Direct_Debit) {
            this.acceptPaymentDocuments = {
                memberId: this.memberInfo.memberId,
                memberTypeId: this.memberInfo.memberTypeId,
                documents: this.paymentTermsAndPoliciyDocuments
            };
        }
        else {
            this.acceptPaymentDocuments = null;
        }
    };
    OrderPromotionComponent.prototype.orderPending = function (response) {
        if ((response.json().status === 'IN-PROGRESS') || (response.json().status === 'QUEUED')) {
            if (this.pollCount < this.maxPollCount) {
                if (localStorage.getItem('appadmin.pollCount')) {
                    this.pollCount = +(localStorage.getItem('appadmin.pollCount'));
                }
                else {
                    localStorage.setItem('appadmin.pollCount', '1');
                }
                this.pollCount = this.pollCount + 1;
                localStorage.setItem('appadmin.pollCount', this.pollCount + '');
                this.submitOrder(response.json().location);
            }
        }
        else {
            localStorage.removeItem('appadmin.pollCount');
        }
        localStorage.removeItem('appadmin.pollCount');
    };
    OrderPromotionComponent.prototype.prepareOrderRequest = function () {
        var _this = this;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        var shippingAddress;
        var orderTypeId = PurchaseFlow.Personal_Order;
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            orderTypeId = PurchaseFlow.Retail;
        }
        var shippingTax = this._enrollService.prepareShippingTax(this.orderTaxResponse) || this.shippingTax;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            shippingAddress = this.getShippingAddress();
        }
        else {
            shippingAddress = this.getShippingAddress();
        }
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === shippingAddress.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status */
        var memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === _this.orderFormGroup.value.shipMethodId; })[0];
        var orderRequest = {
            backDateOrder: this.orderFormGroup.value.backDateOrder,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: this.memberInfo ? this.memberInfo.memberId : this.retuningGuestUser ? this.retuningGuestUser.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : this.personalInformation ? this.personalInformation.email : null,
            languageCode: this.orderFormGroup.value.orderType === this.orderType.REGULAR ? this.storeDefaultLanguageShortCode : this._enrollmentCommonService.getLanguageCultureCode(this.storeLanguages, this.orderFormGroup),
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: memberTitleId,
            shippingCost: this.getTaxExclusiveShippingCost(),
            importFeeValue: this.importFeeValue,
            retailDeliveryFee: this.retailDeliveryFee,
            shippingTax: (this.appConfig && this.appConfig.enableVatItemizationForNonVat) ? shippingTax : ((this.memberShippingDiscountOfferEligible ||
                (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) || (this.appConfig && this.appConfig.displayTaxInclusivePrice)) && !this.isShippingTaxAddedToShippingCost) ? 0 : shippingTax,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : this.retuningGuestUser
                ? this.retuningGuestUser.distributorId : null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.CUSTOMERSERVICE,
            orderGroupId: this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
                ? this.orderType.REGULAR : this.orderFormGroup.value.orderType,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: this.orderTaxResponse ? this.orderTaxResponse.erpTaxMetaData : null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this.memberTypeId,
            sponsorId: this.memberInfo ? this.getOrderSponsorId() : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : this.retuningGuestUser ? this.retuningGuestUser.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage) : 0,
            // we have to send the wholesale discount percentage of the user,
            // how much discount he will get if he is an wholesaleQualified User
            wholesaleQualifiedDiscount: this.memberInfo ?
                this._commonService.getWholesaleQualifiedDisc(this._orderService
                    .getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId)) : 0,
            optIn: this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            sessionGuid: this._enrollmentCommonService.getSessionGuid(),
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            businessEntityId: this.businessEntityId,
            firstName: this.personalInformation && this.personalInformation.firstName ? this.personalInformation.firstName : this.memberInfo.firstName,
            lastName: this.personalInformation && this.personalInformation.lastName ? this.personalInformation.lastName : this.memberInfo.lastName,
            languageCulture: this.orderFormGroup.value.orderType === this.orderType.REGULAR ? this.storeLanguageCultureName : this.languageCulture,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            overrideMinimumLimit: this.isOverrideMinimumLimit,
            retailFreeShippingOrder: false,
            retailFreeShippingCost: 0,
            freeShippingPromotionOrder: shippingObj ? shippingObj.freeShippingEligible : false,
            orderLevelDiscount: this.orderLevelDiscount,
            sourceTypeId: 5
        };
        if (this.isOrderMeetsRFSCriteria() && shippingObj && shippingObj.shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase()) {
            orderRequest = __assign({}, orderRequest, { retailFreeShippingOrder: true, retailFreeShippingCost: this.storeDetails && this.storeDetails.retailFreeShippingCostDeduction ? +this.storeDetails.retailFreeShippingCostDeduction : 0 });
        }
        if (shippingObj && shippingObj.freeShippingEligible) {
            orderRequest.shippingCost = 0;
            // setting actual shipping cost
            orderRequest.retailFreeShippingCost = shippingObj.originalShippingCost;
        }
        if (!orderRequest.freeShippingPromotionOrder) {
            if (!orderRequest.retailFreeShippingOrder) {
                var hasFDShippableProduct = orderRequest.orderLineItems.some(function (item) { return item.shippableFulfillment; });
                if (hasFDShippableProduct && this.shipMethod && this.shipMethod.retailFreeShippingCost) {
                    orderRequest.retailFreeShippingOrder = true;
                    orderRequest.retailFreeShippingCost = this.shipMethod.retailFreeShippingCost;
                }
            }
        }
        return orderRequest;
    };
    /**
     *  @description thi smethod used for to get t the sponsor id
     *
     */
    OrderPromotionComponent.prototype.getOrderSponsorId = function () {
        if (this.isEnableFboReferralId()) {
            return this.sponsorInformation.sponsorId;
        }
        return this.memberInfo.sponsorId;
    };
    /**
   * @description
   * @memberof CommonService
   */
    OrderPromotionComponent.prototype.getCountryTaxInclusiveInfo = function (country) {
        var countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    };
    /**
     * @description comapare price tier details for line items
     * @date 2019-10-16
     * @param {*} orderRequest
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.comparePriceTier = function (orderRequest, requestUrl) {
        var _this = this;
        var memberDetails = this.memberInfo ? this.memberInfo : this.retuningGuestUser ? this.retuningGuestUser : null;
        if (orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0 && memberDetails) {
            var wholesaleQualified = memberDetails && memberDetails.wholeSaleQualified
                ? memberDetails.wholeSaleQualified : false;
            var optin = memberDetails && memberDetails.optin ? memberDetails.optin : false;
            var memberTitleId = memberDetails && memberDetails.memberLevelId
                ? this.memberInfo.memberLevelId : memberDetails && memberDetails.memberTitleId ? memberDetails.memberTitleId : null;
            var memberTypeId = memberDetails && memberDetails.memberTypeId ? memberDetails.memberTypeId : null;
            // HARD_DOWNGRADE CHECK FOR FPC USERS
            memberTitleId = this._orderService.getDowngradeTitleID(memberTypeId, memberTitleId);
            this._orderService.getPriceTierByMemberId(this.storeInfo.id, memberTitleId, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe(function (response) {
                if (response && response.priceTireName) {
                    var priceTierName_1 = response.priceTireName;
                    var isPriceTierMatched_1 = true;
                    orderRequest.orderLineItems.forEach(function (item) {
                        if (priceTierName_1 !== item.priceTierName) {
                            isPriceTierMatched_1 = false;
                        }
                    });
                    _this.checkLineItemsPriceTier(isPriceTierMatched_1, orderRequest, requestUrl);
                }
                else {
                    _this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
                }
            }, function (error) {
                _this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
            });
        }
        else {
            this.checkLineItemsPriceTier(true, orderRequest, requestUrl);
        }
    };
    /**
     * @description check line items pricetier
     * @date 2019-10-16
     * @param {boolean} isPlaceOrder
     * @param {*} orderRequest
     * @returns {void}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.checkLineItemsPriceTier = function (isPlaceOrder, orderRequest, requestUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var itemNumber, revisionNumber, new_RevisionNumber, recentlyViewedProducts, isProductRevisionNumberMatch_2, notification, productIds, arr, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isPlaceOrder) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getRecentlyviewedProducts(orderRequest)];
                    case 1:
                        recentlyViewedProducts = _a.sent();
                        isProductRevisionNumberMatch_2 = true;
                        if (recentlyViewedProducts) {
                            if (recentlyViewedProducts && recentlyViewedProducts.length > 0) {
                                recentlyViewedProducts.forEach(function (recentProduct) {
                                    orderRequest.orderLineItems.forEach(function (product) {
                                        if (product.revisionNumber === recentProduct.revisionNumber) {
                                        }
                                        else {
                                            isProductRevisionNumberMatch_2 = false;
                                            itemNumber = product.itemNumber;
                                            revisionNumber = product.revisionNumber;
                                            new_RevisionNumber = recentProduct.revisionNumber;
                                            return;
                                        }
                                    });
                                });
                            }
                        }
                        if (isProductRevisionNumberMatch_2) {
                            this.submitOrderBasedOnPriceTierCheck(orderRequest, requestUrl);
                        }
                        else {
                            notification = this._translatePipe.get('order.Product revision number mismatch,' + ' Item : ' + itemNumber + ', Revision Number : ' + revisionNumber + ', New Revision Number : ' + new_RevisionNumber);
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        if (orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0) {
                            productIds = orderRequest.orderLineItems.map(function (item) { return item.productId; });
                            if (productIds && productIds.length) {
                                this.orderFormGroup.get('items').reset();
                                arr = this.orderFormGroup.controls.items;
                                arr.controls = [];
                                this.getProductsByIds(productIds, this.storeInfo);
                                notification = this._translatePipe.get('order.Product prices are updated. please verify and submit order');
                                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                this.isSubmitted = false;
                            }
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderPromotionComponent.prototype.getRecentlyviewedProducts = function (orderRequest) {
        var wholesaleQualified = orderRequest.wholesaleQualified;
        var optin = orderRequest.optin;
        var productIds = orderRequest.orderLineItems.map(function (item) { return item.productId; });
        this.purchaseFlowType = this._commonService.getPurchaseFlowType(orderRequest.memberTitleId, orderRequest.wholesaleQualified, this.appConfig.fpc5PercentEnabled, false, orderRequest.memberTitleId);
        if (productIds && productIds.length > 0) {
            return this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, orderRequest.memberLevelId, this.purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified ? true : false, optin ? true : false, this.storeInfo.taxInclusive).toPromise();
        }
        else {
            var notification = this._translatePipe.get('order.Products not added .');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    };
    /**
     * @description
     * frame content to be logged for shipping price change
     * @date 2020-03-18
     * @returns {string}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getShippingLogInfo = function () {
        var shippingLogInfo;
        var shippingCost = this.getOrderShippingCost();
        if (this.appConfig && this.appConfig.freeShippingFPCOrder && this.memberShippingDiscountOfferEligible) {
            shippingLogInfo = 'Shipping Cost was discounted by ' + this._currencyPipe.
                transform(shippingCost, this.storeInfo, true);
        }
        else if (this.orderFormGroup && this.orderFormGroup.controls['shippingCostSelector']
            && this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage']
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0) {
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value;
            shippingLogInfo = discountPercentage > 0 ? 'Shipping Cost was discounted by ' +
                (discountPercentage + '%') + '.' : '';
        }
        else if (this.orginalShippingCost !== shippingCost && !this.appConfig.enableVatItemizationForNonVat) {
            var costDifference = shippingCost - this.orginalShippingCost;
            shippingLogInfo = costDifference > 0 ? 'Shipping Cost was increased by ' + this._currencyPipe.
                transform(costDifference, this.storeInfo, true) +
                '.' : 'Shipping Cost was discounted by ' + this._currencyPipe.
                transform(-costDifference, this.storeInfo, true) + '.';
        }
        return shippingLogInfo;
    };
    /**
     * @description submit Order
     * @date 2019-10-17
     * @param {*} orderRequest
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.submitOrderBasedOnPriceTierCheck = function (orderRequest, requestUrl) {
        var _this = this;
        if (orderRequest) {
            var notification_1;
            this._orderService.createNewOrder(orderRequest, requestUrl).subscribe(function (response) {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        if (_this.appConfig && _this.appConfig.freeShippingFPCOrder && _this.memberShippingDiscountOfferEligible) {
                            _this.removeMemberDiscountOffer(_this.memberInfo.memberId);
                        }
                        var shippingLogInfo = _this.getShippingLogInfo();
                        if (shippingLogInfo) {
                        }
                        _this.orderSuccess(response.json().responseModel);
                        var sessionGuid = ((_this.memberCart && _this.memberCart.sessionGuid) || _this.memberCartSessionGuid);
                        if (sessionGuid && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST && _this.shoppingBagClicked) {
                            _this.deleteCart(sessionGuid);
                        }
                    }
                    else if (response.json().responseModel && response.json().status === 'VALIDATION-ERROR'
                        && response.json().responseModel.validations.length > 0) {
                        var exceedLimitNotification = response.json().responseModel.validations[0].message;
                        response.json().responseModel.validations.forEach(function (x) {
                            if (x.message === StatusConstants.MONTHLY_CC_EXCEEDED) {
                                notification_1 = _this._translatePipe.get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                                var errorMessage = notification_1.value + ' <b class="helvetica-bold">'
                                    + (_this.memberCCOverride && _this.memberCCOverride.cVLimit ? _this.memberCCOverride.cVLimit : _this.memberOrderCCInfo.maxCCValue) + '</b>';
                                _this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
                            }
                            else if (x.field === 'VAT REGITSTER') {
                                var notification_2 = _this._translatePipe.get('order.VAT Registered Price Error');
                                _this._commonService.createNotification('', notification_2.value, NotificationType.ERROR);
                            }
                            else {
                                notification_1 = _this._translatePipe.get('order.Unable to Process the Order');
                                _this._commonService.createNotification('', notification_1.value, NotificationType.ERROR);
                            }
                        });
                    }
                    else {
                        _this.orderPending(response);
                    }
                    _this.isSubmitted = false;
                }
            }, function (error) {
                _this.orderSessionGuid = orderRequest.sessionGuid;
                _this.getOrderDetailsByUuid(_this.orderSessionGuid, orderRequest.distrubutorId);
            });
        }
    };
    /**
* @returns OrderLineItem
*/
    OrderPromotionComponent.prototype.getOrderLineItems = function (countryTaxInclusive) {
        var _this = this;
        var lineItems = [];
        if (this.products && this.products.length > 0) {
            var itemLineNumber_1 = 0;
            var lineItemTax_1;
            this.products.sort(function (x, y) {
                return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1;
            });
            this.products.forEach(function (product) {
                if (product) {
                    var unitPrice = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    var retailPrice = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    var wholesalePrice = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (_this.displayPriceConfig) {
                        unitPrice = _this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (_this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (_this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = _this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            _this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = _this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            _this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (_this.orderTaxResponse && _this.orderTaxResponse.cart && _this.orderTaxResponse.cart.orderLineItems
                        && _this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax_1 = _this.orderTaxResponse.cart.orderLineItems.find(function (y) { return y.itemNumber === product.itemNumber; });
                    }
                    var unitDiscountPrice = _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    var bondedProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1'; });
                    var lineItem = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber_1,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (_this.checkoutConfig && _this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax_1 ? lineItemTax_1.salesTax : 0,
                        unitTaxablePrice: lineItemTax_1 && lineItemTax_1.taxablePrice ? lineItemTax_1.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: _this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        totalAmount: _this._currencyPipe.getFormatedCurrency(_this.getItemTotalSum(product), _this.storeInfo),
                        discountAmount: _this._currencyPipe.getFormatedCurrency(_this.calculateDiscountAmount(product, _this.displayPriceConfig), _this.storeInfo),
                        personalDiscount: _this._currencyPipe.getFormatedCurrency(((parseFloat(product.retailPrice.toFixed(2)) * product.quantity
                            * _this.personalDiscountPercentage) / 100), _this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: _this.appConfig && _this.appConfig.calculateNetUnitPrice
                            && _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified
                            && _this.memberInfo.transactionalOptin ? _this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.display ? (product.display.comboBOMEnabled ? true : false) : false,
                        depositFeeProduct: product.display ? (product.display.depositFeeProduct ? true : false) : false,
                        depositFeeEnabledProduct: product.productMetaData ? (product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; }) ? true : false) : false,
                        orderPromotionTrackings: product.orderPromotionTrackings ? product.orderPromotionTrackings : null,
                        bondedProduct: bondedProduct ? true : false,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment ? true : false) : false,
                    };
                    lineItems.push(lineItem);
                }
            });
        }
        return lineItems;
    };
    /**
     * @description get FBO eligible product
     * @date 2019-07-04
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getFBOEigibleProduct = function (product) {
        if (product.productMetaData) {
            var fboEligibilty = product.productMetaData.
                find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    };
    OrderPromotionComponent.prototype.getOrderShippings = function () {
        var _this = this;
        var orderShippings = [];
        var shippingAddressId = null;
        var guestToRetailAddressId = this.guestToRetailShippingId;
        if (this.savedAddressId) {
            shippingAddressId = this.savedAddressId;
        }
        else if (this.verifiedShippingAddressId) {
            shippingAddressId = this.verifiedShippingAddressId;
        }
        else if (guestToRetailAddressId) {
            shippingAddressId = guestToRetailAddressId;
        }
        var discountPercentage = this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0
            ? this.orderFormGroup.controls['shippingCostPercentage'].value : 0;
        var orderShipping = {
            deliveryPreferenceId: this.orderFormGroup.value.deliveryPreference,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingAddressId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) ?
                shippingAddressId : null,
            shortCode: this.shipMethod ? this.shipMethod.shortCode : '',
            preferredTime: null,
            notes: null,
            shipmentDate: null,
            shippingWaived: this.memberShippingDiscountOfferEligible ? true :
                ((+this.orginalShippingCost) - (+this.getOrderShippingCost())) === 0 ? false : true,
            shippingWaiverPercentage: this.memberShippingDiscountOfferEligible ? 100 :
                discountPercentage > 0 ? discountPercentage : null,
            distributionCenter: this.shipMethods.distributionCenterName
        };
        var shippingObj = this.shippingMethods.find(function (shipMethod) { return shipMethod.shippingMethodId == _this.orderFormGroup.value.shipMethodId; });
        if (shippingObj && shippingObj.freeShippingEligible && shippingObj.promotionId) {
            var orderPromotionTrackingList = [{
                    promotionID: shippingObj.promotionId
                }];
            orderShipping.orderPromotionTrackingList = orderPromotionTrackingList;
        }
        if (orderShipping.deliveryPreferenceId === ShippingType.PICKUP) {
            orderShipping.distributionCenter = (this.shipMethod.pickUpLocation.pickupCenterName) ? this.shipMethod.pickUpLocation.pickupCenterName : '';
        }
        orderShippings.push(orderShipping);
        return orderShippings;
    };
    /**
      * @returns payment method
      */
    OrderPromotionComponent.prototype.getPaymentMethodById = function (paymentMethodId) {
        var paymentType;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Orange_Money:
                paymentType = PaymentMethodTypes.Orange_Money;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case this.paymentTypeEnum.BanContact_MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.BanContact_MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.Single_Debit:
                paymentType = PaymentMethodTypes.Single_Debit;
                break;
            case this.paymentTypeEnum.Direct_Debit:
                paymentType = PaymentMethodTypes.Direct_Debit;
                break;
            case this.paymentTypeEnum.Pay_By_Link:
                paymentType = PaymentMethodTypes.Pay_By_Link;
                break;
            case this.paymentTypeEnum.Wire_Transfer:
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
        }
        return paymentType;
    };
    /*
*/
    OrderPromotionComponent.prototype.getPaymentMethod = function (paymentMethod) {
        var paymentType;
        switch (paymentMethod) {
            case 'Credit_Card':
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case 'eCheck':
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case 'Money_Order':
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case 'Bank_Transfer':
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case 'Ideal':
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case 'PayPal':
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case 'Wire_Transfer':
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
        }
        return paymentType;
    };
    OrderPromotionComponent.prototype.getAddresses = function () {
        var addresses = [];
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            var pickupAddress = this.getPickUpAddress();
            if (pickupAddress) {
                pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction : '';
                pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
                addresses.push(pickupAddress);
            }
        }
        else {
            var shipAddress = this.getShippingAddress();
            if (shipAddress) {
                addresses.push(shipAddress);
            }
        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            var pudoPickUpAddress = this.getPudoPickUpAddress(this.pudoShippingAddressInfo, this.pudoShippingMethod);
            if (pudoPickUpAddress) {
                pudoPickUpAddress.deliveryInstruction = pudoPickUpAddress && pudoPickUpAddress.instruction ? pudoPickUpAddress.instruction : '';
                pudoPickUpAddress.email = pudoPickUpAddress.email ? pudoPickUpAddress.email : null;
                addresses.push(pudoPickUpAddress);
            }
        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            var pudoDropAddress = this.getPudoDropAddress(this.pudoShippingAddressInfo, this.shipMethod);
            if (pudoDropAddress) {
                pudoDropAddress.deliveryInstruction = pudoDropAddress && pudoDropAddress.instruction ? pudoDropAddress.instruction : '';
                pudoDropAddress.email = pudoDropAddress.email ? pudoDropAddress.email : null;
                addresses.push(pudoDropAddress);
            }
        }
        if ((this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()) || (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString())) {
            var billingAddress = this.getBillingAddress();
            if (billingAddress) {
                addresses.push(billingAddress);
            }
        }
        return addresses;
    };
    OrderPromotionComponent.prototype.getPudoPickUpAddress = function (address, shippingMethod) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoCollectionPoint = this.selectedPudoCollectionPoint;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            var pudoPickUpAddress = {
                addressLine1: pudoCollectionPoint.street ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) : '',
                addressLine2: pudoCollectionPoint.address2 ? pudoCollectionPoint.address2 : '',
                addressLine3: pudoCollectionPoint.address3 ? pudoCollectionPoint.address3 : '',
                addressLine4: null,
                city: pudoCollectionPoint.city,
                state: pudoCollectionPoint.state,
                stateCode: address.stateCode,
                countryCode: address.countryCode,
                country: countryObj.name,
                county: null,
                zip: pudoCollectionPoint.zipCode,
                company: null,
                name: pudoCollectionPoint.name,
                pickupCenterName: pudoCollectionPoint.name,
                instruction: '',
                optionName: DelivaryOptionType.Dropship,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: pudoCollectionPoint.geoPoint.latitude + '',
                longitude: pudoCollectionPoint.geoPoint.longitude + '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.zipCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoPickUpAddress;
        }
    };
    OrderPromotionComponent.prototype.getPudoDropAddress = function (address, shippingMethod) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoCollectionPoint = this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : this.dropShipAddress ? this.dropShipAddress : address;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            var pudoDropShipAddress = {
                addressLine1: this.selectedPudoCollectionPoint ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) :
                    pudoCollectionPoint.addressLine1 ? pudoCollectionPoint.addressLine1 : address.addressLine1,
                addressLine2: this.selectedPudoCollectionPoint ? pudoCollectionPoint.address2 : pudoCollectionPoint.addressLine2,
                addressLine3: this.selectedPudoCollectionPoint ? pudoCollectionPoint.address3 : pudoCollectionPoint.addressLine3,
                addressLine4: null,
                city: pudoCollectionPoint.city || address.city,
                state: pudoCollectionPoint.state || address.state,
                stateCode: address.stateCode || pudoCollectionPoint.stateCode,
                countryCode: address.countryCode,
                country: countryObj.name,
                county: null,
                zip: pudoCollectionPoint.zipCode || address.zipCode,
                company: null,
                firstName: address.firstName,
                lastName: address.lastName,
                phoneNumer: address.phoneNumber,
                email: address.email,
                name: pudoCollectionPoint.name || address.name,
                instruction: '',
                optionName: DelivaryOptionType.Dropship,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.latitude + '' : '',
                longitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.longitude + '' : '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.postalCode || address.postalCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoDropShipAddress;
        }
    };
    OrderPromotionComponent.prototype.calculateOrderTotal = function () {
        var totalCost = 0;
        var itemsTotalTax = 0;
        var calculateVatTax = true;
        if (this.orderSession) {
            this.taxableAmount = this.orderSession.taxableAmount;
        }
        for (var i = 0; i < this.products.length; i++) {
            if (!this.countryTaxInclusive) {
                itemsTotalTax += this.products[i].tax;
            }
        }
        if (this.memberInfo && this.memberInfo.vatRegistered
            && this.countryTaxInclusive) {
            if ((this.appConfig && this.appConfig.enableVatItemizationForNonVat) || this.appConfig.displayTaxInclusivePrice) {
                if (this.appConfig && this.appConfig.calculateVatForVatRegisterUser) {
                    calculateVatTax = true;
                }
                else {
                    calculateVatTax = false;
                }
            }
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) +
                (this.memberShippingDiscountOfferEligible ? 0 : this.getShippingCostForOrderSummary() || 0) + (calculateVatTax ? this.taxableAmount || 0 : 0);
        }
        else {
            if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                calculateVatTax = this.memberInfo && (!this.memberInfo.vatRegistered && this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ? true : false;
            }
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) +
                (this.memberShippingDiscountOfferEligible ? 0 : this.getShippingCostForOrderSummary() || 0) +
                ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (calculateVatTax ? this.taxableAmount || 0 : 0) : 0);
        }
        if (this.isBWPEnabled && this.isBWPEnabledProduct && this.storeInfo && this.storeInfo.bwpEnabled) {
            this.orderLevelDiscount = Number((this.orderLevelDiscount).toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
            totalCost = totalCost - this.orderLevelDiscount;
        }
        if (this.storeInfo) {
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.itemTotal = totalCost - this.itemShippingCost;
        return totalCost;
    };
    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    OrderPromotionComponent.prototype.calculateOrderTax = function () {
        var _this = this;
        this.taxCalculationStatus = true;
        this.orderTaxResponse = null;
        if (this.storeInfo && this.products && this.products.length > 0 && this.orderFormGroup.value.shipMethodId) {
            var taxRequest = this.prepareTaxRequest();
            if (taxRequest && taxRequest.fromAddress && taxRequest.toAddress) {
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe(function (taxResponse) {
                    if (taxResponse && taxResponse.success) {
                        _this.isTaxMetaDataAvailable = taxResponse.taxMetaData ? true : false;
                        if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                            taxResponse.cart.totalTax = _this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, _this.storeInfo);
                            _this.orderTaxResponse = taxResponse;
                            _this.taxableAmount = taxResponse.cart.totalTax;
                            _this.retailDeliveryFee = taxResponse.cart.retailDeliveryFee ? taxResponse.cart.retailDeliveryFee : 0;
                            _this.isCalculateTax = _this.appConfig.displayTaxInclusivePrice ? false : true;
                            if (_this.orderTaxResponse && _this.orderTaxResponse.taxMetaData
                                && _this.orderTaxResponse.taxMetaData.orderTaxCharges
                                && _this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                                var gst = _this.orderTaxResponse.taxMetaData
                                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.GST_TAX; });
                                var pst = _this.orderTaxResponse.taxMetaData
                                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.PST_TAX; });
                                _this.gstTax = gst ? gst.taxAmount : 0;
                                _this.pstTax = pst ? pst.taxAmount : 0;
                                if (_this.countryTaxInclusive) {
                                    var shippingLineItem = _this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.NOR && tax.lineNo === 0; });
                                    if (shippingLineItem && _this.orderFormGroup.controls['shippingCostSelector'].value != _this.selectEnum.secondOption.toString() && _this.orderFormGroup.controls['shippingCostSelector'].value != _this.selectEnum.thirdOption.toString()) {
                                        // this.shippingTax = shippingLineItem.taxAmount;
                                    }
                                }
                            }
                        }
                        setTimeout(function () {
                            _this.taxCalculationStatus = false;
                        }, 500);
                        var isEnableVATCalculation = _this.appConfig && _this.appConfig.enableVATCalculation;
                        var taxCalculated = _this.appConfig.displayTaxInclusivePrice ? false : true;
                        _this.displayPriceConfig = _this._memberDisplayPriceConfigService
                            .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, _this.storeInfo.taxInclusive, _this.memberInfo, taxCalculated, _this.countryTaxInclusive, _this.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    }
                }, function (error) {
                    if (error) {
                        var taxResponse = error;
                        if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                            if ((taxResponse.validations.map(function (validation) { return validation.name; }).indexOf(CommonConstant.Order_Tax)) > -1) {
                                var notification = _this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                            else {
                                var notification = _this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                        }
                    }
                });
            }
        }
    };
    OrderPromotionComponent.prototype.prepareTaxRequest = function () {
        var _this = this;
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        var memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        var countryCode = this.countries.find(function (x) { return x.isocodeThree === _this.countryCode; });
        this.countryID = countryCode.countryId;
        var taxRequest = {
            orderID: 0,
            memberID: this.memberInfo ? this.memberInfo.memberId : null,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                this.getPickUpAddress() : this.getShippingMethodWarehouseAddress(),
            toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP)
                ? this.getPickUpAddress() : (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) ? this.getPodiCollectPointAddress() : this.getShippingAddress(),
            memberNumber: this.memberInfo ? this.memberInfo.fboId : null,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                ShippingType.PICKUP : ShippingType.DELIVERY,
            orderSource: 'CUSTOMER SERVICE',
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: memberTitleId,
            wholesaleQualified: this.memberInfo ? this.memberInfo.wholeSaleQualified : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            isDiscountedShipping: this.orderFormGroup.value.isShippingDiscountApplied,
            memberType: MemberTypeEnum[this.memberTypeId]
        };
        return taxRequest;
    };
    /**
      * @returns TaxCart
      */
    OrderPromotionComponent.prototype.mapCartToTaxCart = function () {
        var taxCart = {
            shippingTax: 0,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingCost: this.getTaxExclusiveShippingCost(),
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    };
    /**
     * @returns CartItems
     */
    OrderPromotionComponent.prototype.mapItemstoTaxItems = function () {
        var _this = this;
        // PS2020-496 PR applicable tax issue
        var address = (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod && this.shipMethod.pickUpLocation) ?
            this.getPickUpAddress() : this.getShippingAddress();
        /*
             TASK : HOTFIX PS2020-387
             TO:DO : taxablePrice price coloumn mapping should be based on Provider. We will adopt this changes as part of R7 release
         */
        var taxItems = [];
        if (this.products && this.products.length > 0) {
            var itemLineNumber_2 = 0;
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }
            this.products.forEach(function (x) {
                var taxablePrice;
                var paidPrice;
                if (_this.checkoutConfig && _this.checkoutConfig.calculateTaxExclusivePrice) {
                    taxablePrice = x.catalogPrice;
                    paidPrice = x.applicablePrice;
                }
                else {
                    taxablePrice = ((_this.checkoutConfig.catalogPriceAsTaxablePrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.catalogPrice : x.retailPrice);
                    paidPrice = ((_this.checkoutConfig.applicablePriceAspaidPrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.applicablePrice : x.retailPrice);
                }
                var bondedProduct = x.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1'; });
                var taxItem = {
                    lineNumber: ++itemLineNumber_2,
                    itemNumber: x.itemNumber,
                    taxablePrice: _this.getTaxablePrice(taxablePrice, x),
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',
                    taxInclusive: _this.countryTaxInclusive ? true : false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: _this.getPaidPrice(paidPrice, x),
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit,
                    unitTaxExclusiveRetailPrice: x.baseRetailPrice,
                    computedTaxInclusivePrice: x.computedTaxInclusivePrice,
                    comboBOMEnabled: x.display ? (x.display.comboBOMEnabled ? x.display.comboBOMEnabled : false) : false,
                    computedComboTaxTotals: x.computedComboTaxTotals && x.computedComboTaxTotals.length > 0 ? x.computedComboTaxTotals : [],
                    bondedProduct: (bondedProduct && _this.isBWPEnabled) ? true : false
                };
                taxItems.push(taxItem);
            });
        }
        return taxItems;
    };
    OrderPromotionComponent.prototype.getTaxablePrice = function (taxablePrice, item) {
        var enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin && !this.memberInfo.vatRegistered &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || (this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && enableWHLSAL00ForAsstSupervisor))) {
            return this.calculateNetUnitPrice(item);
        }
        else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        }
        else if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        }
        else {
            return taxablePrice;
        }
    };
    OrderPromotionComponent.prototype.getPaidPrice = function (paidPrice, item) {
        if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        }
        else {
            return paidPrice;
        }
    };
    OrderPromotionComponent.prototype.getPriceTier = function () {
        var priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    };
    OrderPromotionComponent.prototype.addNewProductItem = function (items, index, product) {
        var itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        var itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
        var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
        var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
        items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
        return items;
    };
    OrderPromotionComponent.prototype.setFocusbyID = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    };
    OrderPromotionComponent.prototype.moveToItemLevelSearchBlock = function (event) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    };
    /**
     * @description item number search in table
     * @date 2019-09-25
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.itemLevelSearchEvent = function (event) {
        var _this = this;
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe(function (products) {
                var responseproducts = products;
                if (responseproducts.length > 0) {
                    var product_1 = responseproducts[0];
                    var isStockAvailable = _this.stockAvailable(product_1);
                    if (isStockAvailable) {
                        var items = _this.orderFormGroup.get('items');
                        if (items && items.length >= 0) {
                            var sameProductIndex = items.controls.findIndex(function (item) {
                                return item.controls['productNumber'].value === product_1.itemNumber;
                            });
                            if (sameProductIndex >= 0) {
                                items.controls[sameProductIndex].controls['quantity']
                                    .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                _this.setFocusbyID('quantity-' + (sameProductIndex));
                            }
                            else {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                items = _this.addNewProductItem(items, index, product_1);
                                _this.setFocusbyID('quantity-' + (items.length - 1));
                            }
                        }
                        /*if(this.isPromotionEngineEnabled) {
                            this.getPromotionProducts();
                        }*/
                        var isDepositFeeProductEnabled = product_1.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                        if (isDepositFeeProductEnabled) {
                            _this.getDepositFeeProduct(product_1);
                        }
                        _this.updateTotalsAndShipMethod(false);
                        //New logic to bind promtoion product from promotion engine
                        var freeProductsInfo = _this.validatePromotionCriteria(items);
                        var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items, _this.orderFormGroup, _this.promotionIds);
                        //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                        if (productIds && productIds.length) {
                            _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                        }
                        else {
                            _this.updateTotalsAndShipMethod();
                        }
                        if (_this.orderFormGroup.controls['orderType'].value === OrderType.POS
                            || _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            _this.deliveryPreferenceOnChange();
                        }
                    }
                    else {
                        _this._commonService.createNotification('', 'Out of stock - '
                            + (product_1.name || ''), NotificationType.ERROR);
                        if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                            _this.itemLevelSearch.nativeElement.focus();
                        }
                        _this.taxCalculationStatus = false;
                    }
                }
                else {
                    if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                        _this.itemLevelSearch.nativeElement.focus();
                    }
                    var notification = _this._translatePipe.get('order.Invalid Item Number');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                _this.itemLevelSearch.nativeElement.value = '';
            });
        }
    };
    OrderPromotionComponent.prototype.getDepositFeeProduct = function (searchProduct, loadProducts) {
        var _this = this;
        var depositFeeProduct = null;
        var memberTitleId = this.memberInfo && this.memberInfo.memberTitleId ? this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId) : MemberLevel.RETAIL;
        var purchaseFlowType = (this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL) ?
            PurchaseFlows.RETAIL : this.getPurchaseFlowType();
        var productAssociation = this.productAssociationInfo.find(function (x) { return x.productId === searchProduct.id; });
        if (productAssociation) {
            depositFeeProduct = this.depsoitFeeProductsInfo.find(function (x) { return x.id === productAssociation.depositFeeProductId; });
            if (depositFeeProduct) {
                depositFeeProduct.productQuantity = 1;
                if (!loadProducts) {
                    this.onItemSelect(depositFeeProduct);
                }
            }
        }
        else {
            var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
                ? this.memberInfo.wholeSaleQualified : false;
            var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
            var taxInclusive = this.storeInfo && this.storeInfo.taxInclusive ? this.storeInfo.taxInclusive : this.orderSession && this.orderSession.storeInfo && this.orderSession.storeInfo.taxInclusive ? this.orderSession.storeInfo.taxInclusive : false;
            this._customerService.getRelatedProducts(this.storeId, searchProduct.id, 2, memberTitleId, this.countryCode, this.storeDefaultLanguage, purchaseFlowType, taxInclusive, wholesaleQualified, optin)
                .subscribe(function (response) {
                if (response && response.length) {
                    depositFeeProduct = response[0];
                    var depositFeeProductInfo = _this.depsoitFeeProductsInfo.find(function (x) { return x.id === depositFeeProduct.id; });
                    _this.productAssociationInfo.push({
                        productId: searchProduct.id,
                        depositFeeProductId: depositFeeProduct.id
                    });
                    if (!depositFeeProductInfo) {
                        _this.depsoitFeeProductsInfo.push(depositFeeProduct);
                    }
                    if (!loadProducts) {
                        _this.onItemSelect(depositFeeProduct);
                    }
                }
            });
        }
    };
    OrderPromotionComponent.prototype.getPurchaseFlowType = function () {
        var fpc5PercentEnabled = false;
        var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        return this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
    };
    /**
     * @description Check stock available or not
     * @date 2019-09-25
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.stockAvailable = function (product) {
        return (product.manageStock && product.stockQuantity > 0) || (product.stockAvailable && !product.manageStock);
    };
    /**
     * @description auto complete search
     * @date 2019-09-25
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.onItemSelect = function (depositFeeProduct) {
        var _this = this;
        var searchProduct = depositFeeProduct ? depositFeeProduct : this.orderFormGroup.controls['itemSearch'].value;
        if (searchProduct && searchProduct.id) {
            var isStockAvailable = this.stockAvailable(searchProduct);
            if (isStockAvailable) {
                var items = this.orderFormGroup.get('items');
                if (items && items.length >= 0) {
                    this.taxCalculationStatus = true;
                    var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productNumber'].value === searchProduct.itemNumber; });
                    if (sameProductIndex >= 0) {
                        items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                        this.orderFormGroup.controls['itemSearch'].setValue('');
                        this.setFocusbyID('quantity-' + (sameProductIndex));
                        items.controls[sameProductIndex].controls['disableDecrement'].setValue(false);
                    }
                    else {
                        this.addItemNumber();
                        var index = (items.length - 1);
                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        if (!items.controls[index].controls['quantity'].value) {
                            items.controls[index].controls['quantity'].setValue(1);
                        }
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.orderFormGroup.controls['itemSearch'].value) {
                            var typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            items = this.addNewProductItem(items, index, typHeadItem);
                        }
                        else {
                            items = this.addNewProductItem(items, index, searchProduct);
                        }
                        this.isFocused = true;
                        this.setFocusbyID('quantity-' + (items.length - 1));
                    }
                }
                /*if(this.isPromotionEngineEnabled) {
                    this.getPromotionProducts();
                }*/
                var isDepositFeeProductEnabled = searchProduct.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                if (isDepositFeeProductEnabled) {
                    this.getDepositFeeProduct(searchProduct);
                }
                this.updateTotalsAndShipMethod(false);
                //New logic to bind promtoion product from promotion engine
                var freeProductsInfo = this.validatePromotionCriteria(items);
                var productIds = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                if (productIds && productIds.length) {
                    this.addPromotionEngineProducts(productIds, freeProductsInfo);
                }
                else {
                    this.updateTotalsAndShipMethod();
                }
                if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                    || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.deliveryPreferenceOnChange();
                }
            }
            else {
                this._commonService.createNotification('', 'Out of stock - '
                    + (this.orderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
                this.orderFormGroup.controls['itemSearch'].setValue('');
                setTimeout(function () {
                    if (_this.seachItemElement && _this.seachItemElement.nativeElement) {
                        _this.seachItemElement.nativeElement.focus();
                    }
                }, 500);
            }
        }
    };
    OrderPromotionComponent.prototype.shippingAddressSelectionChange = function () {
        this.shippingAddressInfo = this.address && this.address.isSavedAddress ? this.address : null;
        this.address = this.address && this.address.isSavedAddress ? this.address : null;
        this.getShipMethods();
    };
    /**
     * get shipping cost in percentage
     */
    OrderPromotionComponent.prototype.getShippingCostInPercentage = function () {
        var shippingOriginalCost = this.orginalShippingCost;
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                ? this.orderFormGroup.controls['originalShippingCost'].value
                : this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            this.shippingTax = this.orderFormGroup.controls['originalShippingTax'].value;
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost = this.memberInfo && this.memberInfo.vatRegistered ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            var shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            }
            else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.getShippingCost();
    };
    /**
     * on chnage on shipping charge selector
     */
    OrderPromotionComponent.prototype.shippingCostChange = function (isRetailFreeShipping) {
        var _this = this;
        var shippingObj = this.shippingMethods.find(function (shipMethod) { return shipMethod.shippingMethodId == _this.orderFormGroup.value.shipMethodId; });
        if (this.isOrderMeetsRFSCriteria() && shippingObj && shippingObj.shippingMethod && shippingObj.shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase()) {
            this.orderFormGroup.get('shippingCostSelector').setValue(this.selectEnum.firstOption.toString());
            var notification = this._translatePipe.get('order.Free shipping is already available for this order, No more discounts allowed');
            isRetailFreeShipping ? this._commonService.createNotification('', notification.value, NotificationType.ERROR) : '';
        }
        else if (shippingObj && shippingObj.freeShippingEligible && (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString())) {
            this.orderFormGroup.get('shippingCostSelector').setValue(this.selectEnum.firstOption.toString());
            var notification = this._translatePipe.get('order.Free shipping is already available for this order, No more discounts allowed');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.showSelectedShipMethod) {
                this.orderFormGroup.controls['originalShippingCost'].setValue(this._currencyPipe.getFormatedCurrency(this.orginalShippingCost || 0, this.storeInfo));
                this.orderFormGroup.controls['originalShippingTax'].setValue(this.originalShippingTax);
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            }
            else {
                this.orderFormGroup.controls['originalShippingCost'].setValue(0);
                this.orderFormGroup.controls['originalShippingTax'].setValue(0);
            }
            this.orderFormGroup.controls['originalShippingCost'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(false);
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        }
        else {
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            var shippingOriginalCost = this.orginalShippingCost;
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost = this.memberInfo && this.memberInfo.vatRegistered ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            var shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            }
            else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.calculateOrderTax();
    };
    OrderPromotionComponent.prototype.shippingPercentChange = function (event) {
        if (event.keyCode !== 8) {
            var value = (this.orderFormGroup.controls['shippingCostPercentage'].value
                ? this.orderFormGroup.controls['shippingCostPercentage'].value : '') + (event.key ? event.key : '');
            var pattern = /^(?:100|[1-9]?[0-9])$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    OrderPromotionComponent.prototype.allowOnlyNumbers = function (event) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            var value = (event.key ? event.key : '');
            var pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    /**
     * Save Shipping Address
     */
    OrderPromotionComponent.prototype.saveShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        var guestToRetailUser = this.guestToRetailMember;
        if ((this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) || guestToRetailUser) {
            this.saveAddress(address);
        }
        else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.useNewShippingAddress(address);
        setTimeout(function () {
            var addtoSavedAddressesElement = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddressesElement) {
                addtoSavedAddressesElement.focus();
            }
        }, 200);
    };
    OrderPromotionComponent.prototype.savePudoShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        }
        else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
    };
    /**
     * @description save billing address
     * @date 2018-11-19
     * @param {Address} address
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.saveBillingAddress = function (address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    };
    // *************************payvision payment section*******************************/
    /**
     * @description Load Member Saved Cards
     * @date 2018-08-30
     * @memberof PaymentComponent
     */
    OrderPromotionComponent.prototype.loadSavedCardsForMemberId = function (memberId, countryCode) {
        var _this = this;
        var paymentStatus = this._cacheService.get(CacheKey.PaymentStatus);
        if (paymentStatus) {
            var newCardError = this._translatePipe.get('order.Payment gateway not responding');
            this._commonService.createNotification('', newCardError.value, NotificationType.ERROR);
            this._cacheService.remove(CacheKey.PaymentStatus);
        }
        var paymentInstrumentId = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode, paymentInstrumentId).subscribe(function (savedCardResponse) {
            if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                _this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                _this.paymentComponentSettings.savedCards.forEach(function (card) {
                    card.notes = card.defaultCard ? PaymentConstants.default : '';
                });
                if (paymentInstrumentId) {
                    var selectedCard = _this.paymentComponentSettings.savedCards.find(function (x) { return x.id === paymentInstrumentId; });
                    if (selectedCard) {
                        var indexPostion = _this.paymentComponentSettings.savedCards.findIndex(function (x) { return x.id === paymentInstrumentId; });
                        _this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                        _this.paymentComponentSettings.savedCards.unshift(selectedCard);
                        _this.selectedpayvisionCardInfo = selectedCard;
                    }
                    _this.orderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                    _this._cacheService.remove(CacheKey.PaymentInstrumentId);
                }
                else {
                    if (_this.paymentComponentSettings.savedCards && _this.paymentComponentSettings.savedCards.length > 0) {
                        var defaultCard = _this.paymentComponentSettings.savedCards.find(function (card) { return card.expired === false && card.defaultCard === true; });
                        if (defaultCard) {
                            _this.orderFormGroup.controls['paymentInstrumentId'].setValue(defaultCard.id);
                            _this.selectSavedCard(defaultCard);
                        }
                        else {
                            var isDefaultCard_1 = false;
                            var isCardAdded_1 = false;
                            _this.paymentComponentSettings.savedCards.forEach(function (card) {
                                if (card.expired === false && isDefaultCard_1 === false) {
                                    isDefaultCard_1 = true;
                                    isCardAdded_1 = true;
                                    _this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                    _this.selectSavedCard(card);
                                }
                            });
                            if (!isCardAdded_1) {
                                _this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                                _this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                            }
                        }
                    }
                    else {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                        _this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    }
                }
            }
            else {
                _this.paymentComponentSettings.savedCards = [];
            }
            _this.getPaymentMethodsByStore();
        }, function (error) {
            _this.paymentComponentSettings.isAddNewCard = false;
        });
    };
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    OrderPromotionComponent.prototype.getImagePath = function (cardType) {
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    this.paymentComponentSettings.cardTypeImage = null;
                    break;
            }
        }
        return this.paymentComponentSettings.cardTypeImage;
    };
    /**
     * On change of card
     */
    OrderPromotionComponent.prototype.selectSavedCard = function (cardDetails, isNewCard) {
        this._cacheService.set(CacheKey.IsRefreshed, true);
        this.addNewCardClicked = false;
        this.mapBillingAddress();
        this.mapShippingAddress();
        if (isNewCard) {
            if (this.shippingAddressChanged) {
                this.showVerifyAddressMessage();
                return;
            }
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
                this._enrollmentMessageService.setSubmitGuestForm(true);
            }
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
                this._enrollmentMessageService.setSubmitPersonalInfoForm(true);
            }
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            }
            else if (this.isAdyenPayment) {
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            }
            else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            }
            else if (this.isNexioPayment) {
                this.showNexioPayment = true;
                this.showNexioPopup.open();
            }
            else {
                this.addNewpayvisionCard = true;
                this.payvisionPayment.open();
            }
        }
        else {
            this.selectedpayvisionCardInfo = cardDetails;
            this.addNewpayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.showAdyenPayment = false;
        }
    };
    OrderPromotionComponent.prototype.showVerifyAddressMessage = function () {
        var verifyAddressError = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    };
    OrderPromotionComponent.prototype.addOrderInfoToSession = function () {
        sessionStorage.removeItem(CacheKey.OrderInfo);
        var formValues = this.orderFormGroup.value;
        var pudoformvalues = this.pudoLocationSearchForm.value;
        var OrderInfo = {
            products: this.products,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shippingAddressId: this.shippingAddressInfo && this.shippingAddressInfo.id ? this.shippingAddressInfo.id : 0,
            shippingAddressInfo: this.shippingAddressInfo ? this.shippingAddressInfo : this.pudoAddress,
            shipMethodId: formValues.shipMethodId,
            shipMethods: this.shipMethods,
            shippingTax: this.shippingTax,
            shippingCost: this.memberShippingDiscountOfferEligible ? 0 : formValues.shippingCost,
            shippingCostPercentage: this.memberShippingDiscountOfferEligible ? 0 : formValues.shippingCostPercentage,
            shippingCostSelector: formValues.shippingCostSelector,
            verifiedShippingAddressId: this.verifiedShippingAddressId,
            shippingCostValue: this.memberShippingDiscountOfferEligible ? 0 : this.shippingCost,
            orderFromLookup: this.orderFromLookup,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            shoppingBagClicked: this.shoppingBagClicked ? true : false,
            memberCartSessionGuid: this.shoppingBagClicked && this.memberCart
                && this.memberCart.sessionGuid ? this.memberCart.sessionGuid :
                this.shoppingBagClicked && this.memberCartSessionGuid ? this.memberCartSessionGuid : null,
            personalInformation: this.personalInformation,
            retuningGuestUser: this.retuningGuestUser,
            documents: this.agreementDocuments,
            language: this.orderFormGroup.value.language,
            mailingAddress: this.mailingAddress,
            rebindSponsorData: this.rebindSponsorData,
            sponsorInformation: this.sponsorInformation,
            memberCommunicationPreferences: this.memberCommunicationPreferences,
            liveFormAddress: this.liveFormAddress,
            mailAlreadyExist: this.mailAlreadyExist,
            isShippingDiscountApplied: this.orderFormGroup.value.isShippingDiscountApplied,
            minMaxPriceValidation: this.minMaxPriceValidation,
            businessEntityId: this.businessEntityId,
            selectPudoCollectionPoint: this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : null,
            buildPudoLocationSearchForm: this.pudoLocationSearchForm.value,
            pudoShippingMethod: this.pudoShippingMethod ? this.pudoShippingMethod : null,
            pudoaddress: this.pudoAddress ? this.pudoAddress : null,
            buildPayByLinkForm: this.emailForm.value,
            languageCulture: this.orderFormGroup.value.orderType === this.orderType.REGULAR ? this.storeLanguageCultureName : this.languageCulture,
            isOverrideMinimumLimit: this.isOverrideMinimumLimit,
            taxCalculationStatus: this.taxCalculationStatus,
            orderTaxResponse: this.orderTaxResponse,
            storeInfo: this.storeInfo,
            appConfig: this.appConfig,
            countryTaxInclusive: this.countryTaxInclusive,
            taxableAmount: this.taxableAmount,
            importFeeValue: this.importFeeValue,
            originalShippingCost: formValues.originalShippingCost,
            pudoShippingAddressInfo: this.pudoShippingAddressInfo && this.shippingAddressInfoConfig.dropShipLocationsEnabled ? this.pudoShippingAddressInfo : null
        };
        sessionStorage.setItem(CacheKey.OrderInfo, JSON.stringify(OrderInfo));
    };
    /**
     *load procducts from session
     */
    OrderPromotionComponent.prototype.loadproductsFromSession = function () {
        var _this = this;
        this.orderSession.products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
                    var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (product.promoProduct) {
                        items.controls[index].controls['disableIncrement'].setValue(true);
                        items.controls[index].controls['disableDecrement'].setValue(true);
                        items.controls[index].controls['disableDelete'].setValue(true);
                    }
                    else {
                        items.controls[index].controls['disableIncrement'].setValue(false);
                        items.controls[index].controls['disableDelete'].setValue(false);
                        if (product.quantity == 1) {
                            items.controls[index].controls['disableDecrement'].setValue(true);
                        }
                        else {
                            items.controls[index].controls['disableDecrement'].setValue(false);
                        }
                    }
                    if (depositFeeEnabled) {
                        _this.getDepositFeeProduct(product, true);
                    }
                }
            }
            if (_this.orderSession) {
                _this.orderFormGroup.patchValue({
                    shipMethodId: _this.orderSession.shipMethodId,
                    originalShippingCost: _this.orderSession.originalShippingCost,
                });
            }
        });
        this.updateTotalsAndShipMethod();
    };
    /**
     * map shipping Info with the shipping form
     */
    OrderPromotionComponent.prototype.mapShippingAddressToShippingInfo = function () {
        var formAddress = this.orderSession.shippingAddressForm;
        var shippingAddressForm = this.orderFormGroup.get('shippingAddressForm');
        shippingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        shippingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        shippingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        shippingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        shippingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        shippingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        shippingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        shippingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        shippingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        shippingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        shippingAddressForm.comtrols[0].controls['email'].setValue(formAddress.email || '');
        if (this.orderSession.shipVerificationProcessDone) {
            this.shippingAddressInfo = this.orderSession.shippingAddressInfo;
        }
    };
    /**
     * on close of payvision form popup
     */
    OrderPromotionComponent.prototype.onPayvisionFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewpayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
        // To remove payvision Configurations
        this._commonService.unloadPayvisionWidget();
    };
    /**
* @returns any
*/
    OrderPromotionComponent.prototype.getOrderPaymentInfo = function () {
        var payments = [];
        var paymentMethodType;
        paymentMethodType = this.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value);
        var orderPayment = {
            savePaymentMethod: this.savePaymentMethod && this.orderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                ? this.savePaymentMethod : false,
            paymentAmount: this.calculateOrderTotal(),
            priceTier: this.getStorePriceTierName(),
            redirect: false,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            memberPaymentMethodId: +this.orderFormGroup.controls['paymentSelector'].value,
            authorizationCode: this.paymentComponentSettings && this.paymentComponentSettings.authorizationCode ? this.paymentComponentSettings.authorizationCode : null,
            paymentMode: paymentMethodType && paymentMethodType == PaymentMethodTypes.Pay_By_Link ? paymentMethodType : null,
            creditCardModel: {
                currencyCode: this.storeInfo.currencyCode,
                paymentToken: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.token : null,
                paymentMethodType: paymentMethodType,
                maskedCreditCardNumber: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.maskedCard : null,
                cardHolderName: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.nameOnTheCard : null,
                expMonth: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.expiryMonth : null,
                expYear: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.expiryYear : null
            },
            paymentECheck: (this.orderFormGroup.controls['paymentSelector'].value === this.paymentTypeEnum.eCheck) ? this.getAchInfo() : null
        };
        payments.push(orderPayment);
        return payments;
    };
    /**
         * get controls of items
         */
    OrderPromotionComponent.prototype.getItemsControl = function () {
        return this.orderFormGroup.get('items');
    };
    /**
     * prevent +, -, e entering in shipping cost
     */
    OrderPromotionComponent.prototype.keyEventShippingCost = function (event) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    };
    /**
     * On paste event for member Info
     */
    OrderPromotionComponent.prototype.onPasteEvent = function () {
        var _this = this;
        setTimeout(function () {
            _this.orderFormGroup.controls['memberInfo'].setValue(_this.orderFormGroup.controls['memberInfo'].value.trim());
        }, 0);
    };
    /**
* @description submit ach payment information
* @memberof ACHComponent
*/
    OrderPromotionComponent.prototype.submitAchPaymentInformation = function (achPaymentInfo) {
        if (achPaymentInfo) {
            this.achPaymentInfo = achPaymentInfo;
            this.achToken = this.achPaymentInfo.personalCheckId;
            this.getSavedAchs();
            this.achPaymentPopup.close();
        }
    };
    /**
     * Get ACH payment
     */
    OrderPromotionComponent.prototype.getSavedAchs = function () {
        var _this = this;
        var memberId = this.getUserMemberId();
        if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
            this._achService.getSavedEchecks(memberId, this.selectedIsoCountryCode, PaymentMethodTypeConstants.eCheck, this.achToken, true, SecType.Tel)
                .subscribe(function (response) {
                if (response && response.length) {
                    _this.paymentComponentSettings.savedAchs = response;
                    if (_this.achRequest && _this.achRequest.reusable) {
                        var selectedCard = _this.paymentComponentSettings.savedAchs.find(function (x) { return x.id === _this.achRequest.id; });
                        if (selectedCard) {
                            var indexPostion = _this.paymentComponentSettings.savedAchs
                                .findIndex(function (x) { return x.id === _this.achRequest.id; });
                            _this.paymentComponentSettings.savedAchs.splice(indexPostion, 1);
                            _this.paymentComponentSettings.savedAchs.unshift(selectedCard);
                            _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.paymentComponentSettings.savedAchs[0].id);
                        }
                        else {
                            var index_1 = _this.paymentComponentSettings.savedAchs.length - 1;
                            _this.orderFormGroup.controls['paymentInstrumentId']
                                .setValue(_this.paymentComponentSettings.savedAchs[index_1].id);
                        }
                        var index = _this.paymentComponentSettings.savedAchs.length - 1;
                        _this.selectAch(_this.paymentComponentSettings.savedAchs[index], false);
                    }
                    else {
                        var index = _this.paymentComponentSettings.savedAchs.length - 1;
                        _this.selectAch(_this.paymentComponentSettings.savedAchs[index], false);
                    }
                    _this.savedAch = JSON.stringify(_this.paymentComponentSettings.savedAchs);
                }
            });
        }
    };
    /**
     * on change of payment method
     */
    OrderPromotionComponent.prototype.onPaymentMethodChnage = function () {
        var _this = this;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.selectedpayvisionCardInfo = null;
        this.echeckRequest = null;
        var options = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer,
            this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Orange_Money, this.paymentTypeEnum.MisterCash_and_Maestro, this.paymentTypeEnum.BanContact_MisterCash_and_Maestro,
            this.paymentTypeEnum.Single_Debit, this.paymentTypeEnum.Direct_Debit, this.paymentTypeEnum.Pay_By_Link, this.paymentTypeEnum.Wire_Transfer];
        var paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        if (options.some(function (x) { return x == paymentSelectorValue; })) {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
        }
        else {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        }
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (paymentSelectorValue === this.paymentTypeEnum.Credit_Card) {
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                var isDefaultCard_2 = false;
                var isCardAdded_2 = false;
                this.paymentComponentSettings.savedCards.forEach(function (card) {
                    if (card.expired === false && isDefaultCard_2 === false) {
                        isDefaultCard_2 = true;
                        isCardAdded_2 = true;
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                        _this.selectSavedCard(card);
                    }
                });
                if (!isCardAdded_2) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                    this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                }
            }
        }
        if (paymentSelectorValue === this.paymentTypeEnum.eCheck) {
            if (this.paymentComponentSettings.savedAchs && this.paymentComponentSettings.savedAchs.length > 0) {
                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
            }
        }
        if (paymentSelectorValue === this.paymentTypeEnum.Pay_By_Link) {
            var email = this.paymentComponentSettings && this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : this.liveFormPersonalInfo && this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : this.address && this.address.email ? this.address.email : null;
            if (email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            }
            else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            }
            else {
                this.isPayByLinkValid = false;
            }
        }
        else {
            this.isPayByLinkValid = true;
        }
        if (this.appConfig.enablePaymentReferenceNumber) {
            this.paymentReferenceNumber.reset();
            this.paymentReferenceNumberFormValidations();
        }
    };
    /**
     * on change of Echeck
     */
    OrderPromotionComponent.prototype.selectECheck = function (echeckDetails, isNewEcheck) {
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckValidationMessages = [];
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        }
        else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    };
    OrderPromotionComponent.prototype.buildAchForm = function () {
        var phone = '';
        var email = '';
        var checkNumber = "";
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.paymentAchForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            secType: ['', [Validators.required, CustomValidator.checkIfAccountSelected()],
            ],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]],
            checkNumber: [checkNumber, [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
            billingAddressId: [''],
        });
    };
    /**
    * on change of Ach
    */
    OrderPromotionComponent.prototype.selectAch = function (achDetails, isNewAch) {
        if (isNewAch) {
            this.buildAchForm();
            this.eCheckValidationMessages = [];
            this.addNewAchCard = true;
            this.achPaymentPopup.open();
        }
        else {
            this.selectedAchInfo = achDetails;
            this.billingAddressInfo = achDetails.billingAddress;
            this.addNewAchCard = false;
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    };
    /**
     * when Echeck form is closed
     */
    OrderPromotionComponent.prototype.onECheckFormClose = function () {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    };
    /**
     * buildEcheckForm
     */
    OrderPromotionComponent.prototype.buildEcheckForm = function () {
        var phone = '';
        var email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            reuse: [false],
            billingAddressId: [''],
            customMessage: [''],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    };
    OrderPromotionComponent.prototype.validateNewECheck = function () {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            var echeckFormValue_1 = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue_1.phone) {
                var phoneCode = PhoneCodesConstants.phoneCodes.find(function (x) { return echeckFormValue_1.phone.toUpperCase().indexOf(x.name) > -1; });
                if (phoneCode) {
                    echeckFormValue_1.phone = echeckFormValue_1.phone;
                }
                else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue_1.phone = this._maskPipe.transform(echeckFormValue_1.phone, this.phoneNumberFormat);
                    }
                    else {
                        echeckFormValue_1.phone = echeckFormValue_1.phone;
                    }
                }
            }
            var validateECheckReq = {
                accountNumber: echeckFormValue_1.accountNumber,
                accountType: echeckFormValue_1.accountType,
                bankName: echeckFormValue_1.bankName,
                routingNumber: echeckFormValue_1.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue_1.email,
                phone: echeckFormValue_1.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    };
    OrderPromotionComponent.prototype.validateECheck = function (validateECheckReq) {
        var _this = this;
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe(function (response) {
            if (response && response.success) {
                _this.savePersonalEcheck(validateECheckReq);
            }
            else if (response && !response.success && response.validations.length > 0) {
                _this.eCheckValidationMessages = response.validations.map(function (validation) { return validation.message; });
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * save personal echecks
     */
    OrderPromotionComponent.prototype.savePersonalEcheck = function (eCheckInfo) {
        var _this = this;
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe(function (response) {
            if (response) {
                _this.eCheckTokenRes = response;
                _this.echeckSubmitted = false;
                if (_this.addNeweCheck) {
                    _this.eCheckPaymentPopup.close();
                    var savedEChecks = JSON.parse(_this.savedEChecks);
                    _this.paymentComponentSettings.savedEChecks = savedEChecks;
                    if (_this.echeckRequest) {
                        _this.echeckRequest.id = +(atob(_this.eCheckTokenRes));
                    }
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(_this.eCheckTokenRes)));
                        //this.getSavedEchecks();
                    }
                    else {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(_this.eCheckTokenRes)));
                    }
                }
                if (_this.paymentFormBtn && _this.paymentFormBtn.nativeElement) {
                    _this.paymentFormBtn.nativeElement.focus();
                }
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * map billing address for e-Check
     */
    OrderPromotionComponent.prototype.getBillingAddressForECheck = function () {
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            id: null,
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2 || '',
            addressLine3: this.billingAddressInfo.addressLine3 || '',
            addressLine4: this.billingAddressInfo.addressLine4 || '',
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            countryId: this.billingAddressInfo.countryId,
            city: this.billingAddressInfo.city,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            country: this.billingAddressInfo.countryCode,
            countryCode: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            firstName: this.billingAddressInfo.shipToName || this.billingAddressInfo.name,
            phone: ''
        };
        return billingAddress;
    };
    /**
     * map Echeck Info for payment
     */
    OrderPromotionComponent.prototype.getEcheckInfo = function () {
        var eCheckInfo = {
            bankName: this.echeckRequest.bankName,
            accountNumber: this.echeckRequest.accountNumber,
            routingNumber: this.echeckRequest.routingNumber,
            accountType: this.echeckRequest.accountType,
            mecTransactionID: '',
            nameOnBankAccount: this.echeckRequest.nameOnBankAccount,
            customMessage: '',
            reusable: this.echeckRequest.reusable,
            eCheckID: this.eCheckTokenRes ? parseInt(atob(this.eCheckTokenRes), 10) : this.echeckRequest ? this.echeckRequest.id : 0,
            email: this.echeckRequest.email,
            phone: this.echeckRequest.phone
        };
        return eCheckInfo;
    };
    /**
     * @description add mask while chnaging phone number
     *
     * @memberof EcheckComponent
     */
    OrderPromotionComponent.prototype.onChangeEcheckPhone = function ($event) {
        var value = this.echeckForm.controls['phone'].value;
        var updatedValue = value;
        var alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            }
            else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            }
            else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        }
        else {
            if (alphaNumericValue.length !== 3) {
                if (this.phoneNumberFormat) {
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                }
                else {
                    updatedValue = value;
                }
            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    };
    OrderPromotionComponent.prototype.onWorldpayXMLFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showWorldpayXml = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    };
    // ======================Worldpay End===================================================
    OrderPromotionComponent.prototype.onAdyenPaymentFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    };
    // ======================Adyen payment End===================================================
    OrderPromotionComponent.prototype.onNIFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    };
    OrderPromotionComponent.prototype.onNexioFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPopup.close();
    };
    OrderPromotionComponent.prototype.onPaymentAchFormClose = function () {
        this.addNewAchCard = false;
        this.achPaymentPopup.close();
    };
    /**
   * clear form...
   */
    OrderPromotionComponent.prototype.clearOrderForm = function (isClearRetailForm) {
        this.clearAllTheForms(true, true, true);
        var memberInfoElement = document.getElementById('memberInfo');
        if (memberInfoElement) {
            memberInfoElement.focus();
        }
        else {
            var countryElement = document.getElementById('country');
            if (countryElement) {
                countryElement.focus();
            }
        }
        if (isClearRetailForm) {
            this.clearGuestAndRetailForm();
        }
        if (this.orderFromLookup) {
            this.getDistributorInfo();
        }
    };
    /**
     * To clear guest or retail form when clicking on cancel
     */
    OrderPromotionComponent.prototype.clearGuestAndRetailForm = function () {
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
            || this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            this.liveFormPersonalInfo = null;
            this.paymentComponentSettings.savedCards = [];
            this.address = null;
            this.liveFormAddress = null;
            this.mailingAddress = null;
            this.storeInfo = null;
            this._enrollmentMessageService.setStoreInfo(this.storeInfo);
            this.orderSession = null;
            this.savePaymentMethod = false;
            this.orderFormGroup.controls['isContactSponsor'].setValue(null);
            this.memberCommunicationPreferences.email = false;
            this.checkContactSponsor();
            this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
            this.orderTypeChange(this.orderFormGroup.value.orderType);
        }
    };
    /**
     * get restricted products
     */
    OrderPromotionComponent.prototype.getRestrictedProducts = function (productModels) {
        var _this = this;
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach(function (product) {
            var itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            var item = _this.products.find(function (productItem) { return productItem.itemNumber === itemNumber; });
            if (item) {
                _this.restrictedProducts.push(item.name + ' - #' + itemNumber);
            }
        });
        this.showRestrictedProducts.open();
    };
    /**
         * @description To Show Shipping Restriction Error message
         * @date 2019-08-01
         * @private
         * @returns {string}
         * @memberof OrderEditComponent
         */
    OrderPromotionComponent.prototype.getShippingRestrictionError = function () {
        var _this = this;
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            var stateName = this.states.find(function (x) { return x.stateCode === _this.shippingAddressInfo.stateCode; }).stateName;
            var error = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        }
        else {
            var error = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    };
    /**
     * @description sip to different address click
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.shipToDifferentAddress = function () {
        var _this = this;
        this.showSavedAddress = true;
        this.isNewCard = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.showPudoPickupPersonAddressForm = false;
        }
        setTimeout(function () {
            if (_this.memberAddressDetails && _this.memberAddressDetails.length > 0) {
                if (_this.savedAddressElement && _this.savedAddressElement.nativeElement) {
                    _this.savedAddressElement.nativeElement.focus();
                }
            }
            else {
                if (_this.addNewAddressEle && _this.addNewAddressEle.nativeElement) {
                    _this.addNewAddressEle.nativeElement.focus();
                }
            }
        }, 500);
        this.clearPudoLocationSearchData();
    };
    /**
     * @description this method will show new address form
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.addNewAddress = function () {
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayPudoAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewPudoShippingAddress();
        }
        else if (this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        }
        else {
            this.address = null;
            this.showSavedAddress = false;
            this.isNewCard = true;
            this.shippingAddressInfo = null;
            this.shippingMethods = [];
            this.updateTotalsAndShipMethod();
        }
        this.clearPudoLocationSearchData();
    };
    OrderPromotionComponent.prototype.addNewPudoShippingAddress = function () {
        var _this = this;
        this.pudoAddress = null;
        this.showSavedAddress = false;
        this.showPudoPickupPersonAddressForm = true;
        setTimeout(function () {
            _this.displayPudoAddress = true;
        }, 100);
    };
    OrderPromotionComponent.prototype.addNewDropshipPersonAddress = function () {
        var _this = this;
        this.pudoShippingAddressInfo = null;
        this.showSavedAddress = false;
        this.showDropShipPersonAddressForm = true;
        setTimeout(function () {
            _this.displayDropAddress = true;
        }, 100);
    };
    OrderPromotionComponent.prototype.clearPudoLocationSearchForm = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    };
    OrderPromotionComponent.prototype.clearPudoLocationSearchData = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    };
    OrderPromotionComponent.prototype.getAddressIsValid = function (isValid) {
        this.formPickupPersonAddressValid = isValid;
        this.pudoLocationsNotFound = false;
    };
    // getPaymentMethod by Store
    OrderPromotionComponent.prototype.getPaymentMethodsByStore = function (memberTypeId) {
        var _this = this;
        var fpc5PercentEnabled = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.credit_Card_show = this.money_Order_show = this.orange_money_show = this.cash_on_delivery_show = this.ach_show
            = this.bank_transfer_show = this.echeck_show = this.banContact_misterCash_and_maestro_show = this.wire_Transfer_show
                = this.misterCash_and_maestro_show = this.single_debit_show = this.direct_debit_show = this.pay_by_link_show = false;
        var memberId = this.memberInfo && this.memberInfo.memberId && (this.memberInfo.memberTypeId == MemberTypeEnum.DISTRIBUTOR || (this.appConfig.showBonusInfoForFPC && this.memberInfo.memberTypeId == MemberTypeEnum.FPC)) ? this.memberInfo.memberId : null;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode, this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode, this.memberInfo ? this.memberInfo.memberTypeId : memberTypeId, this.memberInfo ? this.memberInfo.wholeSaleQualified : null, fpc5PercentEnabled, false, false, memberId, this.memberInfo ? this.memberInfo.homeCompany : null).subscribe(function (response) {
            if (response) {
                //response = this._commonService.singleOrDirectDebitCardEligibilityCheck(response, this.countryCode, this.memberInfo ? this.memberInfo.homeCompany : null);
                if (response.find(function (x) { return x.paymentMethodName === PaymentMethodTypes.Credit_Card && x.paymentProcessor === PaymentProcessorAlias.ADYEN; })) {
                    _this._commonService.getPaymentMethodsSourceConfiguration().subscribe(function (paymentMethodSourceConfigurations) {
                        if (paymentMethodSourceConfigurations && paymentMethodSourceConfigurations.length > 0 && response && response.length > 0) {
                            var paymentmethodsConfig = paymentMethodSourceConfigurations.find(function (paymentMethodSourceConfiguration) { return paymentMethodSourceConfiguration && paymentMethodSourceConfiguration.country == _this.selectedIsoCountryCode; });
                            if (paymentmethodsConfig) {
                                response = _this._commonService.filterPaymentMethods(paymentmethodsConfig, response, _this.orderFormGroup.value.orderType);
                                _this.initialPaymentMethods = response;
                            }
                        }
                        _this.updatePaymentMethodsDisplayStatus(response);
                    }, function (error) {
                        _this.updatePaymentMethodsDisplayStatus(response);
                    });
                }
                else {
                    _this.updatePaymentMethodsDisplayStatus(response);
                }
            }
        }, function (error) {
        });
    };
    OrderPromotionComponent.prototype.updatePaymentMethodsDisplayStatus = function (response) {
        var _this = this;
        this.storePaymentInfo = response;
        this.initializePaymentMethods();
        this.storePaymentInfo.forEach(function (paymentMethod) {
            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                _this.credit_Card_show = (_this.checkoutConfig.disableAddNewCards && (!_this.paymentComponentSettings || !_this.paymentComponentSettings.savedCards || _this.paymentComponentSettings.savedCards.length === 0)) ? false : true;
                if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO) {
                    _this.isNexioPayment = true;
                }
                else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN) {
                    _this.isAdyenPayment = true;
                }
                else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NI) {
                    _this.isNIPayment = true;
                }
                else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML) {
                    _this.isWorldpayPayment = true;
                }
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                _this.displayStatementForWavePayment = _this.appConfig.displayStatementForWavePayment;
                if (_this.displayStatementForWavePayment) {
                    _this.money_Order_show = true;
                    _this.displayStatementForWavePayment = _this.appConfig.displayStatementForWavePayment;
                }
                else {
                    _this.money_Order_show = true;
                    _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Money_Order);
                }
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                _this.wire_Transfer_show = true;
                _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Wire_Transfer);
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                _this.bank_transfer_show = true;
                _this.getBankDetailsByCountry(_this.countryCode);
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                _this.cash_on_delivery_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                _this.orange_money_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                _this.ach_show = true;
                _this.getSavedAchs();
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                _this.direct_debit_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                _this.pay_by_link_show = true;
            }
        });
        if (this.direct_debit_show) {
            this.getPaymentTermsAndPoliciesDocuments();
        }
        var option = this.credit_Card_show ? this.paymentTypeEnum.Credit_Card : this.money_Order_show ? this.paymentTypeEnum.Money_order : this.wire_Transfer_show ? this.paymentTypeEnum.Wire_Transfer
            : this.bank_transfer_show ? this.paymentTypeEnum.Bank_Transfer : this.cash_on_delivery_show ? this.paymentTypeEnum.Cash_On_Delivery : this.ach_show ? this.paymentTypeEnum.eCheck
                : this.banContact_misterCash_and_maestro_show ? this.paymentTypeEnum.BanContact_MisterCash_and_Maestro : this.misterCash_and_maestro_show ? this.paymentTypeEnum.MisterCash_and_Maestro
                    : this.direct_debit_show ? this.paymentTypeEnum.Direct_Debit : this.pay_by_link_show ? this.paymentTypeEnum.Pay_By_Link : this.orange_money_show ? this.paymentTypeEnum.Orange_Money : null;
        if (option) {
            this.setPaymentMethod(option);
        }
        this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
            this.orderSession.savePaymentMethod : false;
        if (!this.appConfig.showBonusInfoForFPC) {
            this.restrictPaymentsByItemTotals();
        }
    };
    OrderPromotionComponent.prototype.initializePaymentMethods = function () {
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    };
    /**
     * @description to get payment terms and Conditions documents
     * @param storeInfo
     */
    OrderPromotionComponent.prototype.getPaymentTermsAndPoliciesDocuments = function () {
        var _this = this;
        var accountlevelID = this._commonService.getMemberAccountLevelId(this.memberInfo);
        if (accountlevelID) {
            this._documentService.getDocuments(Portal.Csp, accountlevelID, DisplaySectionId.Payment_Page, this.countryCode, this.storeDefaultLanguage).subscribe(function (res) {
                if (res && res[0] && res[0].body && res[0].body.length > 0) {
                    _this.paymentTermsAndPoliciyDocuments = res[0].body;
                    _this.paymentTermsAndPoliciyDocuments.forEach(function (item) {
                        item.isSelected = true;
                    });
                }
            }, function (error) {
            });
        }
    };
    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderPromotionComponent
   */
    OrderPromotionComponent.prototype.getOrderRules = function (storeInfo) {
        var _this = this;
        var userInfo = this.memberInfo;
        var isFboUpgradeFlow = false;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
            isFboUpgradeFlow = (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR &&
                this.appConfig && this.appConfig.displayPurchaseLimitationMessage);
        }
        var orderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL,
            orderType: userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };
        if (!isFboUpgradeFlow) {
            this.getBusinessOrderRules(orderRulesRequest);
        }
        this._orderService.getMemberOrderRestrictionsInfo(userInfo, this.selectedIsoCountryCode)
            .subscribe(function (response) {
            if (response) {
                _this.restrictedDays = response.restrictedDays;
                _this.getMemberRankLevelHistory(orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow);
            }
        }, function (error) {
        });
        if (userInfo && userInfo.memberId && userInfo.memberTitleId !== MemberLevel.RETAIL) {
            if (!isFboUpgradeFlow) {
                this.getMemberOrderRules(userInfo, false);
            }
            this.getMemberCCOverrides(userInfo.memberId);
        }
    };
    OrderPromotionComponent.prototype.getPaymentRules = function () {
        var _this = this;
        if (this.memberInfo) {
            var fpc5PercentEnabled = false;
            var memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
            var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? true : false;
            if (wholesaleQualified == null) {
                wholesaleQualified = false;
            }
            if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
                fpc5PercentEnabled = true;
            }
            var paymentdroolsRequest = {
                countryCode: this.selectedIsoCountryCode.toUpperCase(),
                orderType: this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId),
                memberType: this.memberInfo.memberTypeId,
                orderSource: OrderSourceValue.CUSTOMER,
                vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false
            };
            this._orderService.getPaymentDroosResponse(paymentdroolsRequest).subscribe(function (response) {
                if (response) {
                    _this.paymentDroolsResponse = response;
                }
            }, function (error) {
            });
        }
    };
    OrderPromotionComponent.prototype.getBusinessOrderRules = function (orderRulesRequest, userInfo, isFboUpgradeFlow) {
        var _this = this;
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe(function (response) {
            if (response && response.success) {
                _this.orderRules = response;
                if (isFboUpgradeFlow) {
                    _this.getMemberOrderRules(userInfo, false, null, true);
                }
            }
            else {
                _this.orderRules = null;
            }
        }, function (error) {
            _this.orderRules = null;
        });
    };
    /**
     * Get member cc overrides
     * @param memberId
    */
    OrderPromotionComponent.prototype.getMemberCCOverrides = function (memberId) {
        var _this = this;
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(function (response) {
            if (response && response.length) {
                _this.memberCCOverride = response[0];
            }
            else {
                _this.memberCCOverride = null;
            }
        }, function (err) {
        });
    };
    /** get Member Order rules
     * @description
     * @date 2019-05-20
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getMemberOrderRules = function (userInfo, isBackOrderDate, requestUrl, isFboUpgradeFlow) {
        var _this = this;
        this.memberOrderCCInfo = null;
        var fromDate;
        var toDate;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        }
        if (isFboUpgradeFlow) {
            fromDate = this.memberInfo.enrolmentDate.substr(0, 10);
            var enrollDate = new Date(fromDate);
            var orderToDateStr = enrollDate.setDate(enrollDate.getDate() + this.restrictedDays);
            toDate = moment(orderToDateStr).format(DateConstants.DOBFormat);
        }
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate, this.selectedIsoCountryCode, userInfo.memberTitleId, null, fromDate, toDate)
            .subscribe(function (response) {
            if (response) {
                var memberOrderRules = response;
                var frequencyType_1 = _this.isMemberFboUpgraded ? Constants.FREQUENCY_ABSOLUTE : Constants.FREQUENCY_MONTHLY;
                _this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter(function (x) { return x.frequency === frequencyType_1; })[0];
                var validateOrderRule = _this.verifyOrderRules(isBackOrderDate);
                _this.upgradeFboLimitExceeded = frequencyType_1 === Constants.FREQUENCY_ABSOLUTE ?
                    validateOrderRule.purchaseLimitExceed : false;
                _this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                _this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                _this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                _this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                _this.cartLimitExceed = validateOrderRule.cartLimitExceed;
                _this.cartLimitNotReach = validateOrderRule.cartLimitNotReach;
                if (requestUrl) {
                    _this.placeOrder(requestUrl);
                }
            }
        }, function (error) {
        });
    };
    /**
     * @description savePayment methos
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.savePaymentMethodClicked = function (savePaymentMethod) {
        this.savePaymentMethod = !savePaymentMethod;
    };
    /**
     * @description get Terms and Conditions Document
     * fetchTermsConditionDocument
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.fetchTermsConditionDocument = function (agreementDocuments) {
        this.agreementDocuments = agreementDocuments;
        var unselectedAgreements = this.agreementDocuments.filter(function (agreement) { return !agreement.isSelected; });
        if (unselectedAgreements && unselectedAgreements.length > 0) {
            this.agreementCheck = false;
        }
        else {
            this.agreementCheck = true;
            this.isSubmitted = false;
        }
    };
    /**
     * @description prepare Terms and Conditions Document request
     * prepareAgreementDocumentsRequest
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.prepareAgreementDocumentsRequest = function () {
        this.documentsRequest = {
            customerTypeId: this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL ? MemberLevel.GUEST
                : MemberLevel.RETAIL,
            portalId: Portal.Csp,
            displaySectionId: this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
                ? DisplaySectionId.Guest_Checkout_Page : DisplaySectionId.Retail_Checkout_Page,
            countryCode: this.countryCode,
            languageCode: this.orderFormGroup.value.language
        };
    };
    OrderPromotionComponent.prototype.gotoCheckout = function () {
        if (this.shoppingCartCount) {
            if (!this.memberCart) {
                if (this.memberCartInfo.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCartInfo,
                        shoppingBagClicked: true
                    });
                }
            }
            else {
                if (this.memberCart.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCart,
                        shoppingBagClicked: true
                    });
                }
            }
        }
    };
    /**
     * @description close modal
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.closeModal = function () {
        this.orderTypeChangeConfirmation.close();
    };
    OrderPromotionComponent.prototype.closeModalPopUp = function (status) {
        this.accountRestriction = status;
    };
    /**
     * @description
     * @date 2020-03-19
     * @private
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getParticipatingCountries = function (countryCode) {
        var _this = this;
        this._customerService.getParticipatingCountries(countryCode)
            .subscribe(function (response) {
            if (response && response.length > 0) {
                var participatingCountries = response;
                if (!_this.orderFormGroup.value.orderType || (_this.orderFormGroup.value.orderType !== _this.orderType.NEW_GUEST_RETAIL
                    && _this.orderFormGroup.value.orderType !== _this.orderType.NEW_RETAIL)) {
                    var selectedCountryID = participatingCountries.map(function (item) { return item.countryId; }).join(',');
                    _this.getMemberAddressByMemberId(_this.memberInfo.memberId, selectedCountryID);
                }
            }
        });
    };
    /**
     * check member has access to place an order
     */
    OrderPromotionComponent.prototype.checkMemberAccess = function () {
        if (this.memberInfo && this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.restrictedDays > 0) {
            var dateParts = this.memberInfo.enrolmentDate ? this.memberInfo.enrolmentDate.split('-') : this.memberInfo.createdDate.split('-');
            var enrollmentDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
            enrollmentDate.setHours(0, 0, 0, 0);
            enrollmentDate.setDate(enrollmentDate.getDate() + this.restrictedDays);
            var currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (this.isFBOValidationPending) {
                return;
            }
            if (this.upgradeFboLimitExceeded && this.isMemberFboUpgraded) {
                this.displayPurchaseLimitMessage(enrollmentDate);
                this.isMemberHasAccessToOrder = this.calculateItemsSubTotal(this.storeInfo) > 0 ? true : false;
                return;
            }
            else if (this.isMemberFboUpgraded) {
                this.isMemberHasAccessToOrder = true;
                this._commonService.removeNotification(Constants.PURCHASE_WINDOW);
            }
            else if (enrollmentDate.getTime() > currentDate.getTime() && this.memberInfo.fboId && !this.isMemberFboUpgraded) {
                var restrictPlacingOrder = true;
                if ((this.memberInfo.sponsorTransactionalSourceId == transactional.SPNC && this.countryCode && environment.skipOrderRestrictionCountriesOnSPNCTransaction.includes(this.countryCode.toUpperCase()))) {
                    restrictPlacingOrder = false;
                }
                if (restrictPlacingOrder) {
                    var nextOrderDate = moment(enrollmentDate).format(DateConstants.DateFormat);
                    var orderPlacingError = this._translatePipe.get('order.Next Order is permitted after');
                    this._commonService.createNotification('', orderPlacingError.value + nextOrderDate, NotificationType.ERROR);
                    this.isMemberHasAccessToOrder = false;
                }
            }
        }
    };
    OrderPromotionComponent.prototype.displayPurchaseLimitMessage = function (enrollmentDate) {
        var purchaseLimitExceedMessage = this._translatePipe
            .get('order.Orders should not exceed an aggregate of ||maxValue|| until ||endDate||')['value'];
        var nextOrderEligibleDate = moment(enrollmentDate).format(DateConstants.DateFormat);
        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
        purchaseLimitExceedMessage = this._translateKey.transform(purchaseLimitExceedMessage, {
            maxValue: maxValue,
            endDate: nextOrderEligibleDate
        });
        this._commonService.createNotification('', purchaseLimitExceedMessage, NotificationType.ERROR, 0, Constants.PURCHASE_WINDOW);
    };
    /**
    *
    * @param items
    */
    OrderPromotionComponent.prototype.getItemVolumeSum = function (items) {
        if (this.appConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        }
        else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    };
    OrderPromotionComponent.prototype.trackByItem = function (index) {
        return index;
    };
    /**
    * @description this method used for allow user to enter address fields
    * @memberof PersonalInfoComponent
    */
    OrderPromotionComponent.prototype.enableAddressFields = function (block) {
        var addressFieldInfo = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    };
    OrderPromotionComponent.prototype.loadPreferences = function (response) {
        var memberTypeId;
        var preferenceConfig;
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            memberTypeId = MemberTypeEnum.RETAIL;
        }
        else if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            memberTypeId = MemberTypeEnum.GUEST;
        }
        preferenceConfig = response && response.storePreferenceModels && memberTypeId ? response.storePreferenceModels.find(function (config) { return config.memberTypeId === memberTypeId; }) : null;
        if (preferenceConfig) {
            if (preferenceConfig.value === Constants.YES || preferenceConfig.value === Constants.DEFAULT) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(true);
            }
            else if (preferenceConfig.value === Constants.NO) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(false);
            }
            this.checkContactSponsor();
        }
    };
    OrderPromotionComponent.prototype.validateSubTotalBasedOnType = function (products, subTotal) {
        var isThresholdCrossed = true;
        var itemSubTotal = subTotal;
        var orderMinValue = this.orderRules.minValue;
        var orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        var hasMinValueIgnoreProduct = this._enrollmentCommonService.checkMinValueProduct(this.products, this.orderRules);
        if (itemSubTotal <= orderMinValue) {
            this.isOverrideMinimumLimit === true || hasMinValueIgnoreProduct ? isThresholdCrossed = false : isThresholdCrossed = true;
        }
        return isThresholdCrossed;
    };
    OrderPromotionComponent.prototype.isLiteratureValidation = function (products) {
        var literatureItems = this.getLiteratureItems(products);
        var isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    };
    /**
*
* @param items
*/
    OrderPromotionComponent.prototype.getItemTotalSum = function (item) {
        return this.calculateSubTotal(this.storeInfo, this.countryTaxInclusive, item, this.memberInfo, true);
    };
    /**
      * Get Total CartItems Cost.
      */
    OrderPromotionComponent.prototype.calculateSubTotal = function (store, taxInclusiveShippingCountry, item, userInfo, taxCalculated) {
        var subTotal = 0;
        if (item) {
            var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item, store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            }
            else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry, isCalculateTaxExclusivePrice, taxCalculated, userInfo);
            }
        }
        if (store) {
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    };
    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    OrderPromotionComponent.prototype.calculateSubtotalForVatAndNonVatRegisteredUser = function (item, store, taxInclusiveShippingCountry, userInfo, taxCalculated) {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                var total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            }
            else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        }
        else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice.
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
        else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
        }
    };
    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    OrderPromotionComponent.prototype.calculateItemSubtotal = function (item, store, taxInclusiveShippingCountry, isCalcTaxExclusivePrice, taxCalculated, userInfo) {
        if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            var productPrice = 'applicablePrice';
            if (userInfo && (userInfo.vatRegistered || (!userInfo.vatRegistered && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR && this.isCalculateTax))) {
                productPrice = 'catalogPrice';
            }
            return Number(item[productPrice].
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
        else {
            return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
    };
    /**
     *
     */
    OrderPromotionComponent.prototype.calculateDiscountAmount = function (item, displayPriceConfig) {
        var discountAmount = 0;
        discountAmount = (parseFloat(item.baseRetailPrice.toFixed(2)) * item.quantity) -
            (parseFloat(item.catalogPrice.toFixed(2)) * item.quantity);
        return discountAmount;
    };
    /**
  * Get Total CartItems Cost.
  */
    OrderPromotionComponent.prototype.calculateItemsSubTotal = function (store) {
        this.orderLevelDiscount = 0;
        var itemsSubTotal = 0;
        this.isBWPEnabledProduct = false;
        var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
        var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
        for (var i = 0; i < this.products.length; i++) {
            if (this.memberInfo && store.taxInclusive && isEnableVATCalculation) {
                var presentItemSubtotal = this.calculateSubtotalForVatAndNonVatRegisteredUser(this.products[i], store, this.countryTaxInclusive, this.memberInfo, true);
                itemsSubTotal += presentItemSubtotal;
                if (this.isBWPEnabled && store.bwpEnabled) {
                    var isBWPEnabledProduct = this.products[i].productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1'; });
                    if (isBWPEnabledProduct && presentItemSubtotal > 0 && this.storeInfo && this.storeInfo.bwpEnabled) {
                        this.isBWPEnabledProduct = true;
                        this.orderLevelDiscount += ((presentItemSubtotal * 5) / 100);
                    }
                }
            }
            else {
                var presentItemSubtotal = this.calculateItemSubtotal(this.products[i], store, this.countryTaxInclusive, isCalculateTaxExclusivePrice, true, this.memberInfo);
                itemsSubTotal += presentItemSubtotal;
                if (this.isBWPEnabled && store.bwpEnabled) {
                    var isBWPEnabledProduct = this.products[i].productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1'; });
                    if (isBWPEnabledProduct && presentItemSubtotal > 0 && this.storeInfo && this.storeInfo.bwpEnabled) {
                        this.isBWPEnabledProduct = true;
                        this.orderLevelDiscount += ((presentItemSubtotal * 5) / 100);
                    }
                }
            }
        }
        if (store) {
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    };
    /**
       * get member shipping discount offer
       */
    OrderPromotionComponent.prototype.getMemberShippingDiscountOffer = function (memberId) {
        var _this = this;
        this._commonService.getMemberShippingDiscountOffer(memberId, this.countryCode).subscribe(function (response) {
            if (response && response.effectiveEndDate) {
                var currentDate = new Date().setHours(0, 0, 0, 0);
                var endDate = new Date(response.effectiveEndDate.split('T')[0]).setHours(0, 0, 0, 0);
                _this.memberShippingDiscountOfferEligible = currentDate <= endDate ? true : false;
            }
            else {
                _this.memberShippingDiscountOfferEligible = false;
            }
        });
    };
    /**
    * @description this method will remove member discount offer for UK FPC second order
    * @memberof OrderSummaryNewComponent
    */
    OrderPromotionComponent.prototype.removeMemberDiscountOffer = function (memberId) {
        this._commonService.removeMemberDiscountOffer(memberId)
            .subscribe(function (response) {
        });
    };
    OrderPromotionComponent.prototype.calculateNetUnitPrice = function (product) {
        var netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    };
    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.getShippingCostForOrderSummary = function () {
        var shippingCost = +this.getOrderShippingCost() || 0;
        if (this.memberShippingDiscountOfferEligible) {
            shippingCost = 0;
        }
        else if (this.orderFormGroup.value.isShippingDiscountApplied) {
            var skipShippingTaxCalculation = (this.memberInfo && this.memberInfo.vatRegistered) || this.appConfig.skipShippingTaxCalculationInShipping;
            if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost > 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString() ||
                    this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.fourthOption.toString()
                        && this.orderFormGroup.controls['shippingCostPercentage'].value > 0)) {
                if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                    shippingCost = shippingCost;
                }
                else {
                    var shippingCostWithTax = (this.shippingCost || 0) + (this.shippingTax || 0);
                    if (this.shippingTax && !skipShippingTaxCalculation) {
                        this.isShippingTaxAddedToShippingCost = true;
                    }
                    shippingCost = skipShippingTaxCalculation ? (this.shippingCost || 0) : shippingCostWithTax;
                }
            }
            else if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost === 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                    && this.orderFormGroup.controls['shippingCostPercentage'].value === 100)) {
                shippingCost = 0;
            }
        }
        this.itemShippingCost = shippingCost;
        return shippingCost;
    };
    /**
    * @description this method will calculate tax exclusive shipping cost
    * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.getTaxExclusiveShippingCost = function () {
        var shippingCost = this.shippingCost || 0;
        if (this.memberShippingDiscountOfferEligible) {
            shippingCost = 0;
        }
        else if (this.orderFormGroup.value.isShippingDiscountApplied) {
            if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                && this.orderFormGroup.controls['shippingCostPercentage'].value === 100) {
                shippingCost = 0;
            }
        }
        return shippingCost;
    };
    /**
    * @description this method will calculate total shipping cost that includes taxes
    * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.getOrderShippingCost = function () {
        if (this.orderSession) {
            this.shippingCost = this.orderSession.shippingCost ? this.orderSession.shippingCost : this.orderSession.shippingCostValue;
            this.shippingTax = this.orderSession.shippingTax;
            this.taxCalculationStatus = this.orderSession.taxCalculationStatus;
            this.appConfig = this.appConfig ? this.appConfig : this.orderSession.appConfig;
            this.orderTaxResponse = this.orderTaxResponse ? this.orderTaxResponse : this.orderSession.orderTaxResponse;
            this.importFeeValue = this.orderSession.importFeeValue;
        }
        if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            return (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ? this.shippingCost : (this.shippingCost + this.shippingTax);
        }
        else {
            return ((this.memberInfo && this.memberInfo.vatRegistered) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) || (this.appConfig && this.appConfig.displayTaxInclusivePrice)) ? this.shippingCost : (this.shippingCost + this.shippingTax);
        }
    };
    /**
    * @description
    * @date 2020-12-11
    * @param {*} value
    * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.updateProductInCart = function (value) {
        this.updateCartProduct = value;
    };
    OrderPromotionComponent.prototype.updateMemberDetails = function (value) {
        this.updateMemberDetail = value;
    };
    /**
      * map Ach Info for payment
      */
    OrderPromotionComponent.prototype.getAchInfo = function () {
        this.achPaymentInfo = this.achPaymentInfo ? this.achPaymentInfo : this.selectedAchInfo;
        if (this.achPaymentInfo) {
            var paymentAchInfo = {
                name: this.achPaymentInfo.billingAddress.name,
                accountNumber: this.achPaymentInfo.accountNumber,
                routingNumber: this.achPaymentInfo.routingNumber,
                accountType: this.achPaymentInfo.accountType,
                mecTransactionID: '',
                nameOnBankAccount: this.achPaymentInfo.nameOnBankAccount,
                customMessage: '',
                reusable: this.achPaymentInfo.reusable,
                eCheckID: this.achPaymentInfo.id,
                email: this.achPaymentInfo.email,
                phone: this.achPaymentInfo.phone,
                secType: this.achPaymentInfo.secType,
                //dlState:this.achPaymentInfo.dlState,
                //dlNumber:this.achPaymentInfo.dlNumber,
                checkNumber: this.achPaymentInfo.checkNumber,
            };
            return paymentAchInfo;
        }
    };
    OrderPromotionComponent.prototype.getUserMemberId = function () {
        var memberId = null;
        if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
            memberId = this.accountMemberInfo.memberId;
        }
        else
            memberId = 0;
        return memberId;
    };
    /**
  * @description To get the list of bank details from payment service based on country
  * @date 2021-01-07
  * @param {*} countryCode
  * @memberof OrderPromotionComponent
  */
    OrderPromotionComponent.prototype.getBankDetailsByCountry = function (countryCode, paymentMethod) {
        var _this = this;
        this._achService.getBankDetailsByCountry(countryCode, paymentMethod).subscribe(function (response) {
            if (response && response.length > 0) {
                if (paymentMethod && PaymentMethodTypes.Wire_Transfer.toLowerCase() === paymentMethod.toLowerCase()) {
                    _this.bankDetailsCountryList = response.filter(function (bankDetail) { return bankDetail.paymentMode.toLowerCase() === PaymentMethodTypes.Wire_Transfer.toLowerCase(); });
                }
                else {
                    _this.bankDetailsCountryList = response;
                }
            }
            else {
                _this.bankDetailsCountryList = [];
            }
        });
    };
    /**
  * @description To get the order details based on sessionguid
  * @date 2021-22-01
  * @memberof OrderPromotionComponent
  */
    OrderPromotionComponent.prototype.getOrderDetailsByUuid = function (orderSessionGuid, distrubutorId) {
        var _this = this;
        if (orderSessionGuid) {
            this._orderService.getOrderDetailsUuid(orderSessionGuid, distrubutorId).subscribe(function (response) {
                if (response) {
                    if (_this.appConfig && _this.appConfig.freeShippingFPCOrder && _this.memberShippingDiscountOfferEligible) {
                        _this.removeMemberDiscountOffer(_this.memberInfo.memberId);
                    }
                    var shippingLogInfo = _this.getShippingLogInfo();
                    if (shippingLogInfo) {
                    }
                    _this.orderSuccess(response);
                    var sessionGuid = ((_this.memberCart && _this.memberCart.sessionGuid) || _this.memberCartSessionGuid);
                    if (sessionGuid && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST && _this.shoppingBagClicked) {
                        _this.deleteCart(sessionGuid);
                    }
                }
                else {
                    var notification = _this._translatePipe.get('order.Unable to Process Order.');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    _this.isSubmitted = false;
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to Process Order.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isSubmitted = false;
            });
        }
    };
    OrderPromotionComponent.prototype.mapShippingAddress = function () {
        if (this.shippingAddressInfo) {
            this.paymentComponentSettings.shippingAddressDetail = this.shippingAddressInfo;
        }
    };
    //FBo Referela Id Section
    OrderPromotionComponent.prototype.searchSponsorByFboId = function (sponsorId) {
        if ((sponsorId && sponsorId.value && sponsorId.valid)) {
            this.sponsorInformation = null;
            this.getSponsorInfoByReferralOrAutoSuggest(this.fboReferralId, true, true);
        }
    };
    OrderPromotionComponent.prototype.isEnableFboReferralId = function () {
        if ((this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL || (this.memberTypeId == MemberTypeEnum.GUEST)) && this.storeInfo && this.storeInfo.enableCspFBOReferralId && this.sponsorInformation) {
            return true;
        }
        return false;
    };
    OrderPromotionComponent.prototype.resetSponsorDetails = function () {
        this.sponsorInformation = null;
        this.fboReferralId = null;
    };
    /**
     * @description Method to get Government ID details based on country
     * @date 2021-03-31
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getGovermentIdentificationPatterns = function () {
        var _this = this;
        this._commonService.getGovermentIdentificationPatterns().subscribe(function (response) {
            if (response) {
                _this.identificationPatternByCountry = response.find(function (item) { return item.countryCode.toLowerCase() ===
                    _this.countryCode.toLowerCase(); });
                if (_this.identificationPatternByCountry && _this.identificationPatternByCountry.required) {
                    _this.fboUpgradeForm.controls['governmentId'].setValidators(Validators.required);
                    _this.fboUpgradeForm.controls['governmentId'].updateValueAndValidity();
                }
            }
        });
    };
    OrderPromotionComponent.prototype.onChange = function () {
        this.isSubmitted = false;
        this.governmentIdValidInProgress = true;
        this.fboUpgradeForm.controls['governmentId'].setValue(this.fboUpgradeForm.value.governmentId.toUpperCase());
    };
    /**
     * @description Method to search address based on name
     * @date 2021-04-19
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.searchShippingAddress = function (event) {
        this.addressSearchResult = this._commonService.searchShippingAddress(event, this.memberAddressDetails);
    };
    OrderPromotionComponent.prototype.selectBonusPaymentType = function (paymentOption) {
        this.isSelectedBonusPaymentOptionType = true;
        this.bonusPaymentOptionType = paymentOption;
        if (paymentOption === this.bonusPaymentOption.DECIDE_LATER) {
            this.bonusInformation = null;
        }
    };
    OrderPromotionComponent.prototype.setBonusInformation = function () {
        this._personalMessageService.setSubmitBonusInfoForm(true);
    };
    OrderPromotionComponent.prototype.getBonusInfo = function (bonusInformation) {
        this.bonusInformation = bonusInformation;
    };
    OrderPromotionComponent.prototype.getBonusInfoOnInputChange = function (bonusInfoFormValidated) {
        var _this = this;
        this.bonusInfoFormValidated = bonusInfoFormValidated;
        if (this.beneluxCountry) {
            this.messageService.accountNumber.subscribe(function (accountNumber) {
                _this.accountNumber = (accountNumber === undefined || accountNumber === "") ? "" : accountNumber;
                _this.disableBonusAgreement = (accountNumber === undefined || accountNumber === "") ? true : false;
                if (_this.accountNumber !== undefined || _this.accountNumber !== "") {
                    _this.bonusInfoAgreementCheckError = false;
                }
            });
        }
    };
    /**
     * @description Reteriving guest info from personal info for guest to retail update
     * @date 2021-05-26
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    OrderPromotionComponent.prototype.getGuestToRetailUsers = function (event) {
        this.guestToRetailMember = event;
    };
    OrderPromotionComponent.prototype.fetchEcheckSecTypes = function (secType) {
        if (secType === SecType.Web) {
            return 'WEB ACH';
        }
        else {
            return 'PPD ACH';
        }
    };
    /**
     * To Get Promotions based on store
     */
    OrderPromotionComponent.prototype.getStorePromotions = function (resetPromotion) {
        var _this = this;
        if (this.memberInfo && (this.orderFormGroup.get('orderType').value == this.orderType.REGULAR) && this.storeDetails) {
            if (this.memberHomeCountry && this.memberInfo.memberPreferences && this.memberInfo.memberPreferences.length > 0 && this.selectedIsoCountryCode && (this.memberHomeCountry.toUpperCase() === this.selectedIsoCountryCode.toUpperCase())) {
                var webSitelanguagePreference_1 = this.memberInfo.memberPreferences.find(function (x) { return x.preferenceId === MemberPreferencesType.PREFERREDWEBSITELANGUAGE; });
                if (webSitelanguagePreference_1) {
                    var language = this.storeDetails.languages.find(function (x) { return x.languageId === parseInt(webSitelanguagePreference_1.preferenceValue, 0); });
                    if (language) {
                        this.storeLangCultureId = parseInt(language.cultureId);
                        this.storeLanguageCultureName = language.cultureName;
                        this.storeDefaultLanguageShortCode = language.languageCode;
                    }
                }
            }
            else {
                this.storeLangCultureId = this.storeDetails.languages.find(function (languageCulture) { return languageCulture.default; }).cultureId;
                this.storeLanguageCultureName = this.storeDetails.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
                this.storeDefaultLanguageShortCode = this.storeDetails.languages.find(function (languageCulture) { return languageCulture.default; }).languageCode;
            }
        }
        this.promotionModels = [];
        var promotionrequest = {
            memberType: (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) ? MemberTypeEnum.RETAIL : (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) ? MemberTypeEnum.GUEST : (this.memberInfo && this.memberInfo.memberTypeId) ? this.memberInfo.memberTypeId : null,
            memberLevel: ((this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) || (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL)) ? null : (this.memberInfo && this.memberInfo.memberTypeId == MemberTypeEnum.DISTRIBUTOR) ? this.memberInfo.memberTitleId : null,
            orderType: PromotionOrderType.SHOP,
            distributorId: ((this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) || (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL)) ? null : (this.memberInfo && this.memberInfo.fboId) ? this.memberInfo.fboId : null,
            isTaxInclusive: this.countryTaxInclusive,
            languageSetting: this.storeLangCultureId ? this.storeLangCultureId : null
        };
        this._commonService.getPromotionEngineConfigurations(this.storeId, promotionrequest).subscribe(function (response) {
            if (response && response.promotionModelList && response.promotionModelList.length > 0) {
                _this.promotionModels = response.promotionModelList;
                if (resetPromotion && _this.orderFormGroup.get('items').length > 0) {
                    _this.reUpdateCartAndPromotion();
                }
            }
            else {
                _this.promotionModels = [];
                _this.reUpdateCartAndPromotion();
            }
        }, function (error) {
            _this.promotionModels = [];
            _this.reUpdateCartAndPromotion();
        });
    };
    /**
     * Rebind the products based promotions
     */
    OrderPromotionComponent.prototype.reUpdateCartAndPromotion = function () {
        var items = this.orderFormGroup.get('items');
        var freeProductsInfo = this.validatePromotionCriteria(items);
        var productIds = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        }
        else {
            this.updateTotalsAndShipMethod();
        }
    };
    /**
     * Validate Promotions based on all criteria
     * @param product
     * @returns
     */
    OrderPromotionComponent.prototype.validatePromotionCriteria = function (items) {
        var subTotal = this.calculateItemsSubTotal(this.storeInfo);
        var freeProductsInfo = [];
        if (this.promotionModels && this.promotionModels.length > 0) {
            this._commonService.setSubTotalAndOrderCC(subTotal, this.totalCommissionableVolume, this.countryTaxInclusive);
            this._commonService.validateOrderCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderSubTotalCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderCCCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductAtQuantityCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateMultipleProductCriteria(this.promotionModels, freeProductsInfo, items);
        }
        return this._commonService.removeDuplicates(freeProductsInfo);
        //return freeProductsInfo;
    };
    /**
     * To Get Promotion Product details and bind it to order line items
     * @param productIds
     */
    OrderPromotionComponent.prototype.addPromotionEngineProducts = function (productIds, freeProductsInfo) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        if (items && items.length >= 0) {
            var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
                ? this.memberInfo.wholeSaleQualified : false;
            var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
            var memberTitleId = this.memberInfo ? this.memberInfo.memberTitleId : MemberLevel.RETAIL;
            var purchaseFlowType = this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL
                ? PurchaseFlows.RETAIL : PurchaseFlows.PERSONAL;
            this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe(function (products) {
                if (products && products.length > 0) {
                    products.forEach(function (product) {
                        var freeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === product.id; });
                        if (items && items.length >= 0 && freeProductIndex < 0) {
                            var currentFreeProduct = freeProductsInfo.find(function (freeProduct) { return freeProduct.productId === product.id; });
                            var stockQuantity = _this._commonService.stockQuantityCheck(product, currentFreeProduct);
                            if (stockQuantity.currentFreeProductQuantity > 0) {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (currentFreeProduct.promotionId && currentFreeProduct.promotionId.length > 0) {
                                    currentFreeProduct.promotionId.forEach(function (promotionId) {
                                        if (_this.promotionIds.indexOf(promotionId) == -1) {
                                            _this.promotionIds.push(promotionId);
                                        }
                                    });
                                }
                                currentFreeProduct.quantity = stockQuantity.currentFreeProductQuantity;
                                items = _this._commonService.addPromoItem(items, index, product, environment.uiTemplateBaseUrl, environment.cdnURL);
                                var productItem = items.controls[index].controls['productItem'].value;
                                productItem.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(currentFreeProduct.quantity);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                productItem.quantity = currentFreeProduct.quantity;
                                items.controls[index].controls['productItem'].setValue(productItem);
                            }
                        }
                    });
                }
                else {
                    if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                        _this.itemLevelSearch.nativeElement.focus();
                    }
                }
                _this.itemLevelSearch.nativeElement.value = '';
                _this.updateTotalsAndShipMethod();
            });
        }
    };
    OrderPromotionComponent.prototype.getPlaceOrderButtonEnabled = function () {
        var isEnablePlaceOrder;
        isEnablePlaceOrder = !((!this.mailAlreadyExist) && !this.taxCalculationStatus
            && ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
                && this.shippingAddressInfo)
                || ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP && this.shipMethod)
                    || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP
                        && this.pudoShippingMethod && this.selectedPudoCollectionPoint)))
            && (this.products.length > 0 && this.orderFormGroup.valid &&
                (this.guestPersonalInfoFormValid || this.personalInfoFormValid) && ((this.orderFormGroup.value.orderType !== this.orderType.NEW_RETAIL) || (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL && this.sponsorInformation && this.mailingAddress))));
        return isEnablePlaceOrder ? true : false;
    };
    OrderPromotionComponent.prototype.getAddCartButtonEnabled = function () {
        var isEnablePlaceOrder;
        isEnablePlaceOrder = (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY ? !this.shippingAddressInfo : false) && !this.mailingAddress && !(this.memberInfo && this.memberInfo.address);
        return isEnablePlaceOrder ? true : false;
    };
    OrderPromotionComponent.prototype.regularOrderPlaceOrderButtonEnabled = function () {
        var isEnablePlaceOrder;
        if (!this.taxCalculationStatus && !this.minMaxPriceValidation && this.orderFormGroup.valid && this.isActive && (!this.isSubmitted)) {
            isEnablePlaceOrder = false;
        }
        else {
            isEnablePlaceOrder = true;
        }
        return isEnablePlaceOrder;
    };
    OrderPromotionComponent.prototype.fetchBonusInfoTermsAndConditions = function (countryCode, languageCode) {
        var _this = this;
        this._documentService.getDocuments(Portal.Csp, DocumentLibraryMemberId.Distributor, DisplaySectionId.Fbo_Sign_up, countryCode, languageCode)
            .subscribe(function (response) {
            if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                _this.bonusInfoAgreements = response[0].body;
                _this.bonusInfoAgreements.forEach(function (agreement) {
                    return agreement.isSelected = false;
                });
            }
            else {
                var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    OrderPromotionComponent.prototype.selectedAgreements = function (index) {
        this.bonusInfoAgreements[index].isSelected = !this.bonusInfoAgreements[index].isSelected;
        this.checkBonusInfoDocumentsSelected();
    };
    OrderPromotionComponent.prototype.checkBonusInfoDocumentsSelected = function () {
        var selectedDocuments = this.bonusInfoAgreements.filter(function (x) { return x.isSelected; });
        if (selectedDocuments && selectedDocuments.length === this.bonusInfoAgreements.length) {
            this.bonusInfoAgreementCheckError = false;
            this.formSubmitted = false;
        }
        else {
            this.bonusInfoAgreementCheckError = true;
            this.formSubmitted = false;
        }
    };
    OrderPromotionComponent.prototype.setFboBonusInformationPermissions = function (storeId) {
        this.hasFboBonusInfoViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_VIEW + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoDeletePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_DELETE + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_MANAGE + ']'), AccessLevel.Store, storeId);
    };
    OrderPromotionComponent.prototype.subscribePersistedMemberId = function () {
        var _this = this;
        this.messageService.getPersitedMemberId().subscribe(function (fboId) {
            _this.persistedMemberId = fboId;
            _this.hasPersistedMemberId = fboId ? true : false;
        });
    };
    OrderPromotionComponent.prototype.getOrderFromLookupEmit = function (value) {
        this.orderFromLookup = value;
    };
    /**
    * @description To get gbo ferferal id
    * @date 2021-08-25
    * @memberof OrderPromotionComponent
    */
    OrderPromotionComponent.prototype.getBusinessEntityByHomeCountryCode = function (homeCountryCode) {
        var _this = this;
        this._sponsorService.getBusinessEntityByHomeCountryCode(homeCountryCode).subscribe(function (response) {
            if (response) {
                _this.businessEntityDetails = response;
                if (_this.businessEntityDetails && _this.businessEntityDetails.anonymousRetailFboId) {
                    _this._commonService.anonymousSponsorSearch(_this.businessEntityDetails.anonymousRetailFboId).subscribe(function (response) {
                        if (response && response.length > 0) {
                            _this.processSearchSponsorResponse(null, _this.businessEntityDetails.anonymousRetailFboId, null, response, SponsorSearchOption.SearchByIKnowSponsor);
                        }
                        else {
                            _this.isSponsorFound = false;
                            _this.displayErrorMessage(null);
                        }
                    }, function (error) {
                        _this.isSponsorFound = false;
                        _this.displayErrorMessage(null);
                    });
                }
                else {
                    _this.getSponsorInfoByReferralOrAutoSuggest();
                }
            }
            else {
                _this.getSponsorInfoByReferralOrAutoSuggest();
            }
        });
    };
    OrderPromotionComponent.prototype.setBusinessInformation = function () {
        this._personalMessageService.setSubmitBusinessInfo(true);
    };
    OrderPromotionComponent.prototype.getBusinessInfo = function (event) {
        if (event) {
            this.businessInformation = event;
            if (this.businessInformation.isBusinessInfoValid) {
                this.validateMemberUpdateInformation(this.legalRequirements);
            }
        }
    };
    OrderPromotionComponent.prototype.getBusinessInfoOnInputChange = function (event) {
        if (event) {
            this.businessInformation = event;
        }
    };
    OrderPromotionComponent.prototype.getPodiCollectPointAddress = function () {
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoaddress = null;
            pudoaddress = this.getWarehouseAddress();
            if (this.selectedPudoCollectionPoint && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                pudoaddress.addressLine1 = this.selectedPudoCollectionPoint.street;
                pudoaddress.addressLine2 = this.selectedPudoCollectionPoint.address2;
                pudoaddress.city = this.selectedPudoCollectionPoint.city;
                pudoaddress.addressType = AddressType.PUDO;
                pudoaddress.zip = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.postalCode = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.name = this.selectedPudoCollectionPoint.name;
                pudoaddress.countryId = this.shippingAddressInfo && this.shippingAddressInfo.countryId ? this.shippingAddressInfo.countryId : this.countryID;
            }
            else if (this.selectedPudoCollectionPoint && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                pudoaddress.addressLine1 = this.selectedPudoCollectionPoint.street;
                pudoaddress.addressLine2 = this.selectedPudoCollectionPoint.address2;
                pudoaddress.city = this.selectedPudoCollectionPoint.city;
                pudoaddress.addressType = AddressType.PUDO;
                pudoaddress.zip = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.postalCode = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.name = this.selectedPudoCollectionPoint.name;
                pudoaddress.countryId = this.shippingAddressInfo && this.shippingAddressInfo.countryId ? this.shippingAddressInfo.countryId : this.countryID;
            }
            return pudoaddress;
        }
    };
    OrderPromotionComponent.prototype.buildPayByLinkForm = function () {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    };
    OrderPromotionComponent.prototype.emailCheck = function () {
        if (this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        }
        else {
            this.isPayByLinkValid = false;
        }
    };
    OrderPromotionComponent.prototype.getMailingAddress = function (address) {
        var countryObj = {};
        if (address.countryId) {
            countryObj = this.countries.filter(function (x) { return x.countryId === +address.countryId; })[0];
        }
        var mailingAddress = {
            addressLine1: address.addressLine1,
            countryCodeTwo: countryObj ? countryObj.isocodeTwo : this.selectedCountryCodeTwo,
            stateCode: address.stateCode,
            city: address.city,
            postalCode: address.postalCode,
            addressType: AddressType.MAILING
        };
        return mailingAddress;
    };
    OrderPromotionComponent.prototype.onChangeLanguage = function () {
        if (this.orderFormGroup.controls['language']) {
            this.storeLangCultureId = '';
            var cultureName_1 = this.orderFormGroup.controls['language'].value;
            var selectedLanguage = this.storeInfo.languages.find(function (language) { return language.cultureName === cultureName_1; });
            if (selectedLanguage) {
                this.getFboDocuments(cultureName_1, true);
                this.languageCulture = selectedLanguage.cultureName;
                this.payByLinkLanguageShortCode = selectedLanguage.languageCode;
                this.storeLangCultureId = +selectedLanguage.cultureId;
                this.getStorePromotions(true);
                this.isDropShipOptionExist = false;
                this.isPickUpOptionExist = false;
            }
        }
    };
    OrderPromotionComponent.prototype.savedCardInfo = function (savedcardDetails) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPopup.close();
            this.showNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                var savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }
                else {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);
                }
                this.selectedpayvisionCardInfo = savedcardDetails;
            }
        }
    };
    OrderPromotionComponent.prototype.getStorePriceTierName = function () {
        if (this.products && this.products.length > 0) {
            this.productDiscountPercentage = this.products[0].storePriceTierPercentage ? this.products[0].storePriceTierPercentage : 0;
            var priceTierId = StorerPiceTier[this.products[0].priceTierName];
            var enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.paymentComponentSettings.isoCountryCode);
            if (priceTierId) {
                this.priceTierName = this._commonService.getDiscountPriceLevel(priceTierId, this.productDiscountPercentage, this.paymentComponentSettings.memberTypeId, enableWHLSAL00ForAsstSupervisor);
            }
        }
        return this.priceTierName;
    };
    OrderPromotionComponent.prototype.getPudoDropShipPersonAddress = function (collectionPoint) {
        var address = collectionPoint;
        var dropShipAddress;
        if (collectionPoint) {
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            };
            this.pudoAddress = dropShipAddress;
            this.messageService.setPudoPersonAddress(true);
            this.dropShipAddress = dropShipAddress;
        }
        else if (this.dropLoactionSelected) {
            return this.dropShipAddress;
        }
        else if (this.orderSession && this.orderSession.pudoaddress) {
            return this.orderSession.pudoaddress;
        }
        else {
            return;
        }
    };
    OrderPromotionComponent.prototype.isRetailFreeShipping = function (shippingMethodResponse) {
        if (this.enableRetailFreeShipping && this.isRetailFreeShippingEnabledCountries() && this.isRetailORGuest() && this.isStoreParticipating()) {
            var isTotalOverRFS = this.isSubTotalReachedThresholdValue();
            var freeShippingMethod = this.shippingMethods.find(function (x) { return x.shippingMethod == RetailFreeShippingConstants.FREE_SHIPPING; });
            if (isTotalOverRFS && freeShippingMethod) {
                for (var i = 0; i < this.shippingMethods.length; i++) {
                    this.shippingMethods[i].disabledDeliveryMethods = true;
                    if (this.shippingMethods[i].shippingMethod && (this.shippingMethods[i].shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase())) {
                        this.shippingMethods[i].disabledDeliveryMethods = false;
                    }
                    if (this.shippingMethods[i].shortCode && (RetailFreeShippingConstants.ShortCode.includes(this.shippingMethods[i].shortCode.toUpperCase()))) {
                        this.shippingMethods[i].disabledDeliveryMethods = false;
                    }
                    else if (this.shippingMethods[i].freeShippingEligible) {
                        this.shippingMethods[i].disabledDeliveryMethods = false;
                    }
                }
                this.orderFormGroup.get('shipMethodId').setValue(freeShippingMethod ? freeShippingMethod.shippingMethodId : "");
                return freeShippingMethod ? freeShippingMethod : null;
            }
            else {
                var setIndex = 0;
                for (var i = 0; i < this.shippingMethods.length; i++) {
                    if (this.shippingMethods[i].shippingMethod && (this.shippingMethods[i].shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase())) {
                        this.shippingMethods[i].disabledDeliveryMethods = true;
                        if (i > 0) {
                            setIndex = 0;
                        }
                        if (i <= 0) {
                            setIndex = 1;
                        }
                        break;
                    }
                }
                var shippingMethod = this.shippingMethods[setIndex];
                this.orderFormGroup.get('shipMethodId').setValue(shippingMethod ? shippingMethod.shippingMethodId : "");
                return shippingMethod ? shippingMethod : null;
            }
        }
        return null;
    };
    OrderPromotionComponent.prototype.isRetailORGuest = function () {
        var OrderTypevalue = this.orderFormGroup && +this.orderFormGroup.get('orderType').value;
        if (OrderTypevalue && OrderTypevalue == this.orderType.NEW_GUEST_RETAIL || OrderTypevalue == this.orderType.NEW_RETAIL)
            return true;
        var isMemberRetailORGuest = this.memberInfo && (this.memberInfo.memberTypeId == this.memberTypeEnum.GUEST || this.memberInfo.memberTypeId == this.memberTypeEnum.RETAIL) ? true : false;
        if (OrderTypevalue && OrderTypevalue == this.orderType.REGULAR && isMemberRetailORGuest)
            return true;
        return false;
    };
    OrderPromotionComponent.prototype.isStoreParticipating = function () {
        if (this.storeDetails) {
            var isParticipating = this.storeDetails.retailFreeShippingParticipationType && this.storeDetails.retailFreeShippingParticipationType == this.RFSConstants.RFS_PARTICIPATING ? true : false;
            return isParticipating;
        }
        return false;
    };
    OrderPromotionComponent.prototype.isSubTotalReachedThresholdValue = function () {
        if (this.storeDetails) {
            var subTotal = this.calculateItemsSubTotal(this.storeDetails);
            if (subTotal >= this.storeDetails.retailFreeShippingTransactionAmount)
                return true;
        }
        return false;
    };
    OrderPromotionComponent.prototype.isRetailFreeShippingEnabledCountries = function () {
        var isoCountryCode = this.storeDetails && this.storeDetails.homeIsocodeThree ? this.storeDetails.homeIsocodeThree : "";
        var retailFreeShippingCountries = environment && environment.retailFreeShippingEnabledCountries ? environment.retailFreeShippingEnabledCountries.toUpperCase() : "";
        return isoCountryCode && retailFreeShippingCountries ? retailFreeShippingCountries.split(',').includes(isoCountryCode.toUpperCase()) : false;
    };
    OrderPromotionComponent.prototype.isOrderMeetsRFSCriteria = function () {
        return (this.enableRetailFreeShipping && this.isRetailFreeShippingEnabledCountries() && this.isRetailORGuest() && this.isStoreParticipating() && this.isSubTotalReachedThresholdValue());
    };
    OrderPromotionComponent.prototype.liveFormDataIsValid = function (formStatus) {
        this.liveFormStatusIsValid = formStatus;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY && this.liveFormStatusIsValid) {
            this.liveFormStatusIsValid = true;
        }
        else {
            this.liveFormStatusIsValid = false;
        }
    };
    OrderPromotionComponent.prototype.setPUDOSuggestedAddress = function () {
        var _this = this;
        this.pudoSuggestedAddressSubscription = this.messageService.getPUDOSuggestedAddress().subscribe(function (value) {
            if (value) {
                _this.buildPudoLocationSearchForm(value.zip, value.city, value.addressLine1);
                _this.getPudoLocations();
            }
        });
    };
    OrderPromotionComponent.prototype.getSponsorEligibilty = function (sponsorSearchResponse) {
        var _this = this;
        this._commonService
            .getSearchSponsorsByUUID(sponsorSearchResponse)
            .subscribe(function (sponsorEligibiltyCheckResponse) {
            if (sponsorEligibiltyCheckResponse) {
                if (_this.sponsorPollCount < _this.sponsorMaxPollCount) {
                    _this.sponsorPollCount = _this.sponsorPollCount + 1;
                    if (sponsorEligibiltyCheckResponse.requestStatus === ResponseStatus.QUEUED ||
                        sponsorEligibiltyCheckResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(function () {
                            _this.getSponsorEligibilty(sponsorEligibiltyCheckResponse);
                        }, _this.sponsorSearchTimeDelay);
                    }
                    else if (sponsorEligibiltyCheckResponse.requestStatus === ResponseStatus.FAILED) {
                        _this.isSponsorFound = false;
                        _this.displayErrorMessage(null);
                        _this.sponsorInformation = null;
                        if (_this.businessEntityDetails && _this.businessEntityDetails.anonymousRetailFboId) {
                            _this.fboReferralId = null;
                        }
                    }
                }
            }
        });
    };
    OrderPromotionComponent.prototype.ngOnDestroy = function () {
        if (this.pudoSuggestedAddressSubscription) {
            this.pudoSuggestedAddressSubscription.unsubscribe();
        }
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    };
    OrderPromotionComponent.prototype.getMembergovernmentIdentificationsInfo = function (memberId) {
        var _this = this;
        if (memberId) {
            this._customerService.getMembergovernment_identifications(memberId).subscribe(function (response) {
                if (response) {
                    _this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    _this.memberInfo.vatDetailModel = response.vatDetailModel;
                }
            });
        }
    };
    /**
     * @description To get the Payment method type based on USA country pick up location.
     * @date 2023-28-06
     * @param shippingMethod
     */
    OrderPromotionComponent.prototype.getPickupDetailsForUSA = function (shippingMethod) {
        var _this = this;
        if (shippingMethod.shippingMethod == CommonConstant.LOS_ANGELES_PRODUCT_CENTER) {
            this.storePaymentInfo.forEach(function (paymentMethod) {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                    _this.credit_Card_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    _this.money_Order_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    _this.wire_Transfer_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    _this.bank_transfer_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    _this.cash_on_delivery_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    _this.orange_money_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    _this.ach_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                    _this.direct_debit_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    _this.pay_by_link_show = false;
                }
            });
        }
        else {
            this.storePaymentInfo.forEach(function (paymentMethod) {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                    _this.credit_Card_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    _this.money_Order_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    _this.wire_Transfer_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    _this.bank_transfer_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    _this.cash_on_delivery_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    _this.orange_money_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    _this.ach_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                    _this.direct_debit_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    _this.pay_by_link_show = true;
                }
            });
        }
    };
    /**
     * @description To get the Payment method type based on USA country for delivery option.
     * @date 2023-28-06
     * @param shippingMethod
     */
    OrderPromotionComponent.prototype.getDeliveryOptionsPayment = function () {
        var _this = this;
        this.storePaymentInfo.forEach(function (paymentMethod) {
            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                _this.credit_Card_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                _this.money_Order_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                _this.wire_Transfer_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                _this.bank_transfer_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                _this.cash_on_delivery_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                _this.orange_money_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                _this.ach_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                _this.direct_debit_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                _this.pay_by_link_show = true;
            }
        });
    };
    OrderPromotionComponent.prototype.updateAutoshipProfile = function (memberId) {
        var _this = this;
        if (memberId) {
            this._orderService.getAutoShipDetailsByMemberId(memberId).subscribe(function (response) {
                if (response && response[0] && response[0].body && response[0].body.length) {
                    var optin = _this.memberInfo && _this.memberInfo.optin ? _this.memberInfo.optin : false;
                    _this._orderService.updateAutoshipProfile(memberId, MemberTypeId.DISTRIBUTOR, _this.storeInfo.taxInclusive, optin)
                        .subscribe(function (response) {
                        if (response && response.success) {
                        }
                    }, function (error) {
                        console.log(error);
                    });
                }
            }, function (error) {
                console.log(error);
            });
        }
    };
    OrderPromotionComponent.prototype.getDropShipPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    // Testing Purpose .
                    //response.shippingMethods[0].pudoEnabled = true;
                    _this.dropshipPudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                    if (mappingRequired) {
                        if (_this.dropshipPudoShippingMethod) {
                            _this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                    }
                }
            }, function (error) {
            });
        }
    };
    return OrderPromotionComponent;
}());
export { OrderPromotionComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/order-promotion.component.ts.pre-build-optimizer.js